// @ts-nocheck
import {
  GraphQLResolveInfo,
  GraphQLScalarType,
  GraphQLScalarTypeConfig,
} from 'graphql'
import { baseGraphqlApi } from '@/core/api/graphql/baseGraphqlApi.ts'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
export type RequireFields<T, K extends keyof T> = Omit<T, K> & {
  [P in K]-?: NonNullable<T[P]>
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** Generic decimal */
  Decimal: { input: any; output: any }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any }
  /** An ISO 8601-encoded datetime */
  ISO8601DateOnly: { input: any; output: any }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any }
  /** Represents untyped JSON */
  JSON: { input: any; output: any }
  /** Generic money */
  Money: { input: any; output: any }
}

/** Autogenerated return type of AcceptTerms. */
export type AcceptTermsPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<User>
}

export type Account = {
  accountProducts?: Maybe<Array<Maybe<ProductsUnion>>>
  accountProductsDigest: Scalars['String']['output']
  assistantOptOut: Scalars['Boolean']['output']
  assistantOptOutReason?: Maybe<Scalars['String']['output']>
  assistantOptedOutAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  binInventoryFeature: Scalars['Boolean']['output']
  branches?: Maybe<Array<Branch>>
  branchesCatalog: Array<Product>
  createdAt: Scalars['ISO8601DateTime']['output']
  distributorsList?: Maybe<Array<Scalars['String']['output']>>
  divisions?: Maybe<Array<Division>>
  erpCatalogs: Array<Scalars['String']['output']>
  erpOrders: Scalars['String']['output']
  hasInvoices: Scalars['Boolean']['output']
  id: Scalars['Int']['output']
  lastSync?: Maybe<AccountSyncJob>
  live: Scalars['Boolean']['output']
  logo?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  navAccountId: Scalars['String']['output']
  navAccountName: Scalars['String']['output']
  navSalesCode: Scalars['String']['output']
  orderApproveFlow: Scalars['Boolean']['output']
  ordersEnabled: Scalars['Boolean']['output']
  productsCheckoutable?: Maybe<Array<Maybe<DivisionsProduct>>>
  productsOrderable?: Maybe<Array<Maybe<AccountsProduct>>>
  salableCatalog: Array<Product>
  truckInventoryFeature: Scalars['Boolean']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
  users?: Maybe<Array<User>>
}

export type AccountBranchesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type AccountBranchesCatalogArgs = {
  branchId: Scalars['Int']['input']
  categoryCode?: InputMaybe<Scalars['String']['input']>
  textCode?: InputMaybe<Scalars['String']['input']>
  textName?: InputMaybe<Scalars['String']['input']>
}

export type AccountDivisionsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type AccountProductsCheckoutableArgs = {
  divisionId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
}

export type AccountProductsOrderableArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>
  categoryCode?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  includePlanUnavailable?: InputMaybe<Scalars['Boolean']['input']>
  term?: InputMaybe<Scalars['String']['input']>
  textCode?: InputMaybe<Scalars['String']['input']>
  textName?: InputMaybe<Scalars['String']['input']>
}

export type AccountSalableCatalogArgs = {
  branchId: Scalars['Int']['input']
  categoryCode?: InputMaybe<Scalars['String']['input']>
  textCode?: InputMaybe<Scalars['String']['input']>
  textName?: InputMaybe<Scalars['String']['input']>
}

export type AccountUsersArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>
  hasDivision?: InputMaybe<Scalars['Boolean']['input']>
  role?: InputMaybe<UserRolesEnum>
  status?: InputMaybe<Scalars['String']['input']>
  text?: InputMaybe<Scalars['String']['input']>
}

export type AccountAssignmentInput = {
  accountId: Scalars['Int']['input']
  branchIds?: InputMaybe<Array<Scalars['Int']['input']>>
}

export type AccountBase = {
  binInventoryFeature: Scalars['Boolean']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  erpCatalogs: Array<Scalars['String']['output']>
  erpOrders: Scalars['String']['output']
  hasInvoices: Scalars['Boolean']['output']
  id: Scalars['Int']['output']
  logo?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  orderApproveFlow: Scalars['Boolean']['output']
  ordersEnabled: Scalars['Boolean']['output']
  truckInventoryFeature: Scalars['Boolean']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

/** Attributes for Account */
export type AccountBaseAttributes = {
  assistantOptOut?: InputMaybe<Scalars['Boolean']['input']>
  assistantOptOutReason?: InputMaybe<Scalars['String']['input']>
  binInventoryFeature?: InputMaybe<Scalars['Boolean']['input']>
  branchTruckInventory?: InputMaybe<Array<BranchTruckInventoryInput>>
  live?: InputMaybe<Scalars['Boolean']['input']>
  orderApproveFlow?: InputMaybe<Scalars['Boolean']['input']>
  truckInventoryFeature?: InputMaybe<Scalars['Boolean']['input']>
}

/** An edge in a connection. */
export type AccountEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Account>
}

export type AccountSyncJob = {
  accountId: Scalars['Int']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  finishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['Int']['output']
  jobId: Scalars['String']['output']
  queueName?: Maybe<Scalars['String']['output']>
  startedAt: Scalars['ISO8601DateTime']['output']
  status: AccountSyncJobStatusesEnum
  syncErrors?: Maybe<Scalars['JSON']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export enum AccountSyncJobStatusesEnum {
  Failed = 'failed',
  Finished = 'finished',
  Running = 'running',
  Scheduled = 'scheduled',
}

/** Autogenerated return type of AccountUpdate. */
export type AccountUpdatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Account>
}

/** The connection type for Account. */
export type AccountWithPagination = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AccountEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Account>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalItems: Scalars['Int']['output']
}

export type AccountsProduct = {
  accountId: Scalars['Int']['output']
  branchesProduct?: Maybe<BranchesProduct>
  caseQuantity?: Maybe<Scalars['Int']['output']>
  category?: Maybe<ProductCategory>
  code: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  custom?: Maybe<Scalars['Boolean']['output']>
  description?: Maybe<Scalars['String']['output']>
  distributor?: Maybe<Scalars['String']['output']>
  erpCatalogName: Scalars['String']['output']
  group?: Maybe<ProductGroup>
  id: Scalars['Int']['output']
  kind: GenericProductKindsEnum
  name: Scalars['String']['output']
  palletQuantity?: Maybe<Scalars['Int']['output']>
  photo?: Maybe<Scalars['String']['output']>
  price?: Maybe<Scalars['Money']['output']>
  quantity?: Maybe<Scalars['String']['output']>
  /** @deprecated Use `unit` instead. */
  salesUnit: Scalars['String']['output']
  speciesIds: Array<Scalars['Int']['output']>
  stockInventory?: Maybe<Scalars['Int']['output']>
  stockState?: Maybe<Scalars['String']['output']>
  unavailable?: Maybe<Scalars['Boolean']['output']>
  unit?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
}

/** Autogenerated return type of AddPlanProduct. */
export type AddPlanProductPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<AddPlanProductResult>
}

export type AddPlanProductResult = {
  salableProductId: Scalars['Int']['output']
}

/** Autogenerated return type of AddPlanProductsFromInventory. */
export type AddPlanProductsFromInventoryPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Array<Maybe<OrderItem>>>
}

/** Autogenerated return type of AssignMultipleAccounts. */
export type AssignMultipleAccountsPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<User>
}

export type Branch = {
  account: AccountBase
  address?: Maybe<Scalars['String']['output']>
  address2?: Maybe<Scalars['String']['output']>
  binInventoryFeature: Scalars['Boolean']['output']
  cartItems?: Maybe<Array<CartItem>>
  checkoutUsers?: Maybe<Array<User>>
  checkouts?: Maybe<Array<Checkout>>
  city?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  destinationTransfers?: Maybe<Array<DestinationTransfer>>
  divisions?: Maybe<Array<Division>>
  forecasts?: Maybe<Array<Forecast>>
  id: Scalars['Int']['output']
  inboundInventories?: Maybe<Array<Maybe<InboundInventory>>>
  inventoryProducts?: Maybe<Array<Maybe<InventoryProduct>>>
  invoiceMappingRow?: Maybe<Scalars['String']['output']>
  lastSync?: Maybe<AccountSyncJob>
  locationAssignableUsers?: Maybe<Array<User>>
  managers?: Maybe<Array<User>>
  name: Scalars['String']['output']
  navId: Scalars['String']['output']
  orders?: Maybe<Array<Order>>
  plannedProducts?: Maybe<Array<Maybe<AccountsProduct>>>
  plannedProductsCount?: Maybe<Scalars['Int']['output']>
  planners?: Maybe<Array<User>>
  productTags: Array<ProductTag>
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>
  replenishmentFile?: Maybe<Scalars['String']['output']>
  sanaLoginManager?: Maybe<User>
  sanaLoginManagerId?: Maybe<Scalars['Int']['output']>
  shipToCode?: Maybe<Scalars['String']['output']>
  shipmentApproveFlow: Scalars['Boolean']['output']
  shipments?: Maybe<Array<Shipment>>
  showTechPrice: Scalars['Boolean']['output']
  state?: Maybe<Scalars['String']['output']>
  suggestedCartItems?: Maybe<Array<CartItem>>
  teams?: Maybe<Array<Team>>
  technicians?: Maybe<Array<User>>
  truckInventoryFeature: Scalars['Boolean']['output']
  untaggedProductsCount: Scalars['Int']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
  users?: Maybe<Array<User>>
  zip?: Maybe<Scalars['String']['output']>
}

export type BranchCheckoutUsersArgs = {
  checkoutManager?: InputMaybe<Scalars['Boolean']['input']>
  generalManager?: InputMaybe<Scalars['Boolean']['input']>
  hasDivision?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<Array<Scalars['String']['input']>>
  text?: InputMaybe<Scalars['String']['input']>
}

export type BranchCheckoutsArgs = {
  createdFrom?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  createdTo?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  productId?: InputMaybe<Scalars['Int']['input']>
}

export type BranchDestinationTransfersArgs = {
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  productId?: InputMaybe<Scalars['Int']['input']>
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type BranchDivisionsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type BranchForecastsArgs = {
  month?: InputMaybe<Scalars['Int']['input']>
  productId?: InputMaybe<Scalars['Int']['input']>
  year?: InputMaybe<Scalars['Int']['input']>
}

export type BranchInventoryProductsArgs = {
  categoryCode?: InputMaybe<Scalars['String']['input']>
  divisionId?: InputMaybe<Scalars['Int']['input']>
  excludeCustom?: InputMaybe<Scalars['Boolean']['input']>
  excludePlanned?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  productId?: InputMaybe<Scalars['Int']['input']>
  productTagId?: InputMaybe<Scalars['Int']['input']>
  term?: InputMaybe<Scalars['String']['input']>
  textCode?: InputMaybe<Scalars['String']['input']>
  textName?: InputMaybe<Scalars['String']['input']>
  untaggedOnly?: InputMaybe<Scalars['Boolean']['input']>
}

export type BranchManagersArgs = {
  checkoutManager?: InputMaybe<Scalars['Boolean']['input']>
  generalManager?: InputMaybe<Scalars['Boolean']['input']>
  hasDivision?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<Array<Scalars['String']['input']>>
  text?: InputMaybe<Scalars['String']['input']>
}

export type BranchOrdersArgs = {
  createdFrom?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  createdTo?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  kind?: InputMaybe<OrderKindsEnum>
  limit?: InputMaybe<Scalars['Int']['input']>
  month?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  productId?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<OrderStatusesEnum>
  statuses?: InputMaybe<Array<OrderStatusesEnum>>
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  year?: InputMaybe<Scalars['Int']['input']>
}

export type BranchPlannedProductsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
  textCode?: InputMaybe<Scalars['String']['input']>
  textName?: InputMaybe<Scalars['String']['input']>
}

export type BranchPlannersArgs = {
  hasDivision?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<Array<Scalars['String']['input']>>
  text?: InputMaybe<Scalars['String']['input']>
}

export type BranchShipmentsArgs = {
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  productId?: InputMaybe<Scalars['Int']['input']>
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

export type BranchTeamsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type BranchTechniciansArgs = {
  checkoutManager?: InputMaybe<Scalars['Boolean']['input']>
  generalManager?: InputMaybe<Scalars['Boolean']['input']>
  hasDivision?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<Array<Scalars['String']['input']>>
  text?: InputMaybe<Scalars['String']['input']>
}

export type BranchUsersArgs = {
  checkoutManager?: InputMaybe<Scalars['Boolean']['input']>
  generalManager?: InputMaybe<Scalars['Boolean']['input']>
  hasDivision?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<Array<Scalars['String']['input']>>
  text?: InputMaybe<Scalars['String']['input']>
}

export type BranchBinLocationItem = {
  inventory: Scalars['Int']['output']
  isDefault: Scalars['Boolean']['output']
  lastCycleCountAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  locationCode: Scalars['String']['output']
  locationItemId: Scalars['Int']['output']
  pendingCycleCount: Scalars['Boolean']['output']
  price: Scalars['Money']['output']
  unit: Scalars['String']['output']
  userName?: Maybe<Scalars['String']['output']>
}

/** Attributes for Branch create */
export type BranchCreateAttributes = {
  accountId: Scalars['Int']['input']
  address?: InputMaybe<Scalars['String']['input']>
  address2?: InputMaybe<Scalars['String']['input']>
  binInventoryFeature?: InputMaybe<Scalars['Boolean']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  copyDivisions?: InputMaybe<Scalars['Boolean']['input']>
  copyInventory?: InputMaybe<Scalars['Boolean']['input']>
  copyManagers?: InputMaybe<Scalars['Boolean']['input']>
  copyOrders?: InputMaybe<Scalars['Boolean']['input']>
  copyPurchaseHistory?: InputMaybe<Scalars['Boolean']['input']>
  copyReplenishmentPlan?: InputMaybe<Scalars['Boolean']['input']>
  copyTeams?: InputMaybe<Scalars['Boolean']['input']>
  invoiceMappingRow?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  navId?: InputMaybe<Scalars['String']['input']>
  replenishmentFile?: InputMaybe<Scalars['String']['input']>
  sanaLoginManagerId?: InputMaybe<Scalars['Int']['input']>
  shipToCode?: InputMaybe<Scalars['String']['input']>
  shipmentApproveFlow?: InputMaybe<Scalars['Boolean']['input']>
  showTechPrice?: InputMaybe<Scalars['Boolean']['input']>
  sourceBranchId?: InputMaybe<Scalars['Int']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  truckInventoryFeature?: InputMaybe<Scalars['Boolean']['input']>
  zip?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of BranchCreate. */
export type BranchCreatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Branch>
}

/** Autogenerated return type of BranchDelete. */
export type BranchDeletePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Branch>
}

/** Attributes for updating branch truck inventory feature */
export type BranchTruckInventoryInput = {
  binInventoryFeature?: InputMaybe<Scalars['Boolean']['input']>
  branchId: Scalars['Int']['input']
  truckInventoryFeature: Scalars['Boolean']['input']
}

/** Attributes for Branch update */
export type BranchUpdateAttributes = {
  address?: InputMaybe<Scalars['String']['input']>
  address2?: InputMaybe<Scalars['String']['input']>
  binInventoryFeature?: InputMaybe<Scalars['Boolean']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  invoiceMappingRow?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  navId?: InputMaybe<Scalars['String']['input']>
  replenishmentFile?: InputMaybe<Scalars['String']['input']>
  sanaLoginManagerId?: InputMaybe<Scalars['Int']['input']>
  shipToCode?: InputMaybe<Scalars['String']['input']>
  shipmentApproveFlow?: InputMaybe<Scalars['Boolean']['input']>
  showTechPrice: Scalars['Boolean']['input']
  state?: InputMaybe<Scalars['String']['input']>
  truckInventoryFeature?: InputMaybe<Scalars['Boolean']['input']>
  zip?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of BranchUpdate. */
export type BranchUpdatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Branch>
}

export type BranchesProduct = {
  binLocationThreshold?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['Int']['output']
  locationItems: Array<LocationItem>
  quantity: Scalars['Float']['output']
  technicianThreshold?: Maybe<Scalars['Int']['output']>
  truckLocationThreshold?: Maybe<Scalars['Int']['output']>
  unit: Scalars['String']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type BranchesSalableProduct = {
  branch: Branch
  branchId: Scalars['Int']['output']
  product: Product
  salableProductId: Scalars['Int']['output']
}

/** Attributes for Branch update */
export type CartBranchUpdateAttributes = {
  /** Flag to clear all cart items */
  clearCartItems?: InputMaybe<Scalars['Boolean']['input']>
  /** Flag to clear unavailable cart items */
  clearUnavailableCartItems?: InputMaybe<Scalars['Boolean']['input']>
  /** Flag to move suggested cart items to cart */
  moveSuggestedCartItemsToCart?: InputMaybe<Scalars['Boolean']['input']>
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of CartBranchUpdate. */
export type CartBranchUpdatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Branch>
}

export type CartItem = {
  amountPlanned?: Maybe<Scalars['Int']['output']>
  amountRequested?: Maybe<Scalars['Int']['output']>
  branchId: Scalars['Int']['output']
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  effectivePrice?: Maybe<Scalars['Money']['output']>
  effectiveUnit?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  price?: Maybe<Scalars['Money']['output']>
  product?: Maybe<Product>
  productId: Scalars['Int']['output']
  suggestion: Scalars['Boolean']['output']
  unit?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  updatedBy: User
}

/** Attributes for Order Item creation */
export type CartItemCreateAttributes = {
  amountRequested: Scalars['Int']['input']
  branchId: Scalars['ID']['input']
  productId: Scalars['ID']['input']
}

/** Autogenerated return type of CartItemCreate. */
export type CartItemCreatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<CartItem>
}

/** Attributes for updating a Order Item */
export type CartItemUpdateAttributes = {
  amountRequested?: InputMaybe<Scalars['Int']['input']>
  suggestion?: InputMaybe<Scalars['Boolean']['input']>
}

/** Autogenerated return type of CartItemUpdate. */
export type CartItemUpdatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<CartItem>
}

export type Checkout = {
  asap: Scalars['Boolean']['output']
  branchId: Scalars['Int']['output']
  checkoutItems?: Maybe<Array<CheckoutItem>>
  consumer: User
  cost?: Maybe<Scalars['Decimal']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  hasThresholdBreach: Scalars['Boolean']['output']
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
  openedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  openedBy?: Maybe<User>
  rejectReason?: Maybe<Scalars['String']['output']>
  status: CheckoutStatusesEnum
  /** @deprecated Use `consumer` instead */
  technician?: Maybe<User>
  totalItems?: Maybe<Scalars['Int']['output']>
  totalUnits?: Maybe<Scalars['Int']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
  updatedBy: User
}

export enum CheckoutActionsEnum {
  Completed = 'completed',
  Open = 'open',
}

/** Attributes for Checkout */
export type CheckoutAttributes = {
  action?: InputMaybe<CheckoutActionsEnum>
  asap?: InputMaybe<Scalars['Boolean']['input']>
  branchId?: InputMaybe<Scalars['Int']['input']>
  checkoutItems?: InputMaybe<Array<CheckoutItemBaseAttributes>>
  consumerId?: InputMaybe<Scalars['Int']['input']>
}

/** Attributes for Checkout rejection */
export type CheckoutCancelAttributes = {
  rejectReason?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of CheckoutCancel. */
export type CheckoutCancelPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Checkout>
}

/** Autogenerated return type of CheckoutComplete. */
export type CheckoutCompletePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Checkout>
}

/** Autogenerated return type of CheckoutCreate. */
export type CheckoutCreatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Checkout>
}

export type CheckoutItem = {
  amountRequested?: Maybe<Scalars['Int']['output']>
  checkoutId: Scalars['Int']['output']
  cost: Scalars['Money']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  depletions: Array<CheckoutItemDepletion>
  id: Scalars['Int']['output']
  isOverThreshold: Scalars['Boolean']['output']
  monthlyQuantityUsed?: Maybe<Scalars['Int']['output']>
  overBy?: Maybe<Scalars['Int']['output']>
  price: Scalars['Money']['output']
  product: Product
  productId: Scalars['Int']['output']
  technicianThreshold?: Maybe<Scalars['Int']['output']>
  unit: Scalars['String']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

/** Base attributes for Checkout Item creation */
export type CheckoutItemBaseAttributes = {
  amountRequested: Scalars['Int']['input']
  productId: Scalars['Int']['input']
}

/** Attributes for Checkout Item creation */
export type CheckoutItemCreateAttributes = {
  amountRequested: Scalars['Int']['input']
  checkoutId: Scalars['Int']['input']
  productId: Scalars['Int']['input']
}

/** Autogenerated return type of CheckoutItemCreate. */
export type CheckoutItemCreatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<CheckoutItem>
}

export type CheckoutItemDepletion = {
  amount: Scalars['Int']['output']
  locationCode: Scalars['String']['output']
  userName?: Maybe<Scalars['String']['output']>
}

export type CheckoutItemDepletionInput = {
  amount: Scalars['Int']['input']
  locationItemId: Scalars['ID']['input']
}

/** Autogenerated return type of CheckoutItemRemove. */
export type CheckoutItemRemovePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  /** ID of removed Checkout Item */
  result?: Maybe<Scalars['Int']['output']>
}

/** Attributes for Checkout Item update */
export type CheckoutItemUpdateAttributes = {
  amountRequested: Scalars['Int']['input']
}

/** Autogenerated return type of CheckoutItemUpdate. */
export type CheckoutItemUpdatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<CheckoutItem>
}

/** Autogenerated return type of CheckoutRecall. */
export type CheckoutRecallPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Checkout>
}

/** Autogenerated return type of CheckoutRemove. */
export type CheckoutRemovePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Scalars['Int']['output']>
}

/** Autogenerated return type of CheckoutReopen. */
export type CheckoutReopenPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Checkout>
}

export enum CheckoutStatusesEnum {
  Canceled = 'canceled',
  Completed = 'completed',
  Draft = 'draft',
  Open = 'open',
}

/** Autogenerated return type of CheckoutSubmit. */
export type CheckoutSubmitPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Checkout>
}

export type CycleCount = {
  account: Account
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  completedBy?: Maybe<User>
  countedAmount: Scalars['Int']['output']
  countedAt: Scalars['ISO8601DateTime']['output']
  countedBy: User
  createdAt: Scalars['ISO8601DateTime']['output']
  cycleCountItems: Array<CycleCountItem>
  id: Scalars['Int']['output']
  location: Location
  locationAmount: Scalars['Int']['output']
  rejectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  rejectedBy?: Maybe<User>
  status: Scalars['String']['output']
  totalVariancePrice: Scalars['Float']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
  variance: Scalars['Int']['output']
}

export type CycleCountCycleCountItemsArgs = {
  status?: InputMaybe<CycleCountItemStatusesEnum>
}

/** Attributes for CycleCount creation */
export type CycleCountCreateAttributes = {
  items: Array<CycleCountItemCreateAttributes>
  locationId: Scalars['Int']['input']
  status?: InputMaybe<CycleCountStatusesEnum>
}

/** Autogenerated return type of CycleCountCreate. */
export type CycleCountCreatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<CycleCount>
}

export type CycleCountItem = {
  countedAmount: Scalars['Int']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  cycleCount: CycleCount
  id: Scalars['Int']['output']
  locationAmount: Scalars['Int']['output']
  locationItem: LocationItem
  price: Scalars['Money']['output']
  product: Product
  status: Scalars['String']['output']
  totalVariancePrice: Scalars['Float']['output']
  unit: Scalars['String']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
  variance: Scalars['Int']['output']
}

/** Attributes for CycleCountItem creation */
export type CycleCountItemCreateAttributes = {
  countedAmount: Scalars['Int']['input']
  locationItemId: Scalars['Int']['input']
  status?: InputMaybe<CycleCountItemStatusesEnum>
}

export enum CycleCountItemStatusesEnum {
  Approved = 'approved',
  Pending = 'pending',
  Rejected = 'rejected',
}

/** Attributes for CycleCountItem update */
export type CycleCountItemUpdateAttributes = {
  countedAmount: Scalars['Int']['input']
  id: Scalars['Int']['input']
}

/** Autogenerated return type of CycleCountItemsUpdate. */
export type CycleCountItemsUpdatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Array<CycleCountItem>>
}

/** Autogenerated return type of CycleCountRecount. */
export type CycleCountRecountPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<CycleCount>
}

export enum CycleCountStatusesEnum {
  Completed = 'completed',
  Pending = 'pending',
  Rejected = 'rejected',
}

/** Attributes for CycleCount update */
export type CycleCountUpdateAttributes = {
  status?: InputMaybe<CycleCountStatusesEnum>
}

/** Autogenerated return type of CycleCountUpdate. */
export type CycleCountUpdatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<CycleCount>
}

export type DestinationTransfer = {
  approvedAmount?: Maybe<Scalars['Int']['output']>
  approvedAt?: Maybe<Scalars['ISO8601Date']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  currentInventory: Scalars['Int']['output']
  destinationAmount: Scalars['Int']['output']
  destinationPrice?: Maybe<Scalars['Money']['output']>
  destinationUnit?: Maybe<Scalars['String']['output']>
  hasProduct: Scalars['Boolean']['output']
  id: Scalars['Int']['output']
  product?: Maybe<Product>
  productId: Scalars['Int']['output']
  sourceAuthorName: Scalars['String']['output']
  sourceBranchName: Scalars['String']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type Division = {
  branchId: Scalars['Int']['output']
  /** @deprecated Use `inventory_products` with filter by branch instead */
  checkoutableProducts?: Maybe<Array<Maybe<DivisionsProduct>>>
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['Int']['output']
  inventoryProducts?: Maybe<Array<Maybe<InventoryProduct>>>
  name: Scalars['String']['output']
  /** @deprecated Use `inventory_products` with filter by branch instead */
  products?: Maybe<Array<Maybe<DivisionsProduct>>>
  technicians?: Maybe<Array<User>>
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type DivisionInventoryProductsArgs = {
  branchIds: Array<Scalars['Int']['input']>
}

/** Attributes for Division */
export type DivisionBaseAttributes = {
  name?: InputMaybe<Scalars['String']['input']>
}

/** Attributes for Division creation */
export type DivisionCreateAttributes = {
  branchId: Scalars['Int']['input']
  name?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of DivisionCreate. */
export type DivisionCreatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Division>
}

/** Autogenerated return type of DivisionRemove. */
export type DivisionRemovePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  /** ID of removed Division */
  result?: Maybe<Scalars['Int']['output']>
}

/** Autogenerated return type of DivisionUpdate. */
export type DivisionUpdatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Division>
}

export type DivisionsProduct = {
  accountId: Scalars['Int']['output']
  branchesProduct?: Maybe<BranchesProduct>
  caseQuantity?: Maybe<Scalars['Int']['output']>
  category?: Maybe<ProductCategory>
  code: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  custom?: Maybe<Scalars['Boolean']['output']>
  description?: Maybe<Scalars['String']['output']>
  distributor?: Maybe<Scalars['String']['output']>
  erpCatalogName: Scalars['String']['output']
  group?: Maybe<ProductGroup>
  id: Scalars['Int']['output']
  kind: GenericProductKindsEnum
  name: Scalars['String']['output']
  palletQuantity?: Maybe<Scalars['Int']['output']>
  photo?: Maybe<Scalars['String']['output']>
  price?: Maybe<Scalars['Money']['output']>
  quantity?: Maybe<Scalars['String']['output']>
  /** @deprecated Use `unit` instead. */
  salesUnit: Scalars['String']['output']
  speciesIds: Array<Scalars['Int']['output']>
  stockInventory?: Maybe<Scalars['Int']['output']>
  stockState?: Maybe<Scalars['String']['output']>
  unavailable?: Maybe<Scalars['Boolean']['output']>
  unit?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
}

/** Autogenerated return type of EnsureBranch. */
export type EnsureBranchPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Branch>
}

export type Forecast = {
  amountMaxSuggested: Scalars['Int']['output']
  amountMinSuggested: Scalars['Int']['output']
  amountSuggested: Scalars['Int']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['Int']['output']
  month: Scalars['Int']['output']
  productId: Scalars['Int']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
  year: Scalars['Int']['output']
}

/** Autogenerated return type of GenerateAppLoginToken. */
export type GenerateAppLoginTokenPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  token?: Maybe<Scalars['String']['output']>
}

export type GenericProduct = {
  accountId: Scalars['Int']['output']
  branchesProduct?: Maybe<BranchesProduct>
  caseQuantity?: Maybe<Scalars['Int']['output']>
  category?: Maybe<ProductCategory>
  code: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  custom?: Maybe<Scalars['Boolean']['output']>
  description?: Maybe<Scalars['String']['output']>
  distributor?: Maybe<Scalars['String']['output']>
  erpCatalogName: Scalars['String']['output']
  group?: Maybe<ProductGroup>
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
  palletQuantity?: Maybe<Scalars['Int']['output']>
  photo?: Maybe<Scalars['String']['output']>
  price?: Maybe<Scalars['Money']['output']>
  quantity?: Maybe<Scalars['String']['output']>
  /** @deprecated Use `unit` instead. */
  salesUnit: Scalars['String']['output']
  speciesIds: Array<Scalars['Int']['output']>
  stockInventory?: Maybe<Scalars['Int']['output']>
  stockState?: Maybe<Scalars['String']['output']>
  unavailable?: Maybe<Scalars['Boolean']['output']>
  unit?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export enum GenericProductKindsEnum {
  Checkoutable = 'checkoutable',
  Salable = 'salable',
}

/** Autogenerated return type of ImpersonateUser. */
export type ImpersonateUserPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  token?: Maybe<Scalars['String']['output']>
}

/** Attributes for Inbound Invenotry */
export type InboundApproveAttributes = {
  approvingAmount: Scalars['Int']['input']
  shipmentId?: InputMaybe<Scalars['ID']['input']>
  transferId?: InputMaybe<Scalars['ID']['input']>
}

export type InboundInventory = {
  acctounId: Scalars['Int']['output']
  approvedAmount?: Maybe<Scalars['Int']['output']>
  approvedItemsCount: Scalars['Int']['output']
  branchId: Scalars['Int']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['Int']['output']
  invoiceDate?: Maybe<Scalars['ISO8601Date']['output']>
  itemsCount: Scalars['Int']['output']
  navId: Scalars['String']['output']
  navOriginalOrderId?: Maybe<Scalars['String']['output']>
  recordType: Scalars['String']['output']
  shipments?: Maybe<Array<Maybe<Shipment>>>
  totalAmount: Scalars['Float']['output']
  totalPrice?: Maybe<Scalars['Float']['output']>
  transfers?: Maybe<Array<Maybe<DestinationTransfer>>>
  updatedAt: Scalars['ISO8601DateTime']['output']
}

/** Autogenerated return type of InboundInventoryApprove. */
export type InboundInventoryApprovePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<InboundInventory>
}

export type InventoryEvent = {
  additional: Scalars['JSON']['output']
  amount: Scalars['Int']['output']
  /** stock_value when it is the branch total, not a bin or truck figure */
  branchStockValue?: Maybe<Scalars['Float']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  createdByUser?: Maybe<User>
  eventCreatedAt: Scalars['ISO8601DateTime']['output']
  eventType: Scalars['String']['output']
  id: Scalars['Int']['output']
  locationId?: Maybe<Scalars['Int']['output']>
  stockValue: Scalars['Float']['output']
  unit: Scalars['String']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

/** An edge in a connection. */
export type InventoryEventEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<InventoryEvent>
}

export enum InventoryEventTypesEnum {
  Checkout = 'checkout',
  CycleCount = 'cycle_count',
  Manual = 'manual',
  MoveIn = 'move_in',
  MoveOut = 'move_out',
  Shipment = 'shipment',
  TransferFrom = 'transfer_from',
  TransferTo = 'transfer_to',
}

/** The connection type for InventoryEvent. */
export type InventoryEventWithPagination = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InventoryEventEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<InventoryEvent>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalItems: Scalars['Int']['output']
}

export type InventoryProduct = {
  binLocationThreshold?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  divisions?: Maybe<Array<Maybe<Division>>>
  id: Scalars['Int']['output']
  inventory: Scalars['Int']['output']
  inventoryEvents?: Maybe<InventoryEventWithPagination>
  locationItems: Array<LocationItem>
  lockToken: Scalars['String']['output']
  notifyThreshold?: Maybe<Scalars['Boolean']['output']>
  originalProductData?: Maybe<SalableProductData>
  price?: Maybe<Scalars['Decimal']['output']>
  priceVisible: Scalars['Boolean']['output']
  product: Product
  productTags: Array<ProductTag>
  quantity?: Maybe<Scalars['Int']['output']>
  technicianThreshold?: Maybe<Scalars['Int']['output']>
  threshold?: Maybe<Scalars['Int']['output']>
  truckLocationThreshold?: Maybe<Scalars['Int']['output']>
  unit?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type InventoryProductInventoryEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  eventTypes?: InputMaybe<Array<InventoryEventTypesEnum>>
  first?: InputMaybe<Scalars['Int']['input']>
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  throughEventId?: InputMaybe<Scalars['Int']['input']>
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

/** Attributes for Inventory Product creation */
export type InventoryProductCreateAttributes = {
  blobSignedId?: InputMaybe<Scalars['String']['input']>
  branchId: Scalars['Int']['input']
  deletePhoto?: InputMaybe<Scalars['Boolean']['input']>
  distributor?: InputMaybe<Scalars['String']['input']>
  divisionIds?: InputMaybe<Array<Scalars['Int']['input']>>
  inventory?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  newProductTag?: InputMaybe<NewProductTagInput>
  notifyThreshold?: InputMaybe<Scalars['Boolean']['input']>
  price?: InputMaybe<Scalars['Decimal']['input']>
  productCode: Scalars['String']['input']
  productTagIds?: InputMaybe<Array<Scalars['Int']['input']>>
  quantity: Scalars['Int']['input']
  threshold?: InputMaybe<Scalars['Int']['input']>
  unit: Scalars['String']['input']
}

/** Autogenerated return type of InventoryProductCreate. */
export type InventoryProductCreatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<InventoryProduct>
}

/** Autogenerated return type of InventoryProductRemove. */
export type InventoryProductRemovePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  /** Product ID of removed Inventory Product */
  result?: Maybe<Scalars['Int']['output']>
}

/** Attributes for Inventory Product transfer */
export type InventoryProductTransferAttributes = {
  destinationAmount: Scalars['Int']['input']
  sourceAmount: Scalars['Int']['input']
  sourceLocationId?: InputMaybe<Scalars['Int']['input']>
  sourceLocationIds?: InputMaybe<Array<Scalars['Int']['input']>>
}

/** Autogenerated return type of InventoryProductTransfer. */
export type InventoryProductTransferPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<InventoryProduct>
}

/** Attributes for Inventory Product update */
export type InventoryProductUpdateAttributes = {
  binLocationThreshold?: InputMaybe<Scalars['Int']['input']>
  blobSignedId?: InputMaybe<Scalars['String']['input']>
  deletePhoto?: InputMaybe<Scalars['Boolean']['input']>
  distributor?: InputMaybe<Scalars['String']['input']>
  divisionIds?: InputMaybe<Array<Scalars['Int']['input']>>
  inventory?: InputMaybe<Scalars['Int']['input']>
  locationItemsAttributes?: InputMaybe<Array<LocationItemUpdateAttributes>>
  name?: InputMaybe<Scalars['String']['input']>
  newProductTag?: InputMaybe<NewProductTagInput>
  notifyThreshold?: InputMaybe<Scalars['Boolean']['input']>
  price?: InputMaybe<Scalars['Decimal']['input']>
  productTagIds?: InputMaybe<Array<Scalars['Int']['input']>>
  quantity: Scalars['Int']['input']
  reason?: InputMaybe<Scalars['String']['input']>
  technicianThreshold?: InputMaybe<Scalars['Int']['input']>
  threshold?: InputMaybe<Scalars['Int']['input']>
  truckLocationThreshold?: InputMaybe<Scalars['Int']['input']>
  unit: Scalars['String']['input']
}

/** Autogenerated return type of InventoryProductUpdate. */
export type InventoryProductUpdatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<InventoryProduct>
}

/** Autogenerated return type of LoadAccountsCsv. */
export type LoadAccountsCsvPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Array<Maybe<Account>>>
}

/** Autogenerated return type of LoadBranchesCsv. */
export type LoadBranchesCsvPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Array<Maybe<Branch>>>
}

/** Autogenerated return type of LoadDivisionProductsCsv. */
export type LoadDivisionProductsCsvPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Array<Maybe<GenericProduct>>>
}

/** Autogenerated return type of LoadLocationsCsv. */
export type LoadLocationsCsvPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Array<Maybe<Location>>>
}

/** Autogenerated return type of LoadShipmentsCsv. */
export type LoadShipmentsCsvPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  success?: Maybe<Scalars['Boolean']['output']>
}

/** Autogenerated return type of LoadUsersCsv. */
export type LoadUsersCsvPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
}

export type Location = {
  accountId: Scalars['Int']['output']
  branches: Array<Branch>
  code: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  cycleCountDue: Scalars['Boolean']['output']
  cycleCountFrequencyDays?: Maybe<Scalars['Int']['output']>
  cycleCountStartDate?: Maybe<Scalars['ISO8601Date']['output']>
  description?: Maybe<Scalars['String']['output']>
  hasCycleCounts: Scalars['Boolean']['output']
  id: Scalars['Int']['output']
  isDefault: Scalars['Boolean']['output']
  latestCycleCount?: Maybe<CycleCount>
  latestMove?: Maybe<Move>
  locationItems: Array<LocationItem>
  locationType: Scalars['String']['output']
  lowStockLocationItems: Array<LocationItem>
  nextCycleCountDate?: Maybe<Scalars['ISO8601Date']['output']>
  openProcess?: Maybe<OpenProcessEnum>
  products: Array<Product>
  totalValue: Scalars['Float']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
  updatedBy?: Maybe<User>
  user?: Maybe<User>
}

/** Attributes for Location creation */
export type LocationCreateAttributes = {
  accountId: Scalars['Int']['input']
  branchIds?: InputMaybe<Array<Scalars['Int']['input']>>
  code: Scalars['String']['input']
  cycleCountFrequencyDays?: InputMaybe<Scalars['Int']['input']>
  cycleCountStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  locationType?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['Int']['input']>
}

/** Autogenerated return type of LocationCreate. */
export type LocationCreatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Location>
}

/** Autogenerated return type of LocationDelete. */
export type LocationDeletePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Scalars['Int']['output']>
}

export type LocationItem = {
  branchProductThreshold?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  id: Scalars['Int']['output']
  inventory: Scalars['Int']['output']
  location: Location
  locationId: Scalars['Int']['output']
  price: Scalars['Money']['output']
  product: Product
  productId: Scalars['Int']['output']
  threshold?: Maybe<Scalars['Int']['output']>
  unit: Scalars['String']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
  updatedBy?: Maybe<User>
}

export type LocationItemBranchProductThresholdArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>
}

/** Attributes for Location Item creation */
export type LocationItemCreateAttributes = {
  inventory: Scalars['Int']['input']
  locationId: Scalars['ID']['input']
  price: Scalars['Decimal']['input']
  productId: Scalars['ID']['input']
  unit: Scalars['String']['input']
}

/** Autogenerated return type of LocationItemCreate. */
export type LocationItemCreatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<LocationItem>
}

/** Autogenerated return type of LocationItemDelete. */
export type LocationItemDeletePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<LocationItem>
}

/** Attributes for Location Item update */
export type LocationItemUpdateAttributes = {
  id?: InputMaybe<Scalars['Int']['input']>
  inventory?: InputMaybe<Scalars['Int']['input']>
  reason?: InputMaybe<Scalars['String']['input']>
  threshold?: InputMaybe<Scalars['Int']['input']>
}

/** Autogenerated return type of LocationItemUpdate. */
export type LocationItemUpdatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<LocationItem>
}

/** Attributes for Location update */
export type LocationUpdateAttributes = {
  accountId: Scalars['Int']['input']
  branchIds?: InputMaybe<Array<Scalars['Int']['input']>>
  code?: InputMaybe<Scalars['String']['input']>
  cycleCountFrequencyDays?: InputMaybe<Scalars['Int']['input']>
  cycleCountStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  locationType?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['Int']['input']>
}

/** Autogenerated return type of LocationUpdate. */
export type LocationUpdatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Location>
}

/** Attributes for Manager */
export type ManagerAttributes = {
  branchIds?: InputMaybe<Array<Scalars['Int']['input']>>
  checkoutManager?: InputMaybe<Scalars['Boolean']['input']>
  generalManager?: InputMaybe<Scalars['Boolean']['input']>
  teamIds?: InputMaybe<Array<Scalars['Int']['input']>>
}

/** Autogenerated return type of ManagerUpdate. */
export type ManagerUpdatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
}

export type Message = {
  archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  content: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['Int']['output']
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  read: Scalars['Boolean']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

/** Autogenerated return type of MessageArchive. */
export type MessageArchivePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Message>
}

/** Autogenerated return type of MessageMarkRead. */
export type MessageMarkReadPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<MessageRead>
}

/** Autogenerated return type of MessagePublish. */
export type MessagePublishPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Message>
}

export type MessageRead = {
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['Int']['output']
  message: Message
  readAt: Scalars['ISO8601DateTime']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
  user: User
}

/** Autogenerated return type of MessageUpdate. */
export type MessageUpdatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Message>
}

export type Move = {
  account: Account
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  canceledBy?: Maybe<User>
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  completedBy?: Maybe<User>
  createdAt: Scalars['ISO8601DateTime']['output']
  fromLocation: Location
  id: Scalars['Int']['output']
  locationAmount: Scalars['Int']['output']
  moveItems: Array<MoveItem>
  movedAmount: Scalars['Int']['output']
  movedAt: Scalars['ISO8601DateTime']['output']
  movedBy: User
  rejectReason?: Maybe<Scalars['String']['output']>
  rejectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  rejectedBy?: Maybe<User>
  status: MoveStatusesEnum
  toBranch?: Maybe<Branch>
  toLocation?: Maybe<Location>
  updatedAt: Scalars['ISO8601DateTime']['output']
}

/** Attributes for Move creation */
export type MoveCreateAttributes = {
  items: Array<MoveItemCreateAttributes>
  movedFromLocationId: Scalars['Int']['input']
  movedToBranchId?: InputMaybe<Scalars['Int']['input']>
  movedToLocationId?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<MoveStatusesEnum>
}

/** Autogenerated return type of MoveCreate. */
export type MoveCreatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Move>
}

export type MoveItem = {
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['Int']['output']
  locationAmount: Scalars['Int']['output']
  locationItem: LocationItem
  move: Move
  movedAmount: Scalars['Int']['output']
  price: Scalars['Money']['output']
  product: Product
  toLocation?: Maybe<Location>
  unit: Scalars['String']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

/** Attributes for MoveItem creation */
export type MoveItemCreateAttributes = {
  locationItemId: Scalars['Int']['input']
  movedAmount: Scalars['Int']['input']
  toLocationId?: InputMaybe<Scalars['Int']['input']>
}

export enum MoveStatusesEnum {
  Canceled = 'canceled',
  Completed = 'completed',
  Pending = 'pending',
  Rejected = 'rejected',
}

/** Attributes for Move update */
export type MoveUpdateAttributes = {
  id: Scalars['Int']['input']
  items?: InputMaybe<Array<MoveItemCreateAttributes>>
  rejectReason?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<MoveStatusesEnum>
}

/** Autogenerated return type of MoveUpdate. */
export type MoveUpdatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Move>
}

export type Mutation = {
  acceptTerms?: Maybe<AcceptTermsPayload>
  accountUpdate?: Maybe<AccountUpdatePayload>
  addPlanProduct?: Maybe<AddPlanProductPayload>
  addPlanProductsFromInventory?: Maybe<AddPlanProductsFromInventoryPayload>
  assignMultipleAccounts?: Maybe<AssignMultipleAccountsPayload>
  branchCreate?: Maybe<BranchCreatePayload>
  branchDelete?: Maybe<BranchDeletePayload>
  branchUpdate?: Maybe<BranchUpdatePayload>
  cartBranchUpdate?: Maybe<CartBranchUpdatePayload>
  cartItemCreate?: Maybe<CartItemCreatePayload>
  cartItemUpdate?: Maybe<CartItemUpdatePayload>
  checkoutCancel?: Maybe<CheckoutCancelPayload>
  checkoutComplete?: Maybe<CheckoutCompletePayload>
  checkoutCreate?: Maybe<CheckoutCreatePayload>
  checkoutItemCreate?: Maybe<CheckoutItemCreatePayload>
  checkoutItemRemove?: Maybe<CheckoutItemRemovePayload>
  checkoutItemUpdate?: Maybe<CheckoutItemUpdatePayload>
  checkoutRecall?: Maybe<CheckoutRecallPayload>
  checkoutRemove?: Maybe<CheckoutRemovePayload>
  checkoutReopen?: Maybe<CheckoutReopenPayload>
  checkoutSubmit?: Maybe<CheckoutSubmitPayload>
  cycleCountCreate?: Maybe<CycleCountCreatePayload>
  cycleCountItemsUpdate?: Maybe<CycleCountItemsUpdatePayload>
  cycleCountRecount?: Maybe<CycleCountRecountPayload>
  cycleCountUpdate?: Maybe<CycleCountUpdatePayload>
  divisionCreate?: Maybe<DivisionCreatePayload>
  divisionRemove?: Maybe<DivisionRemovePayload>
  divisionUpdate?: Maybe<DivisionUpdatePayload>
  /** @deprecated Keep for backward compatibility with old mobile app versions */
  ensureBranch?: Maybe<EnsureBranchPayload>
  generateAppLoginToken?: Maybe<GenerateAppLoginTokenPayload>
  impersonateUser?: Maybe<ImpersonateUserPayload>
  inboundInventoryApprove?: Maybe<InboundInventoryApprovePayload>
  inventoryProductCreate?: Maybe<InventoryProductCreatePayload>
  inventoryProductRemove?: Maybe<InventoryProductRemovePayload>
  inventoryProductTransfer?: Maybe<InventoryProductTransferPayload>
  inventoryProductUpdate?: Maybe<InventoryProductUpdatePayload>
  loadAccountsCsv?: Maybe<LoadAccountsCsvPayload>
  loadBranchesCsv?: Maybe<LoadBranchesCsvPayload>
  loadDivisionProductsCsv?: Maybe<LoadDivisionProductsCsvPayload>
  loadLocationsCsv?: Maybe<LoadLocationsCsvPayload>
  loadShipmentsCsv?: Maybe<LoadShipmentsCsvPayload>
  loadUsersCsv?: Maybe<LoadUsersCsvPayload>
  locationCreate?: Maybe<LocationCreatePayload>
  locationDelete?: Maybe<LocationDeletePayload>
  locationItemCreate?: Maybe<LocationItemCreatePayload>
  locationItemDelete?: Maybe<LocationItemDeletePayload>
  locationItemUpdate?: Maybe<LocationItemUpdatePayload>
  locationUpdate?: Maybe<LocationUpdatePayload>
  managerUpdate?: Maybe<ManagerUpdatePayload>
  messageArchive?: Maybe<MessageArchivePayload>
  messageMarkRead?: Maybe<MessageMarkReadPayload>
  messagePublish?: Maybe<MessagePublishPayload>
  messageUpdate?: Maybe<MessageUpdatePayload>
  moveCreate?: Maybe<MoveCreatePayload>
  moveUpdate?: Maybe<MoveUpdatePayload>
  navInvoiceIgnore?: Maybe<NavInvoiceIgnorePayload>
  navInvoiceMap?: Maybe<NavInvoiceMapPayload>
  orderApprove?: Maybe<OrderApprovePayload>
  orderItemCreate?: Maybe<OrderItemCreatePayload>
  orderItemUpdate?: Maybe<OrderItemUpdatePayload>
  orderReject?: Maybe<OrderRejectPayload>
  orderRequest?: Maybe<OrderRequestPayload>
  orderRequestFromCart?: Maybe<OrderRequestFromCartPayload>
  orderRequestTrackingInfo?: Maybe<OrderRequestTrackingInfoPayload>
  orderSubmit?: Maybe<OrderSubmitPayload>
  orderSubmitFromCart?: Maybe<OrderSubmitFromCartPayload>
  orderUpdate?: Maybe<OrderUpdatePayload>
  productTagCreate?: Maybe<ProductTagCreatePayload>
  productTagDelete?: Maybe<ProductTagDeletePayload>
  productTagUpdate?: Maybe<ProductTagUpdatePayload>
  removeBranchesSalableProduct?: Maybe<RemoveBranchesSalableProductPayload>
  removePlanProduct?: Maybe<RemovePlanProductPayload>
  replenishmentPlanItemSpecify?: Maybe<ReplenishmentPlanItemSpecifyPayload>
  replenishmentPlanProductReplace?: Maybe<ReplenishmentPlanProductReplacePayload>
  sanaPasswordRotate?: Maybe<SanaPasswordRotatePayload>
  sanaPasswordSetManual?: Maybe<SanaPasswordSetManualPayload>
  scheduleAccountSync?: Maybe<ScheduleAccountSyncPayload>
  scheduleBranchSync?: Maybe<ScheduleBranchSyncPayload>
  scheduleProductsUpdate?: Maybe<ScheduleProductsUpdatePayload>
  speciesSetGroup?: Maybe<SpeciesSetGroupPayload>
  teamCreate?: Maybe<TeamCreatePayload>
  teamRemove?: Maybe<TeamRemovePayload>
  teamUpdate?: Maybe<TeamUpdatePayload>
  technicianCreate?: Maybe<TechnicianCreatePayload>
  technicianMove?: Maybe<TechnicianMovePayload>
  technicianRemove?: Maybe<TechnicianRemovePayload>
  technicianUpdate?: Maybe<TechnicianUpdatePayload>
  updateDeviceInfo?: Maybe<UpdateDeviceInfoPayload>
  userAttachAvatar?: Maybe<UserAttachAvatarPayload>
  userCreate?: Maybe<UserCreatePayload>
  userMove?: Maybe<UserMovePayload>
  userReassignAccount?: Maybe<UserReassignAccountPayload>
  userSetBranches?: Maybe<UserSetBranchesPayload>
  userUpdate?: Maybe<UserUpdatePayload>
}

export type MutationAccountUpdateArgs = {
  attributes: AccountBaseAttributes
  id: Scalars['Int']['input']
}

export type MutationAddPlanProductArgs = {
  branchId: Scalars['Int']['input']
  productId: Scalars['Int']['input']
}

export type MutationAddPlanProductsFromInventoryArgs = {
  branchId: Scalars['Int']['input']
  productIds: Array<Scalars['Int']['input']>
}

export type MutationAssignMultipleAccountsArgs = {
  accountAssignments: Array<AccountAssignmentInput>
  userId: Scalars['Int']['input']
}

export type MutationBranchCreateArgs = {
  attributes: BranchCreateAttributes
}

export type MutationBranchDeleteArgs = {
  id: Scalars['Int']['input']
}

export type MutationBranchUpdateArgs = {
  attributes: BranchUpdateAttributes
  id: Scalars['Int']['input']
}

export type MutationCartBranchUpdateArgs = {
  attributes: CartBranchUpdateAttributes
  id: Scalars['Int']['input']
}

export type MutationCartItemCreateArgs = {
  attributes: CartItemCreateAttributes
}

export type MutationCartItemUpdateArgs = {
  attributes: CartItemUpdateAttributes
  id: Scalars['Int']['input']
}

export type MutationCheckoutCancelArgs = {
  attributes?: InputMaybe<CheckoutCancelAttributes>
  id: Scalars['Int']['input']
}

export type MutationCheckoutCompleteArgs = {
  depletionInstructions?: InputMaybe<Array<CheckoutItemDepletionInput>>
  id: Scalars['Int']['input']
}

export type MutationCheckoutCreateArgs = {
  attributes: CheckoutAttributes
}

export type MutationCheckoutItemCreateArgs = {
  attributes: CheckoutItemCreateAttributes
}

export type MutationCheckoutItemRemoveArgs = {
  id: Scalars['Int']['input']
}

export type MutationCheckoutItemUpdateArgs = {
  attributes: CheckoutItemUpdateAttributes
  id: Scalars['Int']['input']
}

export type MutationCheckoutRecallArgs = {
  id: Scalars['Int']['input']
}

export type MutationCheckoutRemoveArgs = {
  id: Scalars['Int']['input']
}

export type MutationCheckoutReopenArgs = {
  id: Scalars['Int']['input']
}

export type MutationCheckoutSubmitArgs = {
  attributes?: InputMaybe<CheckoutAttributes>
  id: Scalars['Int']['input']
}

export type MutationCycleCountCreateArgs = {
  attributes: CycleCountCreateAttributes
}

export type MutationCycleCountItemsUpdateArgs = {
  cycleCountId: Scalars['Int']['input']
  ids: Array<Scalars['Int']['input']>
  status: CycleCountItemStatusesEnum
}

export type MutationCycleCountRecountArgs = {
  id: Scalars['Int']['input']
  items: Array<CycleCountItemUpdateAttributes>
}

export type MutationCycleCountUpdateArgs = {
  attributes: CycleCountUpdateAttributes
  id: Scalars['Int']['input']
}

export type MutationDivisionCreateArgs = {
  attributes: DivisionCreateAttributes
}

export type MutationDivisionRemoveArgs = {
  id: Scalars['Int']['input']
}

export type MutationDivisionUpdateArgs = {
  attributes: DivisionBaseAttributes
  id: Scalars['Int']['input']
}

export type MutationEnsureBranchArgs = {
  id: Scalars['Int']['input']
}

export type MutationGenerateAppLoginTokenArgs = {
  userId: Scalars['Int']['input']
}

export type MutationImpersonateUserArgs = {
  navId?: InputMaybe<Scalars['String']['input']>
  userId?: InputMaybe<Scalars['Int']['input']>
}

export type MutationInboundInventoryApproveArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['Int']['input']
  inboundData: Array<InboundApproveAttributes>
}

export type MutationInventoryProductCreateArgs = {
  attributes: InventoryProductCreateAttributes
}

export type MutationInventoryProductRemoveArgs = {
  branchId: Scalars['Int']['input']
  productId: Scalars['Int']['input']
}

export type MutationInventoryProductTransferArgs = {
  attributes: InventoryProductTransferAttributes
  destinationBranchId: Scalars['Int']['input']
  productCode: Scalars['String']['input']
  sourceBranchId: Scalars['Int']['input']
}

export type MutationInventoryProductUpdateArgs = {
  attributes: InventoryProductUpdateAttributes
  branchId: Scalars['Int']['input']
  lockToken?: InputMaybe<Scalars['String']['input']>
  productId: Scalars['Int']['input']
}

export type MutationLoadBranchesCsvArgs = {
  accountId: Scalars['String']['input']
}

export type MutationLoadDivisionProductsCsvArgs = {
  branchId: Scalars['String']['input']
}

export type MutationLoadLocationsCsvArgs = {
  accountId: Scalars['String']['input']
  branchId: Scalars['String']['input']
}

export type MutationLoadShipmentsCsvArgs = {
  accountId: Scalars['String']['input']
  erpCatalog?: InputMaybe<Scalars['String']['input']>
}

export type MutationLoadUsersCsvArgs = {
  accountId: Scalars['String']['input']
}

export type MutationLocationCreateArgs = {
  attributes: LocationCreateAttributes
}

export type MutationLocationDeleteArgs = {
  id: Scalars['Int']['input']
}

export type MutationLocationItemCreateArgs = {
  attributes: LocationItemCreateAttributes
}

export type MutationLocationItemDeleteArgs = {
  id: Scalars['ID']['input']
}

export type MutationLocationItemUpdateArgs = {
  attributes: LocationItemUpdateAttributes
  id: Scalars['Int']['input']
}

export type MutationLocationUpdateArgs = {
  attributes: LocationUpdateAttributes
  id: Scalars['Int']['input']
}

export type MutationManagerUpdateArgs = {
  attributes: ManagerAttributes
  branchId?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['Int']['input']
}

export type MutationMessageArchiveArgs = {
  id: Scalars['Int']['input']
}

export type MutationMessageMarkReadArgs = {
  id: Scalars['Int']['input']
}

export type MutationMessagePublishArgs = {
  content: Scalars['String']['input']
}

export type MutationMessageUpdateArgs = {
  content: Scalars['String']['input']
  id: Scalars['Int']['input']
}

export type MutationMoveCreateArgs = {
  attributes: MoveCreateAttributes
}

export type MutationMoveUpdateArgs = {
  attributes: MoveUpdateAttributes
}

export type MutationNavInvoiceIgnoreArgs = {
  id: Scalars['Int']['input']
}

export type MutationNavInvoiceMapArgs = {
  branchId: Scalars['Int']['input']
  id: Scalars['Int']['input']
  process: Scalars['Boolean']['input']
}

export type MutationOrderApproveArgs = {
  id: Scalars['Int']['input']
}

export type MutationOrderItemCreateArgs = {
  attributes: OrderItemCreateAttributes
}

export type MutationOrderItemUpdateArgs = {
  attributes: OrderItemUpdateAttributes
  id: Scalars['Int']['input']
}

export type MutationOrderRejectArgs = {
  attributes?: InputMaybe<OrderRejectAttributes>
  id: Scalars['Int']['input']
}

export type MutationOrderRequestArgs = {
  id: Scalars['Int']['input']
}

export type MutationOrderRequestFromCartArgs = {
  branchId: Scalars['Int']['input']
}

export type MutationOrderRequestTrackingInfoArgs = {
  id: Scalars['Int']['input']
}

export type MutationOrderSubmitArgs = {
  id: Scalars['Int']['input']
}

export type MutationOrderSubmitFromCartArgs = {
  branchId: Scalars['Int']['input']
}

export type MutationOrderUpdateArgs = {
  attributes: OrderUpdateAttributes
  id: Scalars['Int']['input']
}

export type MutationProductTagCreateArgs = {
  branchId: Scalars['Int']['input']
  color: Scalars['String']['input']
  name: Scalars['String']['input']
}

export type MutationProductTagDeleteArgs = {
  id: Scalars['Int']['input']
}

export type MutationProductTagUpdateArgs = {
  color?: InputMaybe<Scalars['String']['input']>
  id: Scalars['Int']['input']
  name?: InputMaybe<Scalars['String']['input']>
}

export type MutationRemoveBranchesSalableProductArgs = {
  branchId: Scalars['Int']['input']
  productId?: InputMaybe<Scalars['Int']['input']>
  salableProductId: Scalars['Int']['input']
}

export type MutationRemovePlanProductArgs = {
  branchId: Scalars['Int']['input']
  productId: Scalars['Int']['input']
}

export type MutationReplenishmentPlanItemSpecifyArgs = {
  amount: Scalars['Int']['input']
  branchId: Scalars['Int']['input']
  month: Scalars['String']['input']
  productId: Scalars['Int']['input']
}

export type MutationReplenishmentPlanProductReplaceArgs = {
  branchId: Scalars['Int']['input']
  newProductId: Scalars['Int']['input']
  oldProductId: Scalars['Int']['input']
}

export type MutationSanaPasswordRotateArgs = {
  managerId: Scalars['Int']['input']
}

export type MutationSanaPasswordSetManualArgs = {
  managerId: Scalars['Int']['input']
  newPassword: Scalars['String']['input']
}

export type MutationScheduleAccountSyncArgs = {
  accountId: Scalars['Int']['input']
}

export type MutationScheduleBranchSyncArgs = {
  branchId: Scalars['Int']['input']
}

export type MutationScheduleProductsUpdateArgs = {
  accountId: Scalars['Int']['input']
}

export type MutationSpeciesSetGroupArgs = {
  group: Scalars['String']['input']
  id: Scalars['Int']['input']
}

export type MutationTeamCreateArgs = {
  attributes: TeamCreateAttributes
}

export type MutationTeamRemoveArgs = {
  id: Scalars['Int']['input']
}

export type MutationTeamUpdateArgs = {
  attributes: TeamBaseAttributes
  id: Scalars['Int']['input']
}

export type MutationTechnicianCreateArgs = {
  attributes: TechnicianCreateAttributes
}

export type MutationTechnicianMoveArgs = {
  branchIds: Array<Scalars['Int']['input']>
  id: Scalars['Int']['input']
}

export type MutationTechnicianRemoveArgs = {
  id: Scalars['Int']['input']
}

export type MutationTechnicianUpdateArgs = {
  attributes: TechnicianAttributes
  id: Scalars['Int']['input']
}

export type MutationUpdateDeviceInfoArgs = {
  deviceInfo: Scalars['JSON']['input']
}

export type MutationUserAttachAvatarArgs = {
  id: Scalars['String']['input']
}

export type MutationUserCreateArgs = {
  attributes: UserCreateAttributes
}

export type MutationUserMoveArgs = {
  branchIds: Array<Scalars['Int']['input']>
  id: Scalars['Int']['input']
}

export type MutationUserReassignAccountArgs = {
  accountId: Scalars['Int']['input']
  id: Scalars['Int']['input']
}

export type MutationUserSetBranchesArgs = {
  branches: Array<InputMaybe<Scalars['Int']['input']>>
  id: Scalars['Int']['input']
}

export type MutationUserUpdateArgs = {
  attributes: UserAttributes
  id: Scalars['Int']['input']
}

export type NavInvoice = {
  accountName?: Maybe<Scalars['String']['output']>
  actedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  actedByName?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['Int']['output']
  invoiceDate: Scalars['ISO8601Date']['output']
  invoiceNumber: Scalars['String']['output']
  lastError?: Maybe<Scalars['String']['output']>
  manualBranch?: Maybe<Branch>
  navAccountId: Scalars['String']['output']
  navBranchId: Scalars['String']['output']
  pendingReason?: Maybe<Scalars['String']['output']>
  status: NavInvoiceStatusesEnum
  totalPrice: Scalars['Float']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type NavInvoiceCounts = {
  branch: Scalars['Int']['output']
  pending: Scalars['Int']['output']
  processing: Scalars['Int']['output']
  shippingAgent: Scalars['Int']['output']
}

/** An edge in a connection. */
export type NavInvoiceEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<NavInvoice>
}

export enum NavInvoiceErrorSubjectsEnum {
  Branch = 'branch',
  /** No processing attempt has failed yet */
  Pending = 'pending',
  Processing = 'processing',
  ShippingAgent = 'shipping_agent',
}

/** Autogenerated return type of NavInvoiceIgnore. */
export type NavInvoiceIgnorePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<NavInvoice>
}

/** Autogenerated return type of NavInvoiceMap. */
export type NavInvoiceMapPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<NavInvoice>
}

export enum NavInvoiceStatusesEnum {
  Error = 'error',
  Ignored = 'ignored',
  Mapped = 'mapped',
  Pending = 'pending',
  Processed = 'processed',
  Skipped = 'skipped',
}

/** The connection type for NavInvoice. */
export type NavInvoiceWithPagination = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NavInvoiceEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<NavInvoice>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalItems: Scalars['Int']['output']
}

export type NewProductTagInput = {
  color: Scalars['String']['input']
  name: Scalars['String']['input']
}

export enum OpenProcessEnum {
  /** Location user has an open checkout */
  Checkout = 'CHECKOUT',
  /** Location has a pending cycle count */
  CycleCount = 'CYCLE_COUNT',
  /** Location has a pending move */
  Move = 'MOVE',
}

export type Order = {
  account: Account
  approveDueDateAt?: Maybe<Scalars['ISO8601DateOnly']['output']>
  approvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  approvedBy?: Maybe<User>
  autoSubmitted?: Maybe<Scalars['Boolean']['output']>
  blockedReason?: Maybe<Scalars['String']['output']>
  branch: Branch
  cost?: Maybe<Scalars['Money']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  createdBy?: Maybe<User>
  dueDateAt?: Maybe<Scalars['ISO8601DateOnly']['output']>
  erpCatalogName: Scalars['String']['output']
  id: Scalars['Int']['output']
  kind: Scalars['String']['output']
  month?: Maybe<Scalars['Int']['output']>
  name?: Maybe<Scalars['String']['output']>
  navOrderId?: Maybe<Scalars['String']['output']>
  navReferenceId?: Maybe<Scalars['String']['output']>
  orderItems?: Maybe<Array<OrderItem>>
  orderTrackingStatuses?: Maybe<Array<OrderTrackingStatus>>
  processingStatus: Scalars['String']['output']
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>
  rejectReason?: Maybe<Scalars['String']['output']>
  rejectedAt?: Maybe<Scalars['ISO8601DateOnly']['output']>
  rejectedBy?: Maybe<User>
  requestedAt?: Maybe<Scalars['ISO8601DateOnly']['output']>
  requestedBy?: Maybe<User>
  shipmentDateAt?: Maybe<Scalars['ISO8601DateOnly']['output']>
  skipReminder: Scalars['Boolean']['output']
  status: Scalars['String']['output']
  submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  submittedBy?: Maybe<User>
  unit?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
  updatedBy?: Maybe<User>
  year?: Maybe<Scalars['Int']['output']>
}

/** Autogenerated return type of OrderApprove. */
export type OrderApprovePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Order>
}

export type OrderDetailed = {
  account: Account
  approveDueDateAt?: Maybe<Scalars['ISO8601DateOnly']['output']>
  approvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  approvedBy?: Maybe<User>
  autoSubmitted?: Maybe<Scalars['Boolean']['output']>
  blockedReason?: Maybe<Scalars['String']['output']>
  branch: Branch
  cost?: Maybe<Scalars['Money']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  createdBy?: Maybe<User>
  dueDateAt?: Maybe<Scalars['ISO8601DateOnly']['output']>
  erpCatalogName: Scalars['String']['output']
  id: Scalars['Int']['output']
  kind: Scalars['String']['output']
  month?: Maybe<Scalars['Int']['output']>
  name?: Maybe<Scalars['String']['output']>
  navCsv?: Maybe<Scalars['String']['output']>
  navOrderId?: Maybe<Scalars['String']['output']>
  navReferenceId?: Maybe<Scalars['String']['output']>
  orderItems?: Maybe<Array<OrderItem>>
  orderTrackingStatuses?: Maybe<Array<OrderTrackingStatus>>
  processingStatus: Scalars['String']['output']
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>
  rejectReason?: Maybe<Scalars['String']['output']>
  rejectedAt?: Maybe<Scalars['ISO8601DateOnly']['output']>
  rejectedBy?: Maybe<User>
  requestedAt?: Maybe<Scalars['ISO8601DateOnly']['output']>
  requestedBy?: Maybe<User>
  shipmentDateAt?: Maybe<Scalars['ISO8601DateOnly']['output']>
  skipReminder: Scalars['Boolean']['output']
  status: Scalars['String']['output']
  submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  submittedBy?: Maybe<User>
  unit?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
  updatedBy?: Maybe<User>
  year?: Maybe<Scalars['Int']['output']>
}

export type OrderDetailedNavCsvArgs = {
  colSep?: InputMaybe<Scalars['String']['input']>
  forceQuotes?: InputMaybe<Scalars['Boolean']['input']>
  rowSep?: InputMaybe<Scalars['String']['input']>
}

/** An edge in a connection. */
export type OrderEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<Order>
}

export type OrderItem = {
  /** @deprecated No need anymore */
  amountOverridden: Scalars['Boolean']['output']
  amountRequested?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  effectivePrice?: Maybe<Scalars['Money']['output']>
  effectiveUnit?: Maybe<Scalars['String']['output']>
  forecast?: Maybe<Forecast>
  id: Scalars['Int']['output']
  orderId: Scalars['Int']['output']
  price?: Maybe<Scalars['Money']['output']>
  product: Product
  unit?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
  updatedBy: User
}

/** Attributes for Order Item creation */
export type OrderItemCreateAttributes = {
  amountRequested: Scalars['Int']['input']
  orderId: Scalars['ID']['input']
  productId: Scalars['ID']['input']
}

/** Autogenerated return type of OrderItemCreate. */
export type OrderItemCreatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<OrderItem>
}

/** Attributes for updating a Order Item */
export type OrderItemUpdateAttributes = {
  /** @deprecated No need anymore */
  amountOverridden?: InputMaybe<Scalars['Boolean']['input']>
  amountRequested?: InputMaybe<Scalars['Int']['input']>
}

/** Autogenerated return type of OrderItemUpdate. */
export type OrderItemUpdatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<OrderItem>
}

export enum OrderKindsEnum {
  FillIn = 'fill_in',
  Generic = 'generic',
  Replenish = 'replenish',
}

/** Attributes for Order rejection */
export type OrderRejectAttributes = {
  rejectReason?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of OrderReject. */
export type OrderRejectPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Order>
}

/** Autogenerated return type of OrderRequestFromCart. */
export type OrderRequestFromCartPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Order>
}

/** Autogenerated return type of OrderRequest. */
export type OrderRequestPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Order>
}

/** Autogenerated return type of OrderRequestTrackingInfo. */
export type OrderRequestTrackingInfoPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
}

export enum OrderScopesEnum {
  AllApproval = 'all_approval',
  Manageable = 'manageable',
  PendingApproval = 'pending_approval',
  Submitted = 'submitted',
}

export enum OrderStatusesEnum {
  Approved = 'approved',
  Delayed = 'delayed',
  Open = 'open',
  Rejected = 'rejected',
  Requested = 'requested',
  Skipped = 'skipped',
  Submitted = 'submitted',
}

/** Autogenerated return type of OrderSubmitFromCart. */
export type OrderSubmitFromCartPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Order>
}

/** Autogenerated return type of OrderSubmit. */
export type OrderSubmitPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Order>
}

export type OrderTrackingStatus = {
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['Int']['output']
  navId?: Maybe<Scalars['String']['output']>
  shippedAt?: Maybe<Scalars['ISO8601Date']['output']>
  shippingAgent?: Maybe<Scalars['String']['output']>
  soNumber?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  trackingNumber?: Maybe<Scalars['String']['output']>
  trackingUrl?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
}

/** Attributes for Order update */
export type OrderUpdateAttributes = {
  clearAllItems?: InputMaybe<Scalars['Boolean']['input']>
  clearUnavailableItems?: InputMaybe<Scalars['Boolean']['input']>
  navReferenceId?: InputMaybe<Scalars['String']['input']>
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>
  skipReminder?: InputMaybe<Scalars['Boolean']['input']>
}

/** Autogenerated return type of OrderUpdate. */
export type OrderUpdatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Order>
}

/** The connection type for Order. */
export type OrderWithPagination = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrderEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Order>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalItems: Scalars['Int']['output']
}

export type OrdersStats = {
  count: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output']
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>
}

export type PlanItem = {
  amount?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['Int']['output']
  month: Scalars['Int']['output']
  productId: Scalars['Int']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
  year: Scalars['Int']['output']
}

export type Product = {
  caseQuantity?: Maybe<Scalars['Int']['output']>
  category?: Maybe<ProductCategory>
  code: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  custom?: Maybe<Scalars['Boolean']['output']>
  description?: Maybe<Scalars['String']['output']>
  distributor?: Maybe<Scalars['String']['output']>
  erpCatalogName: Scalars['String']['output']
  group?: Maybe<ProductGroup>
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
  palletQuantity?: Maybe<Scalars['Int']['output']>
  photo?: Maybe<Scalars['String']['output']>
  price?: Maybe<Scalars['Decimal']['output']>
  priceVisible: Scalars['Boolean']['output']
  /** @deprecated Use `unit` instead. */
  salesUnit: Scalars['String']['output']
  speciesIds: Array<Scalars['Int']['output']>
  stockInventory?: Maybe<Scalars['Int']['output']>
  stockState?: Maybe<Scalars['String']['output']>
  unavailable?: Maybe<Scalars['Boolean']['output']>
  unit?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type ProductCategory = {
  code: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type ProductGroup = {
  code: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type ProductTag = {
  color: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  productsCount: Scalars['Int']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

/** Autogenerated return type of ProductTagCreate. */
export type ProductTagCreatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<ProductTag>
}

/** Autogenerated return type of ProductTagDelete. */
export type ProductTagDeletePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<ProductTag>
}

/** Autogenerated return type of ProductTagUpdate. */
export type ProductTagUpdatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<ProductTag>
}

export type ProductsUnion = AccountsProduct

/** The query root of this schema */
export type Query = {
  accounts?: Maybe<AccountWithPagination>
  branchBinLocationItems: Array<BranchBinLocationItem>
  cycleCount?: Maybe<CycleCount>
  cycleCounts?: Maybe<Array<CycleCount>>
  forecasts: Array<Forecast>
  internal?: Maybe<User>
  location?: Maybe<Location>
  locations?: Maybe<Array<Location>>
  locationsCsv?: Maybe<Scalars['String']['output']>
  manager?: Maybe<User>
  me?: Maybe<User>
  mobileUser?: Maybe<User>
  move?: Maybe<Move>
  moves?: Maybe<Array<Move>>
  planItems: Array<PlanItem>
  planSpecies: Array<Species>
  planner?: Maybe<User>
  productsOrderable?: Maybe<Array<Maybe<AccountsProduct>>>
  publishedMessage?: Maybe<Message>
  replenishmentPlan?: Maybe<Array<BranchesSalableProduct>>
  replenishmentPlanExports?: Maybe<Array<ReplenishmentPlanExport>>
  shipments: Array<Shipment>
  species: Array<Species>
  submittedItems: Array<SubmittedItem>
  technician?: Maybe<User>
}

/** The query root of this schema */
export type QueryAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  text?: InputMaybe<Scalars['String']['input']>
}

/** The query root of this schema */
export type QueryBranchBinLocationItemsArgs = {
  branchId: Scalars['Int']['input']
  productId: Scalars['Int']['input']
}

/** The query root of this schema */
export type QueryCycleCountArgs = {
  id: Scalars['Int']['input']
}

/** The query root of this schema */
export type QueryCycleCountsArgs = {
  accountId: Scalars['Int']['input']
  branchId?: InputMaybe<Scalars['Int']['input']>
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  locationId?: InputMaybe<Scalars['Int']['input']>
  statuses?: InputMaybe<Array<CycleCountStatusesEnum>>
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

/** The query root of this schema */
export type QueryForecastsArgs = {
  branchId: Scalars['Int']['input']
  fromMonth?: InputMaybe<Scalars['String']['input']>
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>
  toMonth?: InputMaybe<Scalars['String']['input']>
}

/** The query root of this schema */
export type QueryLocationArgs = {
  id: Scalars['Int']['input']
}

/** The query root of this schema */
export type QueryLocationsArgs = {
  accountId: Scalars['Int']['input']
  branchId?: InputMaybe<Scalars['Int']['input']>
}

/** The query root of this schema */
export type QueryLocationsCsvArgs = {
  accountId: Scalars['Int']['input']
  branchId?: InputMaybe<Scalars['Int']['input']>
}

/** The query root of this schema */
export type QueryMoveArgs = {
  id: Scalars['Int']['input']
}

/** The query root of this schema */
export type QueryMovesArgs = {
  accountId: Scalars['Int']['input']
  branchId?: InputMaybe<Scalars['Int']['input']>
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  locationId?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<MoveStatusesEnum>
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

/** The query root of this schema */
export type QueryPlanItemsArgs = {
  branchId: Scalars['Int']['input']
  fromMonth?: InputMaybe<Scalars['String']['input']>
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>
  toMonth?: InputMaybe<Scalars['String']['input']>
}

/** The query root of this schema */
export type QueryProductsOrderableArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>
  categoryCode?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  includePlanUnavailable?: InputMaybe<Scalars['Boolean']['input']>
  term?: InputMaybe<Scalars['String']['input']>
  textCode?: InputMaybe<Scalars['String']['input']>
  textName?: InputMaybe<Scalars['String']['input']>
}

/** The query root of this schema */
export type QueryReplenishmentPlanArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>
}

/** The query root of this schema */
export type QueryReplenishmentPlanExportsArgs = {
  from?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  to?: InputMaybe<Scalars['ISO8601DateTime']['input']>
}

/** The query root of this schema */
export type QueryShipmentsArgs = {
  branchId: Scalars['Int']['input']
  fromMonth?: InputMaybe<Scalars['String']['input']>
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>
  toMonth?: InputMaybe<Scalars['String']['input']>
}

/** The query root of this schema */
export type QuerySubmittedItemsArgs = {
  branchId: Scalars['Int']['input']
  fromMonth?: InputMaybe<Scalars['String']['input']>
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>
  toMonth?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of RemoveBranchesSalableProduct. */
export type RemoveBranchesSalableProductPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Message>
}

/** Autogenerated return type of RemovePlanProduct. */
export type RemovePlanProductPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Array<Maybe<RemovedOrderItem>>>
}

export type RemovedOrderItem = {
  id: Scalars['Int']['output']
  orderId: Scalars['Int']['output']
  productId: Scalars['Int']['output']
}

export type ReplenishmentPlanExport = {
  createdAt: Scalars['ISO8601DateTime']['output']
  file: Scalars['String']['output']
  id: Scalars['Int']['output']
  navId: Scalars['String']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

/** Autogenerated return type of ReplenishmentPlanItemSpecify. */
export type ReplenishmentPlanItemSpecifyPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<PlanItem>
}

/** Autogenerated return type of ReplenishmentPlanProductReplace. */
export type ReplenishmentPlanProductReplacePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<BranchesSalableProduct>
}

export type SalableProductData = {
  price?: Maybe<Scalars['Money']['output']>
  unit?: Maybe<Scalars['String']['output']>
}

/** Autogenerated return type of SanaPasswordRotate. */
export type SanaPasswordRotatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
}

/** Autogenerated return type of SanaPasswordSetManual. */
export type SanaPasswordSetManualPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
}

/** Autogenerated return type of ScheduleAccountSync. */
export type ScheduleAccountSyncPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<AccountSyncJob>
}

/** Autogenerated return type of ScheduleBranchSync. */
export type ScheduleBranchSyncPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<AccountSyncJob>
}

/** Autogenerated return type of ScheduleProductsUpdate. */
export type ScheduleProductsUpdatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Scalars['String']['output']>
}

export type Shipment = {
  amount: Scalars['Int']['output']
  approvedAmount?: Maybe<Scalars['Int']['output']>
  approvedAt?: Maybe<Scalars['ISO8601Date']['output']>
  createdAt: Scalars['ISO8601DateTime']['output']
  currentInventory: Scalars['Int']['output']
  date?: Maybe<Scalars['ISO8601Date']['output']>
  hasProduct: Scalars['Boolean']['output']
  id: Scalars['Int']['output']
  product?: Maybe<ShippedProduct>
  productId: Scalars['Int']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type ShippedProduct = {
  caseQuantity?: Maybe<Scalars['Int']['output']>
  category?: Maybe<ProductCategory>
  code: Scalars['String']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  custom?: Maybe<Scalars['Boolean']['output']>
  description?: Maybe<Scalars['String']['output']>
  distributor?: Maybe<Scalars['String']['output']>
  erpCatalogName: Scalars['String']['output']
  group?: Maybe<ProductGroup>
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
  palletQuantity?: Maybe<Scalars['Int']['output']>
  photo?: Maybe<Scalars['String']['output']>
  price?: Maybe<Scalars['Money']['output']>
  /** @deprecated Use `unit` instead. */
  salesUnit: Scalars['String']['output']
  speciesIds: Array<Scalars['Int']['output']>
  stockInventory?: Maybe<Scalars['Int']['output']>
  stockState?: Maybe<Scalars['String']['output']>
  unavailable?: Maybe<Scalars['Boolean']['output']>
  unit?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type Species = {
  createdAt: Scalars['ISO8601DateTime']['output']
  group?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
  productsForshaw: Scalars['Int']['output']
  productsFrs: Scalars['Int']['output']
  sanaId: Scalars['Int']['output']
  updatedAt: Scalars['ISO8601DateTime']['output']
}

/** Autogenerated return type of SpeciesSetGroup. */
export type SpeciesSetGroupPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Species>
}

export type SubmittedItem = {
  amount: Scalars['Int']['output']
  month: Scalars['String']['output']
  productId: Scalars['Int']['output']
}

export type Team = {
  branchId: Scalars['Int']['output']
  createdAt: Scalars['ISO8601DateTime']['output']
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
  technicians?: Maybe<Array<User>>
  updatedAt: Scalars['ISO8601DateTime']['output']
}

/** Attributes for Team */
export type TeamBaseAttributes = {
  name?: InputMaybe<Scalars['String']['input']>
}

/** Attributes for Team creation */
export type TeamCreateAttributes = {
  branchId: Scalars['Int']['input']
  name?: InputMaybe<Scalars['String']['input']>
}

/** Autogenerated return type of TeamCreate. */
export type TeamCreatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Team>
}

/** Autogenerated return type of TeamRemove. */
export type TeamRemovePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  /** ID of removed Team */
  result?: Maybe<Scalars['Int']['output']>
}

/** Autogenerated return type of TeamUpdate. */
export type TeamUpdatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<Team>
}

/** Attributes for Technician */
export type TechnicianAttributes = {
  binCount?: InputMaybe<Scalars['Boolean']['input']>
  branchIds?: InputMaybe<Array<Scalars['Int']['input']>>
  checkoutManager?: InputMaybe<Scalars['Boolean']['input']>
  divisionIds?: InputMaybe<Array<Scalars['Int']['input']>>
  email?: InputMaybe<Scalars['String']['input']>
  emailInboundInventoryApproval?: InputMaybe<Scalars['Boolean']['input']>
  emailLowStockWarning?: InputMaybe<Scalars['Boolean']['input']>
  emailOrderApprovalRequest?: InputMaybe<Scalars['Boolean']['input']>
  emailReplenishmentPlanReminder?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  password?: InputMaybe<Scalars['String']['input']>
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>
  resetPasswordSentAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  role?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  teamIds?: InputMaybe<Array<Scalars['Int']['input']>>
}

/** Attributes for Technician creation */
export type TechnicianCreateAttributes = {
  accountId: Scalars['Int']['input']
  binCount?: InputMaybe<Scalars['Boolean']['input']>
  branchIds?: InputMaybe<Array<Scalars['Int']['input']>>
  checkoutManager?: InputMaybe<Scalars['Boolean']['input']>
  divisionIds?: InputMaybe<Array<Scalars['Int']['input']>>
  email?: InputMaybe<Scalars['String']['input']>
  emailInboundInventoryApproval?: InputMaybe<Scalars['Boolean']['input']>
  emailLowStockWarning?: InputMaybe<Scalars['Boolean']['input']>
  emailOrderApprovalRequest?: InputMaybe<Scalars['Boolean']['input']>
  emailReplenishmentPlanReminder?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  password?: InputMaybe<Scalars['String']['input']>
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>
  resetPasswordSentAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  role?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  teamIds?: InputMaybe<Array<Scalars['Int']['input']>>
}

/** Autogenerated return type of TechnicianCreate. */
export type TechnicianCreatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<User>
}

/** Autogenerated return type of TechnicianMove. */
export type TechnicianMovePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
}

/** Autogenerated return type of TechnicianRemove. */
export type TechnicianRemovePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  /** ID of removed or deactivated Technician */
  result?: Maybe<Scalars['Int']['output']>
}

/** Autogenerated return type of TechnicianUpdate. */
export type TechnicianUpdatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<User>
}

/** Autogenerated return type of UpdateDeviceInfo. */
export type UpdateDeviceInfoPayload = {
  errors?: Maybe<Array<Scalars['String']['output']>>
  result?: Maybe<Scalars['Boolean']['output']>
}

export type User = {
  account?: Maybe<Account>
  accountUsers?: Maybe<UserWithPagination>
  accounts?: Maybe<AccountWithPagination>
  availableAccounts?: Maybe<Array<Maybe<Account>>>
  avatar?: Maybe<Scalars['String']['output']>
  binCount: Scalars['Boolean']['output']
  bins?: Maybe<Array<Location>>
  branches?: Maybe<Array<Maybe<Branch>>>
  checkoutManager: Scalars['Boolean']['output']
  checkoutUsers?: Maybe<Array<Maybe<User>>>
  checkouts?: Maybe<Array<Maybe<Checkout>>>
  clonedUsers?: Maybe<Array<Maybe<User>>>
  createdAt: Scalars['ISO8601DateTime']['output']
  currentSignInAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  defaultBin?: Maybe<Location>
  divisions?: Maybe<Array<Maybe<Division>>>
  email: Scalars['String']['output']
  emailInboundInventoryApproval?: Maybe<Scalars['Boolean']['output']>
  emailLocationInventory?: Maybe<Scalars['Boolean']['output']>
  emailLowStockWarning?: Maybe<Scalars['Boolean']['output']>
  emailOrderApprovalRequest?: Maybe<Scalars['Boolean']['output']>
  emailReplenishmentPlanReminder?: Maybe<Scalars['Boolean']['output']>
  enableReports?: Maybe<Scalars['Boolean']['output']>
  /** @deprecated Use `name` instead */
  firstName: Scalars['String']['output']
  generalManager: Scalars['Boolean']['output']
  id: Scalars['Int']['output']
  impersonating: Scalars['Boolean']['output']
  inboundInventoryFind?: Maybe<InboundInventory>
  internals?: Maybe<UserWithPagination>
  inventoryProducts?: Maybe<Array<Maybe<InventoryProduct>>>
  isAdmin: Scalars['Boolean']['output']
  isMovable: Scalars['Boolean']['output']
  isRemovable: Scalars['Boolean']['output']
  /** @deprecated Use `name` instead */
  lastName: Scalars['String']['output']
  lastSignInAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  location?: Maybe<Location>
  name: Scalars['String']['output']
  navInvoiceBranches?: Maybe<Array<Branch>>
  navInvoiceCounts?: Maybe<NavInvoiceCounts>
  navInvoices?: Maybe<NavInvoiceWithPagination>
  orderFilter?: Maybe<OrderWithPagination>
  orderFind?: Maybe<OrderDetailed>
  orders?: Maybe<Array<Order>>
  pendingOrdersStats?: Maybe<OrdersStats>
  /** @deprecated Use `avatar` instead */
  photo?: Maybe<Scalars['String']['output']>
  resetPasswordSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  retrieveAnnualPlan: Array<Order>
  role: Scalars['String']['output']
  sanaPasswordSyncError?: Maybe<Scalars['String']['output']>
  sanaPasswordSyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  status?: Maybe<Scalars['String']['output']>
  teams?: Maybe<Array<Maybe<Team>>>
  termsAcceptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>
  updatedAt: Scalars['ISO8601DateTime']['output']
}

export type UserAccountUsersArgs = {
  accountId: Scalars['Int']['input']
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  text?: InputMaybe<Scalars['String']['input']>
}

export type UserAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  text?: InputMaybe<Scalars['String']['input']>
}

export type UserBranchesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type UserCheckoutUsersArgs = {
  branchId: Scalars['Int']['input']
}

export type UserCheckoutsArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>
  status?: InputMaybe<CheckoutStatusesEnum>
  statuses?: InputMaybe<Array<CheckoutStatusesEnum>>
  text?: InputMaybe<Scalars['String']['input']>
}

export type UserInboundInventoryFindArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['Int']['input']
}

export type UserInternalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  text?: InputMaybe<Scalars['String']['input']>
}

export type UserInventoryProductsArgs = {
  branchId: Scalars['Int']['input']
  productId?: InputMaybe<Scalars['Int']['input']>
}

export type UserNavInvoiceBranchesArgs = {
  navInvoiceId: Scalars['Int']['input']
  text?: InputMaybe<Scalars['String']['input']>
}

export type UserNavInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  errorSubject?: InputMaybe<NavInvoiceErrorSubjectsEnum>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  text?: InputMaybe<Scalars['String']['input']>
}

export type UserOrderFilterArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  branchId?: InputMaybe<Scalars['Int']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  kind?: InputMaybe<OrderKindsEnum>
  last?: InputMaybe<Scalars['Int']['input']>
  month?: InputMaybe<Scalars['Int']['input']>
  period?: InputMaybe<Scalars['ISO8601Date']['input']>
  scope?: InputMaybe<OrderScopesEnum>
  status?: InputMaybe<OrderStatusesEnum>
  text?: InputMaybe<Scalars['String']['input']>
  year?: InputMaybe<Scalars['Int']['input']>
}

export type UserOrderFindArgs = {
  id: Scalars['Int']['input']
}

export type UserOrdersArgs = {
  branchId: Scalars['Int']['input']
  id?: InputMaybe<Scalars['Int']['input']>
  kind?: InputMaybe<OrderKindsEnum>
  limit?: InputMaybe<Scalars['Int']['input']>
  month?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  productId?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<OrderStatusesEnum>
  statuses?: InputMaybe<Array<OrderStatusesEnum>>
  text?: InputMaybe<Scalars['String']['input']>
  year?: InputMaybe<Scalars['Int']['input']>
}

export type UserPendingOrdersStatsArgs = {
  branchId: Scalars['Int']['input']
}

export type UserRetrieveAnnualPlanArgs = {
  branchId: Scalars['Int']['input']
  productId?: InputMaybe<Scalars['Int']['input']>
  year: Scalars['Int']['input']
}

/** Autogenerated return type of UserAttachAvatar. */
export type UserAttachAvatarPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<User>
}

/** Attributes for User */
export type UserAttributes = {
  binCount?: InputMaybe<Scalars['Boolean']['input']>
  branchIds?: InputMaybe<Array<Scalars['Int']['input']>>
  checkoutManager?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  emailInboundInventoryApproval?: InputMaybe<Scalars['Boolean']['input']>
  emailLocationInventory?: InputMaybe<Scalars['Boolean']['input']>
  emailLowStockWarning?: InputMaybe<Scalars['Boolean']['input']>
  emailOrderApprovalRequest?: InputMaybe<Scalars['Boolean']['input']>
  emailReplenishmentPlanReminder?: InputMaybe<Scalars['Boolean']['input']>
  enableReports?: InputMaybe<Scalars['Boolean']['input']>
  generalManager?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  password?: InputMaybe<Scalars['String']['input']>
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>
  resetPasswordSentAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  role?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  teamIds?: InputMaybe<Array<Scalars['Int']['input']>>
}

/** Attributes for Technician creation */
export type UserCreateAttributes = {
  accountId: Scalars['Int']['input']
  binCount?: InputMaybe<Scalars['Boolean']['input']>
  branchIds?: InputMaybe<Array<Scalars['Int']['input']>>
  checkoutManager?: InputMaybe<Scalars['Boolean']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  emailInboundInventoryApproval?: InputMaybe<Scalars['Boolean']['input']>
  emailLocationInventory?: InputMaybe<Scalars['Boolean']['input']>
  emailLowStockWarning?: InputMaybe<Scalars['Boolean']['input']>
  emailOrderApprovalRequest?: InputMaybe<Scalars['Boolean']['input']>
  emailReplenishmentPlanReminder?: InputMaybe<Scalars['Boolean']['input']>
  enableReports?: InputMaybe<Scalars['Boolean']['input']>
  generalManager?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  password?: InputMaybe<Scalars['String']['input']>
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>
  resetPasswordSentAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>
  role?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  teamIds?: InputMaybe<Array<Scalars['Int']['input']>>
}

/** Autogenerated return type of UserCreate. */
export type UserCreatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<User>
}

/** An edge in a connection. */
export type UserEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge. */
  node?: Maybe<User>
}

/** Autogenerated return type of UserMove. */
export type UserMovePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<User>
}

/** Autogenerated return type of UserReassignAccount. */
export type UserReassignAccountPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<User>
  token?: Maybe<Scalars['String']['output']>
}

export enum UserRolesEnum {
  Manager = 'manager',
  Technician = 'technician',
}

/** Autogenerated return type of UserSetBranches. */
export type UserSetBranchesPayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<User>
}

/** Autogenerated return type of UserUpdate. */
export type UserUpdatePayload = {
  errors?: Maybe<Scalars['JSON']['output']>
  result?: Maybe<User>
}

/** The connection type for User. */
export type UserWithPagination = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  totalItems: Scalars['Int']['output']
}

export type ResolverTypeWrapper<T> = Promise<T> | T

export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>
}
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | ResolverWithResolve<TResult, TParent, TContext, TArgs>

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => Promise<TResult> | TResult

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>

export interface SubscriptionSubscriberObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs,
> {
  subscribe: SubscriptionSubscribeFn<
    { [key in TKey]: TResult },
    TParent,
    TContext,
    TArgs
  >
  resolve?: SubscriptionResolveFn<
    TResult,
    { [key in TKey]: TResult },
    TContext,
    TArgs
  >
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>
}

export type SubscriptionObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs,
> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>

export type SubscriptionResolver<
  TResult,
  TKey extends string,
  TParent = {},
  TContext = {},
  TArgs = {},
> =
  | ((
      ...args: any[]
    ) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo,
) => Maybe<TTypes> | Promise<Maybe<TTypes>>

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (
  obj: T,
  context: TContext,
  info: GraphQLResolveInfo,
) => boolean | Promise<boolean>

export type NextResolverFn<T> = () => Promise<T>

export type DirectiveResolverFn<
  TResult = {},
  TParent = {},
  TContext = {},
  TArgs = {},
> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>

/** Mapping of union types */
export type ResolversUnionTypes<_RefType extends Record<string, unknown>> = {
  ProductsUnion: Omit<AccountsProduct, 'branchesProduct'> & {
    branchesProduct?: Maybe<_RefType['BranchesProduct']>
  }
}

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AcceptTermsPayload: ResolverTypeWrapper<
    Omit<AcceptTermsPayload, 'result'> & {
      result?: Maybe<ResolversTypes['User']>
    }
  >
  Account: ResolverTypeWrapper<
    Omit<
      Account,
      | 'accountProducts'
      | 'branches'
      | 'divisions'
      | 'productsCheckoutable'
      | 'productsOrderable'
      | 'users'
    > & {
      accountProducts?: Maybe<Array<Maybe<ResolversTypes['ProductsUnion']>>>
      branches?: Maybe<Array<ResolversTypes['Branch']>>
      divisions?: Maybe<Array<ResolversTypes['Division']>>
      productsCheckoutable?: Maybe<
        Array<Maybe<ResolversTypes['DivisionsProduct']>>
      >
      productsOrderable?: Maybe<Array<Maybe<ResolversTypes['AccountsProduct']>>>
      users?: Maybe<Array<ResolversTypes['User']>>
    }
  >
  AccountAssignmentInput: AccountAssignmentInput
  AccountBase: ResolverTypeWrapper<AccountBase>
  AccountBaseAttributes: AccountBaseAttributes
  AccountEdge: ResolverTypeWrapper<
    Omit<AccountEdge, 'node'> & { node?: Maybe<ResolversTypes['Account']> }
  >
  AccountSyncJob: ResolverTypeWrapper<AccountSyncJob>
  AccountSyncJobStatusesEnum: AccountSyncJobStatusesEnum
  AccountUpdatePayload: ResolverTypeWrapper<
    Omit<AccountUpdatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['Account']>
    }
  >
  AccountWithPagination: ResolverTypeWrapper<
    Omit<AccountWithPagination, 'edges' | 'nodes'> & {
      edges?: Maybe<Array<Maybe<ResolversTypes['AccountEdge']>>>
      nodes?: Maybe<Array<Maybe<ResolversTypes['Account']>>>
    }
  >
  AccountsProduct: ResolverTypeWrapper<
    Omit<AccountsProduct, 'branchesProduct'> & {
      branchesProduct?: Maybe<ResolversTypes['BranchesProduct']>
    }
  >
  AddPlanProductPayload: ResolverTypeWrapper<AddPlanProductPayload>
  AddPlanProductResult: ResolverTypeWrapper<AddPlanProductResult>
  AddPlanProductsFromInventoryPayload: ResolverTypeWrapper<
    Omit<AddPlanProductsFromInventoryPayload, 'result'> & {
      result?: Maybe<Array<Maybe<ResolversTypes['OrderItem']>>>
    }
  >
  AssignMultipleAccountsPayload: ResolverTypeWrapper<
    Omit<AssignMultipleAccountsPayload, 'result'> & {
      result?: Maybe<ResolversTypes['User']>
    }
  >
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>
  Branch: ResolverTypeWrapper<
    Omit<
      Branch,
      | 'account'
      | 'cartItems'
      | 'checkoutUsers'
      | 'checkouts'
      | 'divisions'
      | 'inventoryProducts'
      | 'locationAssignableUsers'
      | 'managers'
      | 'orders'
      | 'plannedProducts'
      | 'planners'
      | 'sanaLoginManager'
      | 'suggestedCartItems'
      | 'teams'
      | 'technicians'
      | 'users'
    > & {
      account: ResolversTypes['AccountBase']
      cartItems?: Maybe<Array<ResolversTypes['CartItem']>>
      checkoutUsers?: Maybe<Array<ResolversTypes['User']>>
      checkouts?: Maybe<Array<ResolversTypes['Checkout']>>
      divisions?: Maybe<Array<ResolversTypes['Division']>>
      inventoryProducts?: Maybe<
        Array<Maybe<ResolversTypes['InventoryProduct']>>
      >
      locationAssignableUsers?: Maybe<Array<ResolversTypes['User']>>
      managers?: Maybe<Array<ResolversTypes['User']>>
      orders?: Maybe<Array<ResolversTypes['Order']>>
      plannedProducts?: Maybe<Array<Maybe<ResolversTypes['AccountsProduct']>>>
      planners?: Maybe<Array<ResolversTypes['User']>>
      sanaLoginManager?: Maybe<ResolversTypes['User']>
      suggestedCartItems?: Maybe<Array<ResolversTypes['CartItem']>>
      teams?: Maybe<Array<ResolversTypes['Team']>>
      technicians?: Maybe<Array<ResolversTypes['User']>>
      users?: Maybe<Array<ResolversTypes['User']>>
    }
  >
  BranchBinLocationItem: ResolverTypeWrapper<BranchBinLocationItem>
  BranchCreateAttributes: BranchCreateAttributes
  BranchCreatePayload: ResolverTypeWrapper<
    Omit<BranchCreatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['Branch']>
    }
  >
  BranchDeletePayload: ResolverTypeWrapper<
    Omit<BranchDeletePayload, 'result'> & {
      result?: Maybe<ResolversTypes['Branch']>
    }
  >
  BranchTruckInventoryInput: BranchTruckInventoryInput
  BranchUpdateAttributes: BranchUpdateAttributes
  BranchUpdatePayload: ResolverTypeWrapper<
    Omit<BranchUpdatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['Branch']>
    }
  >
  BranchesProduct: ResolverTypeWrapper<
    Omit<BranchesProduct, 'locationItems'> & {
      locationItems: Array<ResolversTypes['LocationItem']>
    }
  >
  BranchesSalableProduct: ResolverTypeWrapper<
    Omit<BranchesSalableProduct, 'branch'> & {
      branch: ResolversTypes['Branch']
    }
  >
  CartBranchUpdateAttributes: CartBranchUpdateAttributes
  CartBranchUpdatePayload: ResolverTypeWrapper<
    Omit<CartBranchUpdatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['Branch']>
    }
  >
  CartItem: ResolverTypeWrapper<
    Omit<CartItem, 'updatedBy'> & { updatedBy: ResolversTypes['User'] }
  >
  CartItemCreateAttributes: CartItemCreateAttributes
  CartItemCreatePayload: ResolverTypeWrapper<
    Omit<CartItemCreatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['CartItem']>
    }
  >
  CartItemUpdateAttributes: CartItemUpdateAttributes
  CartItemUpdatePayload: ResolverTypeWrapper<
    Omit<CartItemUpdatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['CartItem']>
    }
  >
  Checkout: ResolverTypeWrapper<
    Omit<Checkout, 'consumer' | 'openedBy' | 'technician' | 'updatedBy'> & {
      consumer: ResolversTypes['User']
      openedBy?: Maybe<ResolversTypes['User']>
      technician?: Maybe<ResolversTypes['User']>
      updatedBy: ResolversTypes['User']
    }
  >
  CheckoutActionsEnum: CheckoutActionsEnum
  CheckoutAttributes: CheckoutAttributes
  CheckoutCancelAttributes: CheckoutCancelAttributes
  CheckoutCancelPayload: ResolverTypeWrapper<
    Omit<CheckoutCancelPayload, 'result'> & {
      result?: Maybe<ResolversTypes['Checkout']>
    }
  >
  CheckoutCompletePayload: ResolverTypeWrapper<
    Omit<CheckoutCompletePayload, 'result'> & {
      result?: Maybe<ResolversTypes['Checkout']>
    }
  >
  CheckoutCreatePayload: ResolverTypeWrapper<
    Omit<CheckoutCreatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['Checkout']>
    }
  >
  CheckoutItem: ResolverTypeWrapper<CheckoutItem>
  CheckoutItemBaseAttributes: CheckoutItemBaseAttributes
  CheckoutItemCreateAttributes: CheckoutItemCreateAttributes
  CheckoutItemCreatePayload: ResolverTypeWrapper<CheckoutItemCreatePayload>
  CheckoutItemDepletion: ResolverTypeWrapper<CheckoutItemDepletion>
  CheckoutItemDepletionInput: CheckoutItemDepletionInput
  CheckoutItemRemovePayload: ResolverTypeWrapper<CheckoutItemRemovePayload>
  CheckoutItemUpdateAttributes: CheckoutItemUpdateAttributes
  CheckoutItemUpdatePayload: ResolverTypeWrapper<CheckoutItemUpdatePayload>
  CheckoutRecallPayload: ResolverTypeWrapper<
    Omit<CheckoutRecallPayload, 'result'> & {
      result?: Maybe<ResolversTypes['Checkout']>
    }
  >
  CheckoutRemovePayload: ResolverTypeWrapper<CheckoutRemovePayload>
  CheckoutReopenPayload: ResolverTypeWrapper<
    Omit<CheckoutReopenPayload, 'result'> & {
      result?: Maybe<ResolversTypes['Checkout']>
    }
  >
  CheckoutStatusesEnum: CheckoutStatusesEnum
  CheckoutSubmitPayload: ResolverTypeWrapper<
    Omit<CheckoutSubmitPayload, 'result'> & {
      result?: Maybe<ResolversTypes['Checkout']>
    }
  >
  CycleCount: ResolverTypeWrapper<
    Omit<
      CycleCount,
      | 'account'
      | 'completedBy'
      | 'countedBy'
      | 'cycleCountItems'
      | 'location'
      | 'rejectedBy'
    > & {
      account: ResolversTypes['Account']
      completedBy?: Maybe<ResolversTypes['User']>
      countedBy: ResolversTypes['User']
      cycleCountItems: Array<ResolversTypes['CycleCountItem']>
      location: ResolversTypes['Location']
      rejectedBy?: Maybe<ResolversTypes['User']>
    }
  >
  CycleCountCreateAttributes: CycleCountCreateAttributes
  CycleCountCreatePayload: ResolverTypeWrapper<
    Omit<CycleCountCreatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['CycleCount']>
    }
  >
  CycleCountItem: ResolverTypeWrapper<
    Omit<CycleCountItem, 'cycleCount' | 'locationItem'> & {
      cycleCount: ResolversTypes['CycleCount']
      locationItem: ResolversTypes['LocationItem']
    }
  >
  CycleCountItemCreateAttributes: CycleCountItemCreateAttributes
  CycleCountItemStatusesEnum: CycleCountItemStatusesEnum
  CycleCountItemUpdateAttributes: CycleCountItemUpdateAttributes
  CycleCountItemsUpdatePayload: ResolverTypeWrapper<
    Omit<CycleCountItemsUpdatePayload, 'result'> & {
      result?: Maybe<Array<ResolversTypes['CycleCountItem']>>
    }
  >
  CycleCountRecountPayload: ResolverTypeWrapper<
    Omit<CycleCountRecountPayload, 'result'> & {
      result?: Maybe<ResolversTypes['CycleCount']>
    }
  >
  CycleCountStatusesEnum: CycleCountStatusesEnum
  CycleCountUpdateAttributes: CycleCountUpdateAttributes
  CycleCountUpdatePayload: ResolverTypeWrapper<
    Omit<CycleCountUpdatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['CycleCount']>
    }
  >
  Decimal: ResolverTypeWrapper<Scalars['Decimal']['output']>
  DestinationTransfer: ResolverTypeWrapper<DestinationTransfer>
  Division: ResolverTypeWrapper<
    Omit<
      Division,
      'checkoutableProducts' | 'inventoryProducts' | 'products' | 'technicians'
    > & {
      checkoutableProducts?: Maybe<
        Array<Maybe<ResolversTypes['DivisionsProduct']>>
      >
      inventoryProducts?: Maybe<
        Array<Maybe<ResolversTypes['InventoryProduct']>>
      >
      products?: Maybe<Array<Maybe<ResolversTypes['DivisionsProduct']>>>
      technicians?: Maybe<Array<ResolversTypes['User']>>
    }
  >
  DivisionBaseAttributes: DivisionBaseAttributes
  DivisionCreateAttributes: DivisionCreateAttributes
  DivisionCreatePayload: ResolverTypeWrapper<
    Omit<DivisionCreatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['Division']>
    }
  >
  DivisionRemovePayload: ResolverTypeWrapper<DivisionRemovePayload>
  DivisionUpdatePayload: ResolverTypeWrapper<
    Omit<DivisionUpdatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['Division']>
    }
  >
  DivisionsProduct: ResolverTypeWrapper<
    Omit<DivisionsProduct, 'branchesProduct'> & {
      branchesProduct?: Maybe<ResolversTypes['BranchesProduct']>
    }
  >
  EnsureBranchPayload: ResolverTypeWrapper<
    Omit<EnsureBranchPayload, 'result'> & {
      result?: Maybe<ResolversTypes['Branch']>
    }
  >
  Float: ResolverTypeWrapper<Scalars['Float']['output']>
  Forecast: ResolverTypeWrapper<Forecast>
  GenerateAppLoginTokenPayload: ResolverTypeWrapper<GenerateAppLoginTokenPayload>
  GenericProduct: ResolverTypeWrapper<
    Omit<GenericProduct, 'branchesProduct'> & {
      branchesProduct?: Maybe<ResolversTypes['BranchesProduct']>
    }
  >
  GenericProductKindsEnum: GenericProductKindsEnum
  ID: ResolverTypeWrapper<Scalars['ID']['output']>
  ISO8601Date: ResolverTypeWrapper<Scalars['ISO8601Date']['output']>
  ISO8601DateOnly: ResolverTypeWrapper<Scalars['ISO8601DateOnly']['output']>
  ISO8601DateTime: ResolverTypeWrapper<Scalars['ISO8601DateTime']['output']>
  ImpersonateUserPayload: ResolverTypeWrapper<ImpersonateUserPayload>
  InboundApproveAttributes: InboundApproveAttributes
  InboundInventory: ResolverTypeWrapper<InboundInventory>
  InboundInventoryApprovePayload: ResolverTypeWrapper<InboundInventoryApprovePayload>
  Int: ResolverTypeWrapper<Scalars['Int']['output']>
  InventoryEvent: ResolverTypeWrapper<
    Omit<InventoryEvent, 'createdByUser'> & {
      createdByUser?: Maybe<ResolversTypes['User']>
    }
  >
  InventoryEventEdge: ResolverTypeWrapper<
    Omit<InventoryEventEdge, 'node'> & {
      node?: Maybe<ResolversTypes['InventoryEvent']>
    }
  >
  InventoryEventTypesEnum: InventoryEventTypesEnum
  InventoryEventWithPagination: ResolverTypeWrapper<
    Omit<InventoryEventWithPagination, 'edges' | 'nodes'> & {
      edges?: Maybe<Array<Maybe<ResolversTypes['InventoryEventEdge']>>>
      nodes?: Maybe<Array<Maybe<ResolversTypes['InventoryEvent']>>>
    }
  >
  InventoryProduct: ResolverTypeWrapper<
    Omit<
      InventoryProduct,
      'divisions' | 'inventoryEvents' | 'locationItems'
    > & {
      divisions?: Maybe<Array<Maybe<ResolversTypes['Division']>>>
      inventoryEvents?: Maybe<ResolversTypes['InventoryEventWithPagination']>
      locationItems: Array<ResolversTypes['LocationItem']>
    }
  >
  InventoryProductCreateAttributes: InventoryProductCreateAttributes
  InventoryProductCreatePayload: ResolverTypeWrapper<
    Omit<InventoryProductCreatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['InventoryProduct']>
    }
  >
  InventoryProductRemovePayload: ResolverTypeWrapper<InventoryProductRemovePayload>
  InventoryProductTransferAttributes: InventoryProductTransferAttributes
  InventoryProductTransferPayload: ResolverTypeWrapper<
    Omit<InventoryProductTransferPayload, 'result'> & {
      result?: Maybe<ResolversTypes['InventoryProduct']>
    }
  >
  InventoryProductUpdateAttributes: InventoryProductUpdateAttributes
  InventoryProductUpdatePayload: ResolverTypeWrapper<
    Omit<InventoryProductUpdatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['InventoryProduct']>
    }
  >
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>
  LoadAccountsCsvPayload: ResolverTypeWrapper<
    Omit<LoadAccountsCsvPayload, 'result'> & {
      result?: Maybe<Array<Maybe<ResolversTypes['Account']>>>
    }
  >
  LoadBranchesCsvPayload: ResolverTypeWrapper<
    Omit<LoadBranchesCsvPayload, 'result'> & {
      result?: Maybe<Array<Maybe<ResolversTypes['Branch']>>>
    }
  >
  LoadDivisionProductsCsvPayload: ResolverTypeWrapper<
    Omit<LoadDivisionProductsCsvPayload, 'result'> & {
      result?: Maybe<Array<Maybe<ResolversTypes['GenericProduct']>>>
    }
  >
  LoadLocationsCsvPayload: ResolverTypeWrapper<
    Omit<LoadLocationsCsvPayload, 'result'> & {
      result?: Maybe<Array<Maybe<ResolversTypes['Location']>>>
    }
  >
  LoadShipmentsCsvPayload: ResolverTypeWrapper<LoadShipmentsCsvPayload>
  LoadUsersCsvPayload: ResolverTypeWrapper<LoadUsersCsvPayload>
  Location: ResolverTypeWrapper<
    Omit<
      Location,
      | 'branches'
      | 'latestCycleCount'
      | 'latestMove'
      | 'locationItems'
      | 'lowStockLocationItems'
      | 'updatedBy'
      | 'user'
    > & {
      branches: Array<ResolversTypes['Branch']>
      latestCycleCount?: Maybe<ResolversTypes['CycleCount']>
      latestMove?: Maybe<ResolversTypes['Move']>
      locationItems: Array<ResolversTypes['LocationItem']>
      lowStockLocationItems: Array<ResolversTypes['LocationItem']>
      updatedBy?: Maybe<ResolversTypes['User']>
      user?: Maybe<ResolversTypes['User']>
    }
  >
  LocationCreateAttributes: LocationCreateAttributes
  LocationCreatePayload: ResolverTypeWrapper<
    Omit<LocationCreatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['Location']>
    }
  >
  LocationDeletePayload: ResolverTypeWrapper<LocationDeletePayload>
  LocationItem: ResolverTypeWrapper<
    Omit<LocationItem, 'location' | 'updatedBy'> & {
      location: ResolversTypes['Location']
      updatedBy?: Maybe<ResolversTypes['User']>
    }
  >
  LocationItemCreateAttributes: LocationItemCreateAttributes
  LocationItemCreatePayload: ResolverTypeWrapper<
    Omit<LocationItemCreatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['LocationItem']>
    }
  >
  LocationItemDeletePayload: ResolverTypeWrapper<
    Omit<LocationItemDeletePayload, 'result'> & {
      result?: Maybe<ResolversTypes['LocationItem']>
    }
  >
  LocationItemUpdateAttributes: LocationItemUpdateAttributes
  LocationItemUpdatePayload: ResolverTypeWrapper<
    Omit<LocationItemUpdatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['LocationItem']>
    }
  >
  LocationUpdateAttributes: LocationUpdateAttributes
  LocationUpdatePayload: ResolverTypeWrapper<
    Omit<LocationUpdatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['Location']>
    }
  >
  ManagerAttributes: ManagerAttributes
  ManagerUpdatePayload: ResolverTypeWrapper<ManagerUpdatePayload>
  Message: ResolverTypeWrapper<Message>
  MessageArchivePayload: ResolverTypeWrapper<MessageArchivePayload>
  MessageMarkReadPayload: ResolverTypeWrapper<
    Omit<MessageMarkReadPayload, 'result'> & {
      result?: Maybe<ResolversTypes['MessageRead']>
    }
  >
  MessagePublishPayload: ResolverTypeWrapper<MessagePublishPayload>
  MessageRead: ResolverTypeWrapper<
    Omit<MessageRead, 'user'> & { user: ResolversTypes['User'] }
  >
  MessageUpdatePayload: ResolverTypeWrapper<MessageUpdatePayload>
  Money: ResolverTypeWrapper<Scalars['Money']['output']>
  Move: ResolverTypeWrapper<
    Omit<
      Move,
      | 'account'
      | 'canceledBy'
      | 'completedBy'
      | 'fromLocation'
      | 'moveItems'
      | 'movedBy'
      | 'rejectedBy'
      | 'toBranch'
      | 'toLocation'
    > & {
      account: ResolversTypes['Account']
      canceledBy?: Maybe<ResolversTypes['User']>
      completedBy?: Maybe<ResolversTypes['User']>
      fromLocation: ResolversTypes['Location']
      moveItems: Array<ResolversTypes['MoveItem']>
      movedBy: ResolversTypes['User']
      rejectedBy?: Maybe<ResolversTypes['User']>
      toBranch?: Maybe<ResolversTypes['Branch']>
      toLocation?: Maybe<ResolversTypes['Location']>
    }
  >
  MoveCreateAttributes: MoveCreateAttributes
  MoveCreatePayload: ResolverTypeWrapper<
    Omit<MoveCreatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['Move']>
    }
  >
  MoveItem: ResolverTypeWrapper<
    Omit<MoveItem, 'locationItem' | 'move' | 'toLocation'> & {
      locationItem: ResolversTypes['LocationItem']
      move: ResolversTypes['Move']
      toLocation?: Maybe<ResolversTypes['Location']>
    }
  >
  MoveItemCreateAttributes: MoveItemCreateAttributes
  MoveStatusesEnum: MoveStatusesEnum
  MoveUpdateAttributes: MoveUpdateAttributes
  MoveUpdatePayload: ResolverTypeWrapper<
    Omit<MoveUpdatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['Move']>
    }
  >
  Mutation: ResolverTypeWrapper<{}>
  NavInvoice: ResolverTypeWrapper<
    Omit<NavInvoice, 'manualBranch'> & {
      manualBranch?: Maybe<ResolversTypes['Branch']>
    }
  >
  NavInvoiceCounts: ResolverTypeWrapper<NavInvoiceCounts>
  NavInvoiceEdge: ResolverTypeWrapper<
    Omit<NavInvoiceEdge, 'node'> & {
      node?: Maybe<ResolversTypes['NavInvoice']>
    }
  >
  NavInvoiceErrorSubjectsEnum: NavInvoiceErrorSubjectsEnum
  NavInvoiceIgnorePayload: ResolverTypeWrapper<
    Omit<NavInvoiceIgnorePayload, 'result'> & {
      result?: Maybe<ResolversTypes['NavInvoice']>
    }
  >
  NavInvoiceMapPayload: ResolverTypeWrapper<
    Omit<NavInvoiceMapPayload, 'result'> & {
      result?: Maybe<ResolversTypes['NavInvoice']>
    }
  >
  NavInvoiceStatusesEnum: NavInvoiceStatusesEnum
  NavInvoiceWithPagination: ResolverTypeWrapper<
    Omit<NavInvoiceWithPagination, 'edges' | 'nodes'> & {
      edges?: Maybe<Array<Maybe<ResolversTypes['NavInvoiceEdge']>>>
      nodes?: Maybe<Array<Maybe<ResolversTypes['NavInvoice']>>>
    }
  >
  NewProductTagInput: NewProductTagInput
  OpenProcessEnum: OpenProcessEnum
  Order: ResolverTypeWrapper<
    Omit<
      Order,
      | 'account'
      | 'approvedBy'
      | 'branch'
      | 'createdBy'
      | 'orderItems'
      | 'rejectedBy'
      | 'requestedBy'
      | 'submittedBy'
      | 'updatedBy'
    > & {
      account: ResolversTypes['Account']
      approvedBy?: Maybe<ResolversTypes['User']>
      branch: ResolversTypes['Branch']
      createdBy?: Maybe<ResolversTypes['User']>
      orderItems?: Maybe<Array<ResolversTypes['OrderItem']>>
      rejectedBy?: Maybe<ResolversTypes['User']>
      requestedBy?: Maybe<ResolversTypes['User']>
      submittedBy?: Maybe<ResolversTypes['User']>
      updatedBy?: Maybe<ResolversTypes['User']>
    }
  >
  OrderApprovePayload: ResolverTypeWrapper<
    Omit<OrderApprovePayload, 'result'> & {
      result?: Maybe<ResolversTypes['Order']>
    }
  >
  OrderDetailed: ResolverTypeWrapper<
    Omit<
      OrderDetailed,
      | 'account'
      | 'approvedBy'
      | 'branch'
      | 'createdBy'
      | 'orderItems'
      | 'rejectedBy'
      | 'requestedBy'
      | 'submittedBy'
      | 'updatedBy'
    > & {
      account: ResolversTypes['Account']
      approvedBy?: Maybe<ResolversTypes['User']>
      branch: ResolversTypes['Branch']
      createdBy?: Maybe<ResolversTypes['User']>
      orderItems?: Maybe<Array<ResolversTypes['OrderItem']>>
      rejectedBy?: Maybe<ResolversTypes['User']>
      requestedBy?: Maybe<ResolversTypes['User']>
      submittedBy?: Maybe<ResolversTypes['User']>
      updatedBy?: Maybe<ResolversTypes['User']>
    }
  >
  OrderEdge: ResolverTypeWrapper<
    Omit<OrderEdge, 'node'> & { node?: Maybe<ResolversTypes['Order']> }
  >
  OrderItem: ResolverTypeWrapper<
    Omit<OrderItem, 'updatedBy'> & { updatedBy: ResolversTypes['User'] }
  >
  OrderItemCreateAttributes: OrderItemCreateAttributes
  OrderItemCreatePayload: ResolverTypeWrapper<
    Omit<OrderItemCreatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['OrderItem']>
    }
  >
  OrderItemUpdateAttributes: OrderItemUpdateAttributes
  OrderItemUpdatePayload: ResolverTypeWrapper<
    Omit<OrderItemUpdatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['OrderItem']>
    }
  >
  OrderKindsEnum: OrderKindsEnum
  OrderRejectAttributes: OrderRejectAttributes
  OrderRejectPayload: ResolverTypeWrapper<
    Omit<OrderRejectPayload, 'result'> & {
      result?: Maybe<ResolversTypes['Order']>
    }
  >
  OrderRequestFromCartPayload: ResolverTypeWrapper<
    Omit<OrderRequestFromCartPayload, 'result'> & {
      result?: Maybe<ResolversTypes['Order']>
    }
  >
  OrderRequestPayload: ResolverTypeWrapper<
    Omit<OrderRequestPayload, 'result'> & {
      result?: Maybe<ResolversTypes['Order']>
    }
  >
  OrderRequestTrackingInfoPayload: ResolverTypeWrapper<OrderRequestTrackingInfoPayload>
  OrderScopesEnum: OrderScopesEnum
  OrderStatusesEnum: OrderStatusesEnum
  OrderSubmitFromCartPayload: ResolverTypeWrapper<
    Omit<OrderSubmitFromCartPayload, 'result'> & {
      result?: Maybe<ResolversTypes['Order']>
    }
  >
  OrderSubmitPayload: ResolverTypeWrapper<
    Omit<OrderSubmitPayload, 'result'> & {
      result?: Maybe<ResolversTypes['Order']>
    }
  >
  OrderTrackingStatus: ResolverTypeWrapper<OrderTrackingStatus>
  OrderUpdateAttributes: OrderUpdateAttributes
  OrderUpdatePayload: ResolverTypeWrapper<
    Omit<OrderUpdatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['Order']>
    }
  >
  OrderWithPagination: ResolverTypeWrapper<
    Omit<OrderWithPagination, 'edges' | 'nodes'> & {
      edges?: Maybe<Array<Maybe<ResolversTypes['OrderEdge']>>>
      nodes?: Maybe<Array<Maybe<ResolversTypes['Order']>>>
    }
  >
  OrdersStats: ResolverTypeWrapper<OrdersStats>
  PageInfo: ResolverTypeWrapper<PageInfo>
  PlanItem: ResolverTypeWrapper<PlanItem>
  Product: ResolverTypeWrapper<Product>
  ProductCategory: ResolverTypeWrapper<ProductCategory>
  ProductGroup: ResolverTypeWrapper<ProductGroup>
  ProductTag: ResolverTypeWrapper<ProductTag>
  ProductTagCreatePayload: ResolverTypeWrapper<ProductTagCreatePayload>
  ProductTagDeletePayload: ResolverTypeWrapper<ProductTagDeletePayload>
  ProductTagUpdatePayload: ResolverTypeWrapper<ProductTagUpdatePayload>
  ProductsUnion: ResolverTypeWrapper<
    ResolversUnionTypes<ResolversTypes>['ProductsUnion']
  >
  Query: ResolverTypeWrapper<{}>
  RemoveBranchesSalableProductPayload: ResolverTypeWrapper<RemoveBranchesSalableProductPayload>
  RemovePlanProductPayload: ResolverTypeWrapper<RemovePlanProductPayload>
  RemovedOrderItem: ResolverTypeWrapper<RemovedOrderItem>
  ReplenishmentPlanExport: ResolverTypeWrapper<ReplenishmentPlanExport>
  ReplenishmentPlanItemSpecifyPayload: ResolverTypeWrapper<ReplenishmentPlanItemSpecifyPayload>
  ReplenishmentPlanProductReplacePayload: ResolverTypeWrapper<
    Omit<ReplenishmentPlanProductReplacePayload, 'result'> & {
      result?: Maybe<ResolversTypes['BranchesSalableProduct']>
    }
  >
  SalableProductData: ResolverTypeWrapper<SalableProductData>
  SanaPasswordRotatePayload: ResolverTypeWrapper<SanaPasswordRotatePayload>
  SanaPasswordSetManualPayload: ResolverTypeWrapper<SanaPasswordSetManualPayload>
  ScheduleAccountSyncPayload: ResolverTypeWrapper<ScheduleAccountSyncPayload>
  ScheduleBranchSyncPayload: ResolverTypeWrapper<ScheduleBranchSyncPayload>
  ScheduleProductsUpdatePayload: ResolverTypeWrapper<ScheduleProductsUpdatePayload>
  Shipment: ResolverTypeWrapper<Shipment>
  ShippedProduct: ResolverTypeWrapper<ShippedProduct>
  Species: ResolverTypeWrapper<Species>
  SpeciesSetGroupPayload: ResolverTypeWrapper<SpeciesSetGroupPayload>
  String: ResolverTypeWrapper<Scalars['String']['output']>
  SubmittedItem: ResolverTypeWrapper<SubmittedItem>
  Team: ResolverTypeWrapper<
    Omit<Team, 'technicians'> & {
      technicians?: Maybe<Array<ResolversTypes['User']>>
    }
  >
  TeamBaseAttributes: TeamBaseAttributes
  TeamCreateAttributes: TeamCreateAttributes
  TeamCreatePayload: ResolverTypeWrapper<
    Omit<TeamCreatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['Team']>
    }
  >
  TeamRemovePayload: ResolverTypeWrapper<TeamRemovePayload>
  TeamUpdatePayload: ResolverTypeWrapper<
    Omit<TeamUpdatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['Team']>
    }
  >
  TechnicianAttributes: TechnicianAttributes
  TechnicianCreateAttributes: TechnicianCreateAttributes
  TechnicianCreatePayload: ResolverTypeWrapper<
    Omit<TechnicianCreatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['User']>
    }
  >
  TechnicianMovePayload: ResolverTypeWrapper<TechnicianMovePayload>
  TechnicianRemovePayload: ResolverTypeWrapper<TechnicianRemovePayload>
  TechnicianUpdatePayload: ResolverTypeWrapper<
    Omit<TechnicianUpdatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['User']>
    }
  >
  UpdateDeviceInfoPayload: ResolverTypeWrapper<UpdateDeviceInfoPayload>
  User: ResolverTypeWrapper<
    Omit<
      User,
      | 'account'
      | 'accountUsers'
      | 'accounts'
      | 'availableAccounts'
      | 'bins'
      | 'branches'
      | 'checkoutUsers'
      | 'checkouts'
      | 'clonedUsers'
      | 'defaultBin'
      | 'divisions'
      | 'internals'
      | 'inventoryProducts'
      | 'location'
      | 'navInvoiceBranches'
      | 'navInvoices'
      | 'orderFilter'
      | 'orderFind'
      | 'orders'
      | 'retrieveAnnualPlan'
      | 'teams'
    > & {
      account?: Maybe<ResolversTypes['Account']>
      accountUsers?: Maybe<ResolversTypes['UserWithPagination']>
      accounts?: Maybe<ResolversTypes['AccountWithPagination']>
      availableAccounts?: Maybe<Array<Maybe<ResolversTypes['Account']>>>
      bins?: Maybe<Array<ResolversTypes['Location']>>
      branches?: Maybe<Array<Maybe<ResolversTypes['Branch']>>>
      checkoutUsers?: Maybe<Array<Maybe<ResolversTypes['User']>>>
      checkouts?: Maybe<Array<Maybe<ResolversTypes['Checkout']>>>
      clonedUsers?: Maybe<Array<Maybe<ResolversTypes['User']>>>
      defaultBin?: Maybe<ResolversTypes['Location']>
      divisions?: Maybe<Array<Maybe<ResolversTypes['Division']>>>
      internals?: Maybe<ResolversTypes['UserWithPagination']>
      inventoryProducts?: Maybe<
        Array<Maybe<ResolversTypes['InventoryProduct']>>
      >
      location?: Maybe<ResolversTypes['Location']>
      navInvoiceBranches?: Maybe<Array<ResolversTypes['Branch']>>
      navInvoices?: Maybe<ResolversTypes['NavInvoiceWithPagination']>
      orderFilter?: Maybe<ResolversTypes['OrderWithPagination']>
      orderFind?: Maybe<ResolversTypes['OrderDetailed']>
      orders?: Maybe<Array<ResolversTypes['Order']>>
      retrieveAnnualPlan: Array<ResolversTypes['Order']>
      teams?: Maybe<Array<Maybe<ResolversTypes['Team']>>>
    }
  >
  UserAttachAvatarPayload: ResolverTypeWrapper<
    Omit<UserAttachAvatarPayload, 'result'> & {
      result?: Maybe<ResolversTypes['User']>
    }
  >
  UserAttributes: UserAttributes
  UserCreateAttributes: UserCreateAttributes
  UserCreatePayload: ResolverTypeWrapper<
    Omit<UserCreatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['User']>
    }
  >
  UserEdge: ResolverTypeWrapper<
    Omit<UserEdge, 'node'> & { node?: Maybe<ResolversTypes['User']> }
  >
  UserMovePayload: ResolverTypeWrapper<
    Omit<UserMovePayload, 'result'> & { result?: Maybe<ResolversTypes['User']> }
  >
  UserReassignAccountPayload: ResolverTypeWrapper<
    Omit<UserReassignAccountPayload, 'result'> & {
      result?: Maybe<ResolversTypes['User']>
    }
  >
  UserRolesEnum: UserRolesEnum
  UserSetBranchesPayload: ResolverTypeWrapper<
    Omit<UserSetBranchesPayload, 'result'> & {
      result?: Maybe<ResolversTypes['User']>
    }
  >
  UserUpdatePayload: ResolverTypeWrapper<
    Omit<UserUpdatePayload, 'result'> & {
      result?: Maybe<ResolversTypes['User']>
    }
  >
  UserWithPagination: ResolverTypeWrapper<
    Omit<UserWithPagination, 'edges' | 'nodes'> & {
      edges?: Maybe<Array<Maybe<ResolversTypes['UserEdge']>>>
      nodes?: Maybe<Array<Maybe<ResolversTypes['User']>>>
    }
  >
}

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AcceptTermsPayload: Omit<AcceptTermsPayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['User']>
  }
  Account: Omit<
    Account,
    | 'accountProducts'
    | 'branches'
    | 'divisions'
    | 'productsCheckoutable'
    | 'productsOrderable'
    | 'users'
  > & {
    accountProducts?: Maybe<Array<Maybe<ResolversParentTypes['ProductsUnion']>>>
    branches?: Maybe<Array<ResolversParentTypes['Branch']>>
    divisions?: Maybe<Array<ResolversParentTypes['Division']>>
    productsCheckoutable?: Maybe<
      Array<Maybe<ResolversParentTypes['DivisionsProduct']>>
    >
    productsOrderable?: Maybe<
      Array<Maybe<ResolversParentTypes['AccountsProduct']>>
    >
    users?: Maybe<Array<ResolversParentTypes['User']>>
  }
  AccountAssignmentInput: AccountAssignmentInput
  AccountBase: AccountBase
  AccountBaseAttributes: AccountBaseAttributes
  AccountEdge: Omit<AccountEdge, 'node'> & {
    node?: Maybe<ResolversParentTypes['Account']>
  }
  AccountSyncJob: AccountSyncJob
  AccountUpdatePayload: Omit<AccountUpdatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Account']>
  }
  AccountWithPagination: Omit<AccountWithPagination, 'edges' | 'nodes'> & {
    edges?: Maybe<Array<Maybe<ResolversParentTypes['AccountEdge']>>>
    nodes?: Maybe<Array<Maybe<ResolversParentTypes['Account']>>>
  }
  AccountsProduct: Omit<AccountsProduct, 'branchesProduct'> & {
    branchesProduct?: Maybe<ResolversParentTypes['BranchesProduct']>
  }
  AddPlanProductPayload: AddPlanProductPayload
  AddPlanProductResult: AddPlanProductResult
  AddPlanProductsFromInventoryPayload: Omit<
    AddPlanProductsFromInventoryPayload,
    'result'
  > & { result?: Maybe<Array<Maybe<ResolversParentTypes['OrderItem']>>> }
  AssignMultipleAccountsPayload: Omit<
    AssignMultipleAccountsPayload,
    'result'
  > & { result?: Maybe<ResolversParentTypes['User']> }
  Boolean: Scalars['Boolean']['output']
  Branch: Omit<
    Branch,
    | 'account'
    | 'cartItems'
    | 'checkoutUsers'
    | 'checkouts'
    | 'divisions'
    | 'inventoryProducts'
    | 'locationAssignableUsers'
    | 'managers'
    | 'orders'
    | 'plannedProducts'
    | 'planners'
    | 'sanaLoginManager'
    | 'suggestedCartItems'
    | 'teams'
    | 'technicians'
    | 'users'
  > & {
    account: ResolversParentTypes['AccountBase']
    cartItems?: Maybe<Array<ResolversParentTypes['CartItem']>>
    checkoutUsers?: Maybe<Array<ResolversParentTypes['User']>>
    checkouts?: Maybe<Array<ResolversParentTypes['Checkout']>>
    divisions?: Maybe<Array<ResolversParentTypes['Division']>>
    inventoryProducts?: Maybe<
      Array<Maybe<ResolversParentTypes['InventoryProduct']>>
    >
    locationAssignableUsers?: Maybe<Array<ResolversParentTypes['User']>>
    managers?: Maybe<Array<ResolversParentTypes['User']>>
    orders?: Maybe<Array<ResolversParentTypes['Order']>>
    plannedProducts?: Maybe<
      Array<Maybe<ResolversParentTypes['AccountsProduct']>>
    >
    planners?: Maybe<Array<ResolversParentTypes['User']>>
    sanaLoginManager?: Maybe<ResolversParentTypes['User']>
    suggestedCartItems?: Maybe<Array<ResolversParentTypes['CartItem']>>
    teams?: Maybe<Array<ResolversParentTypes['Team']>>
    technicians?: Maybe<Array<ResolversParentTypes['User']>>
    users?: Maybe<Array<ResolversParentTypes['User']>>
  }
  BranchBinLocationItem: BranchBinLocationItem
  BranchCreateAttributes: BranchCreateAttributes
  BranchCreatePayload: Omit<BranchCreatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Branch']>
  }
  BranchDeletePayload: Omit<BranchDeletePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Branch']>
  }
  BranchTruckInventoryInput: BranchTruckInventoryInput
  BranchUpdateAttributes: BranchUpdateAttributes
  BranchUpdatePayload: Omit<BranchUpdatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Branch']>
  }
  BranchesProduct: Omit<BranchesProduct, 'locationItems'> & {
    locationItems: Array<ResolversParentTypes['LocationItem']>
  }
  BranchesSalableProduct: Omit<BranchesSalableProduct, 'branch'> & {
    branch: ResolversParentTypes['Branch']
  }
  CartBranchUpdateAttributes: CartBranchUpdateAttributes
  CartBranchUpdatePayload: Omit<CartBranchUpdatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Branch']>
  }
  CartItem: Omit<CartItem, 'updatedBy'> & {
    updatedBy: ResolversParentTypes['User']
  }
  CartItemCreateAttributes: CartItemCreateAttributes
  CartItemCreatePayload: Omit<CartItemCreatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['CartItem']>
  }
  CartItemUpdateAttributes: CartItemUpdateAttributes
  CartItemUpdatePayload: Omit<CartItemUpdatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['CartItem']>
  }
  Checkout: Omit<
    Checkout,
    'consumer' | 'openedBy' | 'technician' | 'updatedBy'
  > & {
    consumer: ResolversParentTypes['User']
    openedBy?: Maybe<ResolversParentTypes['User']>
    technician?: Maybe<ResolversParentTypes['User']>
    updatedBy: ResolversParentTypes['User']
  }
  CheckoutAttributes: CheckoutAttributes
  CheckoutCancelAttributes: CheckoutCancelAttributes
  CheckoutCancelPayload: Omit<CheckoutCancelPayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Checkout']>
  }
  CheckoutCompletePayload: Omit<CheckoutCompletePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Checkout']>
  }
  CheckoutCreatePayload: Omit<CheckoutCreatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Checkout']>
  }
  CheckoutItem: CheckoutItem
  CheckoutItemBaseAttributes: CheckoutItemBaseAttributes
  CheckoutItemCreateAttributes: CheckoutItemCreateAttributes
  CheckoutItemCreatePayload: CheckoutItemCreatePayload
  CheckoutItemDepletion: CheckoutItemDepletion
  CheckoutItemDepletionInput: CheckoutItemDepletionInput
  CheckoutItemRemovePayload: CheckoutItemRemovePayload
  CheckoutItemUpdateAttributes: CheckoutItemUpdateAttributes
  CheckoutItemUpdatePayload: CheckoutItemUpdatePayload
  CheckoutRecallPayload: Omit<CheckoutRecallPayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Checkout']>
  }
  CheckoutRemovePayload: CheckoutRemovePayload
  CheckoutReopenPayload: Omit<CheckoutReopenPayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Checkout']>
  }
  CheckoutSubmitPayload: Omit<CheckoutSubmitPayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Checkout']>
  }
  CycleCount: Omit<
    CycleCount,
    | 'account'
    | 'completedBy'
    | 'countedBy'
    | 'cycleCountItems'
    | 'location'
    | 'rejectedBy'
  > & {
    account: ResolversParentTypes['Account']
    completedBy?: Maybe<ResolversParentTypes['User']>
    countedBy: ResolversParentTypes['User']
    cycleCountItems: Array<ResolversParentTypes['CycleCountItem']>
    location: ResolversParentTypes['Location']
    rejectedBy?: Maybe<ResolversParentTypes['User']>
  }
  CycleCountCreateAttributes: CycleCountCreateAttributes
  CycleCountCreatePayload: Omit<CycleCountCreatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['CycleCount']>
  }
  CycleCountItem: Omit<CycleCountItem, 'cycleCount' | 'locationItem'> & {
    cycleCount: ResolversParentTypes['CycleCount']
    locationItem: ResolversParentTypes['LocationItem']
  }
  CycleCountItemCreateAttributes: CycleCountItemCreateAttributes
  CycleCountItemUpdateAttributes: CycleCountItemUpdateAttributes
  CycleCountItemsUpdatePayload: Omit<CycleCountItemsUpdatePayload, 'result'> & {
    result?: Maybe<Array<ResolversParentTypes['CycleCountItem']>>
  }
  CycleCountRecountPayload: Omit<CycleCountRecountPayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['CycleCount']>
  }
  CycleCountUpdateAttributes: CycleCountUpdateAttributes
  CycleCountUpdatePayload: Omit<CycleCountUpdatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['CycleCount']>
  }
  Decimal: Scalars['Decimal']['output']
  DestinationTransfer: DestinationTransfer
  Division: Omit<
    Division,
    'checkoutableProducts' | 'inventoryProducts' | 'products' | 'technicians'
  > & {
    checkoutableProducts?: Maybe<
      Array<Maybe<ResolversParentTypes['DivisionsProduct']>>
    >
    inventoryProducts?: Maybe<
      Array<Maybe<ResolversParentTypes['InventoryProduct']>>
    >
    products?: Maybe<Array<Maybe<ResolversParentTypes['DivisionsProduct']>>>
    technicians?: Maybe<Array<ResolversParentTypes['User']>>
  }
  DivisionBaseAttributes: DivisionBaseAttributes
  DivisionCreateAttributes: DivisionCreateAttributes
  DivisionCreatePayload: Omit<DivisionCreatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Division']>
  }
  DivisionRemovePayload: DivisionRemovePayload
  DivisionUpdatePayload: Omit<DivisionUpdatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Division']>
  }
  DivisionsProduct: Omit<DivisionsProduct, 'branchesProduct'> & {
    branchesProduct?: Maybe<ResolversParentTypes['BranchesProduct']>
  }
  EnsureBranchPayload: Omit<EnsureBranchPayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Branch']>
  }
  Float: Scalars['Float']['output']
  Forecast: Forecast
  GenerateAppLoginTokenPayload: GenerateAppLoginTokenPayload
  GenericProduct: Omit<GenericProduct, 'branchesProduct'> & {
    branchesProduct?: Maybe<ResolversParentTypes['BranchesProduct']>
  }
  ID: Scalars['ID']['output']
  ISO8601Date: Scalars['ISO8601Date']['output']
  ISO8601DateOnly: Scalars['ISO8601DateOnly']['output']
  ISO8601DateTime: Scalars['ISO8601DateTime']['output']
  ImpersonateUserPayload: ImpersonateUserPayload
  InboundApproveAttributes: InboundApproveAttributes
  InboundInventory: InboundInventory
  InboundInventoryApprovePayload: InboundInventoryApprovePayload
  Int: Scalars['Int']['output']
  InventoryEvent: Omit<InventoryEvent, 'createdByUser'> & {
    createdByUser?: Maybe<ResolversParentTypes['User']>
  }
  InventoryEventEdge: Omit<InventoryEventEdge, 'node'> & {
    node?: Maybe<ResolversParentTypes['InventoryEvent']>
  }
  InventoryEventWithPagination: Omit<
    InventoryEventWithPagination,
    'edges' | 'nodes'
  > & {
    edges?: Maybe<Array<Maybe<ResolversParentTypes['InventoryEventEdge']>>>
    nodes?: Maybe<Array<Maybe<ResolversParentTypes['InventoryEvent']>>>
  }
  InventoryProduct: Omit<
    InventoryProduct,
    'divisions' | 'inventoryEvents' | 'locationItems'
  > & {
    divisions?: Maybe<Array<Maybe<ResolversParentTypes['Division']>>>
    inventoryEvents?: Maybe<
      ResolversParentTypes['InventoryEventWithPagination']
    >
    locationItems: Array<ResolversParentTypes['LocationItem']>
  }
  InventoryProductCreateAttributes: InventoryProductCreateAttributes
  InventoryProductCreatePayload: Omit<
    InventoryProductCreatePayload,
    'result'
  > & { result?: Maybe<ResolversParentTypes['InventoryProduct']> }
  InventoryProductRemovePayload: InventoryProductRemovePayload
  InventoryProductTransferAttributes: InventoryProductTransferAttributes
  InventoryProductTransferPayload: Omit<
    InventoryProductTransferPayload,
    'result'
  > & { result?: Maybe<ResolversParentTypes['InventoryProduct']> }
  InventoryProductUpdateAttributes: InventoryProductUpdateAttributes
  InventoryProductUpdatePayload: Omit<
    InventoryProductUpdatePayload,
    'result'
  > & { result?: Maybe<ResolversParentTypes['InventoryProduct']> }
  JSON: Scalars['JSON']['output']
  LoadAccountsCsvPayload: Omit<LoadAccountsCsvPayload, 'result'> & {
    result?: Maybe<Array<Maybe<ResolversParentTypes['Account']>>>
  }
  LoadBranchesCsvPayload: Omit<LoadBranchesCsvPayload, 'result'> & {
    result?: Maybe<Array<Maybe<ResolversParentTypes['Branch']>>>
  }
  LoadDivisionProductsCsvPayload: Omit<
    LoadDivisionProductsCsvPayload,
    'result'
  > & { result?: Maybe<Array<Maybe<ResolversParentTypes['GenericProduct']>>> }
  LoadLocationsCsvPayload: Omit<LoadLocationsCsvPayload, 'result'> & {
    result?: Maybe<Array<Maybe<ResolversParentTypes['Location']>>>
  }
  LoadShipmentsCsvPayload: LoadShipmentsCsvPayload
  LoadUsersCsvPayload: LoadUsersCsvPayload
  Location: Omit<
    Location,
    | 'branches'
    | 'latestCycleCount'
    | 'latestMove'
    | 'locationItems'
    | 'lowStockLocationItems'
    | 'updatedBy'
    | 'user'
  > & {
    branches: Array<ResolversParentTypes['Branch']>
    latestCycleCount?: Maybe<ResolversParentTypes['CycleCount']>
    latestMove?: Maybe<ResolversParentTypes['Move']>
    locationItems: Array<ResolversParentTypes['LocationItem']>
    lowStockLocationItems: Array<ResolversParentTypes['LocationItem']>
    updatedBy?: Maybe<ResolversParentTypes['User']>
    user?: Maybe<ResolversParentTypes['User']>
  }
  LocationCreateAttributes: LocationCreateAttributes
  LocationCreatePayload: Omit<LocationCreatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Location']>
  }
  LocationDeletePayload: LocationDeletePayload
  LocationItem: Omit<LocationItem, 'location' | 'updatedBy'> & {
    location: ResolversParentTypes['Location']
    updatedBy?: Maybe<ResolversParentTypes['User']>
  }
  LocationItemCreateAttributes: LocationItemCreateAttributes
  LocationItemCreatePayload: Omit<LocationItemCreatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['LocationItem']>
  }
  LocationItemDeletePayload: Omit<LocationItemDeletePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['LocationItem']>
  }
  LocationItemUpdateAttributes: LocationItemUpdateAttributes
  LocationItemUpdatePayload: Omit<LocationItemUpdatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['LocationItem']>
  }
  LocationUpdateAttributes: LocationUpdateAttributes
  LocationUpdatePayload: Omit<LocationUpdatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Location']>
  }
  ManagerAttributes: ManagerAttributes
  ManagerUpdatePayload: ManagerUpdatePayload
  Message: Message
  MessageArchivePayload: MessageArchivePayload
  MessageMarkReadPayload: Omit<MessageMarkReadPayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['MessageRead']>
  }
  MessagePublishPayload: MessagePublishPayload
  MessageRead: Omit<MessageRead, 'user'> & {
    user: ResolversParentTypes['User']
  }
  MessageUpdatePayload: MessageUpdatePayload
  Money: Scalars['Money']['output']
  Move: Omit<
    Move,
    | 'account'
    | 'canceledBy'
    | 'completedBy'
    | 'fromLocation'
    | 'moveItems'
    | 'movedBy'
    | 'rejectedBy'
    | 'toBranch'
    | 'toLocation'
  > & {
    account: ResolversParentTypes['Account']
    canceledBy?: Maybe<ResolversParentTypes['User']>
    completedBy?: Maybe<ResolversParentTypes['User']>
    fromLocation: ResolversParentTypes['Location']
    moveItems: Array<ResolversParentTypes['MoveItem']>
    movedBy: ResolversParentTypes['User']
    rejectedBy?: Maybe<ResolversParentTypes['User']>
    toBranch?: Maybe<ResolversParentTypes['Branch']>
    toLocation?: Maybe<ResolversParentTypes['Location']>
  }
  MoveCreateAttributes: MoveCreateAttributes
  MoveCreatePayload: Omit<MoveCreatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Move']>
  }
  MoveItem: Omit<MoveItem, 'locationItem' | 'move' | 'toLocation'> & {
    locationItem: ResolversParentTypes['LocationItem']
    move: ResolversParentTypes['Move']
    toLocation?: Maybe<ResolversParentTypes['Location']>
  }
  MoveItemCreateAttributes: MoveItemCreateAttributes
  MoveUpdateAttributes: MoveUpdateAttributes
  MoveUpdatePayload: Omit<MoveUpdatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Move']>
  }
  Mutation: {}
  NavInvoice: Omit<NavInvoice, 'manualBranch'> & {
    manualBranch?: Maybe<ResolversParentTypes['Branch']>
  }
  NavInvoiceCounts: NavInvoiceCounts
  NavInvoiceEdge: Omit<NavInvoiceEdge, 'node'> & {
    node?: Maybe<ResolversParentTypes['NavInvoice']>
  }
  NavInvoiceIgnorePayload: Omit<NavInvoiceIgnorePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['NavInvoice']>
  }
  NavInvoiceMapPayload: Omit<NavInvoiceMapPayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['NavInvoice']>
  }
  NavInvoiceWithPagination: Omit<
    NavInvoiceWithPagination,
    'edges' | 'nodes'
  > & {
    edges?: Maybe<Array<Maybe<ResolversParentTypes['NavInvoiceEdge']>>>
    nodes?: Maybe<Array<Maybe<ResolversParentTypes['NavInvoice']>>>
  }
  NewProductTagInput: NewProductTagInput
  Order: Omit<
    Order,
    | 'account'
    | 'approvedBy'
    | 'branch'
    | 'createdBy'
    | 'orderItems'
    | 'rejectedBy'
    | 'requestedBy'
    | 'submittedBy'
    | 'updatedBy'
  > & {
    account: ResolversParentTypes['Account']
    approvedBy?: Maybe<ResolversParentTypes['User']>
    branch: ResolversParentTypes['Branch']
    createdBy?: Maybe<ResolversParentTypes['User']>
    orderItems?: Maybe<Array<ResolversParentTypes['OrderItem']>>
    rejectedBy?: Maybe<ResolversParentTypes['User']>
    requestedBy?: Maybe<ResolversParentTypes['User']>
    submittedBy?: Maybe<ResolversParentTypes['User']>
    updatedBy?: Maybe<ResolversParentTypes['User']>
  }
  OrderApprovePayload: Omit<OrderApprovePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Order']>
  }
  OrderDetailed: Omit<
    OrderDetailed,
    | 'account'
    | 'approvedBy'
    | 'branch'
    | 'createdBy'
    | 'orderItems'
    | 'rejectedBy'
    | 'requestedBy'
    | 'submittedBy'
    | 'updatedBy'
  > & {
    account: ResolversParentTypes['Account']
    approvedBy?: Maybe<ResolversParentTypes['User']>
    branch: ResolversParentTypes['Branch']
    createdBy?: Maybe<ResolversParentTypes['User']>
    orderItems?: Maybe<Array<ResolversParentTypes['OrderItem']>>
    rejectedBy?: Maybe<ResolversParentTypes['User']>
    requestedBy?: Maybe<ResolversParentTypes['User']>
    submittedBy?: Maybe<ResolversParentTypes['User']>
    updatedBy?: Maybe<ResolversParentTypes['User']>
  }
  OrderEdge: Omit<OrderEdge, 'node'> & {
    node?: Maybe<ResolversParentTypes['Order']>
  }
  OrderItem: Omit<OrderItem, 'updatedBy'> & {
    updatedBy: ResolversParentTypes['User']
  }
  OrderItemCreateAttributes: OrderItemCreateAttributes
  OrderItemCreatePayload: Omit<OrderItemCreatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['OrderItem']>
  }
  OrderItemUpdateAttributes: OrderItemUpdateAttributes
  OrderItemUpdatePayload: Omit<OrderItemUpdatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['OrderItem']>
  }
  OrderRejectAttributes: OrderRejectAttributes
  OrderRejectPayload: Omit<OrderRejectPayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Order']>
  }
  OrderRequestFromCartPayload: Omit<OrderRequestFromCartPayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Order']>
  }
  OrderRequestPayload: Omit<OrderRequestPayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Order']>
  }
  OrderRequestTrackingInfoPayload: OrderRequestTrackingInfoPayload
  OrderSubmitFromCartPayload: Omit<OrderSubmitFromCartPayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Order']>
  }
  OrderSubmitPayload: Omit<OrderSubmitPayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Order']>
  }
  OrderTrackingStatus: OrderTrackingStatus
  OrderUpdateAttributes: OrderUpdateAttributes
  OrderUpdatePayload: Omit<OrderUpdatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Order']>
  }
  OrderWithPagination: Omit<OrderWithPagination, 'edges' | 'nodes'> & {
    edges?: Maybe<Array<Maybe<ResolversParentTypes['OrderEdge']>>>
    nodes?: Maybe<Array<Maybe<ResolversParentTypes['Order']>>>
  }
  OrdersStats: OrdersStats
  PageInfo: PageInfo
  PlanItem: PlanItem
  Product: Product
  ProductCategory: ProductCategory
  ProductGroup: ProductGroup
  ProductTag: ProductTag
  ProductTagCreatePayload: ProductTagCreatePayload
  ProductTagDeletePayload: ProductTagDeletePayload
  ProductTagUpdatePayload: ProductTagUpdatePayload
  ProductsUnion: ResolversUnionTypes<ResolversParentTypes>['ProductsUnion']
  Query: {}
  RemoveBranchesSalableProductPayload: RemoveBranchesSalableProductPayload
  RemovePlanProductPayload: RemovePlanProductPayload
  RemovedOrderItem: RemovedOrderItem
  ReplenishmentPlanExport: ReplenishmentPlanExport
  ReplenishmentPlanItemSpecifyPayload: ReplenishmentPlanItemSpecifyPayload
  ReplenishmentPlanProductReplacePayload: Omit<
    ReplenishmentPlanProductReplacePayload,
    'result'
  > & { result?: Maybe<ResolversParentTypes['BranchesSalableProduct']> }
  SalableProductData: SalableProductData
  SanaPasswordRotatePayload: SanaPasswordRotatePayload
  SanaPasswordSetManualPayload: SanaPasswordSetManualPayload
  ScheduleAccountSyncPayload: ScheduleAccountSyncPayload
  ScheduleBranchSyncPayload: ScheduleBranchSyncPayload
  ScheduleProductsUpdatePayload: ScheduleProductsUpdatePayload
  Shipment: Shipment
  ShippedProduct: ShippedProduct
  Species: Species
  SpeciesSetGroupPayload: SpeciesSetGroupPayload
  String: Scalars['String']['output']
  SubmittedItem: SubmittedItem
  Team: Omit<Team, 'technicians'> & {
    technicians?: Maybe<Array<ResolversParentTypes['User']>>
  }
  TeamBaseAttributes: TeamBaseAttributes
  TeamCreateAttributes: TeamCreateAttributes
  TeamCreatePayload: Omit<TeamCreatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Team']>
  }
  TeamRemovePayload: TeamRemovePayload
  TeamUpdatePayload: Omit<TeamUpdatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['Team']>
  }
  TechnicianAttributes: TechnicianAttributes
  TechnicianCreateAttributes: TechnicianCreateAttributes
  TechnicianCreatePayload: Omit<TechnicianCreatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['User']>
  }
  TechnicianMovePayload: TechnicianMovePayload
  TechnicianRemovePayload: TechnicianRemovePayload
  TechnicianUpdatePayload: Omit<TechnicianUpdatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['User']>
  }
  UpdateDeviceInfoPayload: UpdateDeviceInfoPayload
  User: Omit<
    User,
    | 'account'
    | 'accountUsers'
    | 'accounts'
    | 'availableAccounts'
    | 'bins'
    | 'branches'
    | 'checkoutUsers'
    | 'checkouts'
    | 'clonedUsers'
    | 'defaultBin'
    | 'divisions'
    | 'internals'
    | 'inventoryProducts'
    | 'location'
    | 'navInvoiceBranches'
    | 'navInvoices'
    | 'orderFilter'
    | 'orderFind'
    | 'orders'
    | 'retrieveAnnualPlan'
    | 'teams'
  > & {
    account?: Maybe<ResolversParentTypes['Account']>
    accountUsers?: Maybe<ResolversParentTypes['UserWithPagination']>
    accounts?: Maybe<ResolversParentTypes['AccountWithPagination']>
    availableAccounts?: Maybe<Array<Maybe<ResolversParentTypes['Account']>>>
    bins?: Maybe<Array<ResolversParentTypes['Location']>>
    branches?: Maybe<Array<Maybe<ResolversParentTypes['Branch']>>>
    checkoutUsers?: Maybe<Array<Maybe<ResolversParentTypes['User']>>>
    checkouts?: Maybe<Array<Maybe<ResolversParentTypes['Checkout']>>>
    clonedUsers?: Maybe<Array<Maybe<ResolversParentTypes['User']>>>
    defaultBin?: Maybe<ResolversParentTypes['Location']>
    divisions?: Maybe<Array<Maybe<ResolversParentTypes['Division']>>>
    internals?: Maybe<ResolversParentTypes['UserWithPagination']>
    inventoryProducts?: Maybe<
      Array<Maybe<ResolversParentTypes['InventoryProduct']>>
    >
    location?: Maybe<ResolversParentTypes['Location']>
    navInvoiceBranches?: Maybe<Array<ResolversParentTypes['Branch']>>
    navInvoices?: Maybe<ResolversParentTypes['NavInvoiceWithPagination']>
    orderFilter?: Maybe<ResolversParentTypes['OrderWithPagination']>
    orderFind?: Maybe<ResolversParentTypes['OrderDetailed']>
    orders?: Maybe<Array<ResolversParentTypes['Order']>>
    retrieveAnnualPlan: Array<ResolversParentTypes['Order']>
    teams?: Maybe<Array<Maybe<ResolversParentTypes['Team']>>>
  }
  UserAttachAvatarPayload: Omit<UserAttachAvatarPayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['User']>
  }
  UserAttributes: UserAttributes
  UserCreateAttributes: UserCreateAttributes
  UserCreatePayload: Omit<UserCreatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['User']>
  }
  UserEdge: Omit<UserEdge, 'node'> & {
    node?: Maybe<ResolversParentTypes['User']>
  }
  UserMovePayload: Omit<UserMovePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['User']>
  }
  UserReassignAccountPayload: Omit<UserReassignAccountPayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['User']>
  }
  UserSetBranchesPayload: Omit<UserSetBranchesPayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['User']>
  }
  UserUpdatePayload: Omit<UserUpdatePayload, 'result'> & {
    result?: Maybe<ResolversParentTypes['User']>
  }
  UserWithPagination: Omit<UserWithPagination, 'edges' | 'nodes'> & {
    edges?: Maybe<Array<Maybe<ResolversParentTypes['UserEdge']>>>
    nodes?: Maybe<Array<Maybe<ResolversParentTypes['User']>>>
  }
}

export type AcceptTermsPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['AcceptTermsPayload'] = ResolversParentTypes['AcceptTermsPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AccountResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['Account'] = ResolversParentTypes['Account'],
> = {
  accountProducts?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['ProductsUnion']>>>,
    ParentType,
    ContextType
  >
  accountProductsDigest?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType
  >
  assistantOptOut?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  assistantOptOutReason?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  assistantOptedOutAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  binInventoryFeature?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >
  branches?: Resolver<
    Maybe<Array<ResolversTypes['Branch']>>,
    ParentType,
    ContextType,
    Partial<AccountBranchesArgs>
  >
  branchesCatalog?: Resolver<
    Array<ResolversTypes['Product']>,
    ParentType,
    ContextType,
    RequireFields<AccountBranchesCatalogArgs, 'branchId'>
  >
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  distributorsList?: Resolver<
    Maybe<Array<ResolversTypes['String']>>,
    ParentType,
    ContextType
  >
  divisions?: Resolver<
    Maybe<Array<ResolversTypes['Division']>>,
    ParentType,
    ContextType,
    Partial<AccountDivisionsArgs>
  >
  erpCatalogs?: Resolver<
    Array<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  erpOrders?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  hasInvoices?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  lastSync?: Resolver<
    Maybe<ResolversTypes['AccountSyncJob']>,
    ParentType,
    ContextType
  >
  live?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  navAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  navAccountName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  navSalesCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  orderApproveFlow?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >
  ordersEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  productsCheckoutable?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['DivisionsProduct']>>>,
    ParentType,
    ContextType,
    Partial<AccountProductsCheckoutableArgs>
  >
  productsOrderable?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['AccountsProduct']>>>,
    ParentType,
    ContextType,
    Partial<AccountProductsOrderableArgs>
  >
  salableCatalog?: Resolver<
    Array<ResolversTypes['Product']>,
    ParentType,
    ContextType,
    RequireFields<AccountSalableCatalogArgs, 'branchId'>
  >
  truckInventoryFeature?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  users?: Resolver<
    Maybe<Array<ResolversTypes['User']>>,
    ParentType,
    ContextType,
    Partial<AccountUsersArgs>
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AccountBaseResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['AccountBase'] = ResolversParentTypes['AccountBase'],
> = {
  binInventoryFeature?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  erpCatalogs?: Resolver<
    Array<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  erpOrders?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  hasInvoices?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  orderApproveFlow?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >
  ordersEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  truckInventoryFeature?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AccountEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['AccountEdge'] = ResolversParentTypes['AccountEdge'],
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  node?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AccountSyncJobResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['AccountSyncJob'] = ResolversParentTypes['AccountSyncJob'],
> = {
  accountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  finishedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  jobId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  queueName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  startedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  status?: Resolver<
    ResolversTypes['AccountSyncJobStatusesEnum'],
    ParentType,
    ContextType
  >
  syncErrors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AccountUpdatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['AccountUpdatePayload'] = ResolversParentTypes['AccountUpdatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AccountWithPaginationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['AccountWithPagination'] = ResolversParentTypes['AccountWithPagination'],
> = {
  edges?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['AccountEdge']>>>,
    ParentType,
    ContextType
  >
  nodes?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Account']>>>,
    ParentType,
    ContextType
  >
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>
  totalItems?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AccountsProductResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['AccountsProduct'] = ResolversParentTypes['AccountsProduct'],
> = {
  accountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  branchesProduct?: Resolver<
    Maybe<ResolversTypes['BranchesProduct']>,
    ParentType,
    ContextType
  >
  caseQuantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  category?: Resolver<
    Maybe<ResolversTypes['ProductCategory']>,
    ParentType,
    ContextType
  >
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  custom?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  distributor?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  erpCatalogName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  group?: Resolver<
    Maybe<ResolversTypes['ProductGroup']>,
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  kind?: Resolver<
    ResolversTypes['GenericProductKindsEnum'],
    ParentType,
    ContextType
  >
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  palletQuantity?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  photo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  price?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>
  quantity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  salesUnit?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  speciesIds?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>
  stockInventory?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  stockState?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  unavailable?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AddPlanProductPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['AddPlanProductPayload'] = ResolversParentTypes['AddPlanProductPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<ResolversTypes['AddPlanProductResult']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AddPlanProductResultResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['AddPlanProductResult'] = ResolversParentTypes['AddPlanProductResult'],
> = {
  salableProductId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AddPlanProductsFromInventoryPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['AddPlanProductsFromInventoryPayload'] = ResolversParentTypes['AddPlanProductsFromInventoryPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['OrderItem']>>>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type AssignMultipleAccountsPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['AssignMultipleAccountsPayload'] = ResolversParentTypes['AssignMultipleAccountsPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BranchResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['Branch'] = ResolversParentTypes['Branch'],
> = {
  account?: Resolver<ResolversTypes['AccountBase'], ParentType, ContextType>
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  address2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  binInventoryFeature?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >
  cartItems?: Resolver<
    Maybe<Array<ResolversTypes['CartItem']>>,
    ParentType,
    ContextType
  >
  checkoutUsers?: Resolver<
    Maybe<Array<ResolversTypes['User']>>,
    ParentType,
    ContextType,
    Partial<BranchCheckoutUsersArgs>
  >
  checkouts?: Resolver<
    Maybe<Array<ResolversTypes['Checkout']>>,
    ParentType,
    ContextType,
    Partial<BranchCheckoutsArgs>
  >
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  destinationTransfers?: Resolver<
    Maybe<Array<ResolversTypes['DestinationTransfer']>>,
    ParentType,
    ContextType,
    Partial<BranchDestinationTransfersArgs>
  >
  divisions?: Resolver<
    Maybe<Array<ResolversTypes['Division']>>,
    ParentType,
    ContextType,
    Partial<BranchDivisionsArgs>
  >
  forecasts?: Resolver<
    Maybe<Array<ResolversTypes['Forecast']>>,
    ParentType,
    ContextType,
    Partial<BranchForecastsArgs>
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  inboundInventories?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['InboundInventory']>>>,
    ParentType,
    ContextType
  >
  inventoryProducts?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['InventoryProduct']>>>,
    ParentType,
    ContextType,
    Partial<BranchInventoryProductsArgs>
  >
  invoiceMappingRow?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  lastSync?: Resolver<
    Maybe<ResolversTypes['AccountSyncJob']>,
    ParentType,
    ContextType
  >
  locationAssignableUsers?: Resolver<
    Maybe<Array<ResolversTypes['User']>>,
    ParentType,
    ContextType
  >
  managers?: Resolver<
    Maybe<Array<ResolversTypes['User']>>,
    ParentType,
    ContextType,
    Partial<BranchManagersArgs>
  >
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  navId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  orders?: Resolver<
    Maybe<Array<ResolversTypes['Order']>>,
    ParentType,
    ContextType,
    Partial<BranchOrdersArgs>
  >
  plannedProducts?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['AccountsProduct']>>>,
    ParentType,
    ContextType,
    Partial<BranchPlannedProductsArgs>
  >
  plannedProductsCount?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  planners?: Resolver<
    Maybe<Array<ResolversTypes['User']>>,
    ParentType,
    ContextType,
    Partial<BranchPlannersArgs>
  >
  productTags?: Resolver<
    Array<ResolversTypes['ProductTag']>,
    ParentType,
    ContextType
  >
  purchaseOrderNumber?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  replenishmentFile?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  sanaLoginManager?: Resolver<
    Maybe<ResolversTypes['User']>,
    ParentType,
    ContextType
  >
  sanaLoginManagerId?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  shipToCode?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  shipmentApproveFlow?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >
  shipments?: Resolver<
    Maybe<Array<ResolversTypes['Shipment']>>,
    ParentType,
    ContextType,
    Partial<BranchShipmentsArgs>
  >
  showTechPrice?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  suggestedCartItems?: Resolver<
    Maybe<Array<ResolversTypes['CartItem']>>,
    ParentType,
    ContextType
  >
  teams?: Resolver<
    Maybe<Array<ResolversTypes['Team']>>,
    ParentType,
    ContextType,
    Partial<BranchTeamsArgs>
  >
  technicians?: Resolver<
    Maybe<Array<ResolversTypes['User']>>,
    ParentType,
    ContextType,
    Partial<BranchTechniciansArgs>
  >
  truckInventoryFeature?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >
  untaggedProductsCount?: Resolver<
    ResolversTypes['Int'],
    ParentType,
    ContextType
  >
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  users?: Resolver<
    Maybe<Array<ResolversTypes['User']>>,
    ParentType,
    ContextType,
    Partial<BranchUsersArgs>
  >
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BranchBinLocationItemResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BranchBinLocationItem'] = ResolversParentTypes['BranchBinLocationItem'],
> = {
  inventory?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  isDefault?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  lastCycleCountAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  locationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  locationItemId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  pendingCycleCount?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >
  price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>
  unit?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BranchCreatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BranchCreatePayload'] = ResolversParentTypes['BranchCreatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Branch']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BranchDeletePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BranchDeletePayload'] = ResolversParentTypes['BranchDeletePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Branch']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BranchUpdatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BranchUpdatePayload'] = ResolversParentTypes['BranchUpdatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Branch']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BranchesProductResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BranchesProduct'] = ResolversParentTypes['BranchesProduct'],
> = {
  binLocationThreshold?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  locationItems?: Resolver<
    Array<ResolversTypes['LocationItem']>,
    ParentType,
    ContextType
  >
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  technicianThreshold?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  truckLocationThreshold?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  unit?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type BranchesSalableProductResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['BranchesSalableProduct'] = ResolversParentTypes['BranchesSalableProduct'],
> = {
  branch?: Resolver<ResolversTypes['Branch'], ParentType, ContextType>
  branchId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  product?: Resolver<ResolversTypes['Product'], ParentType, ContextType>
  salableProductId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CartBranchUpdatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CartBranchUpdatePayload'] = ResolversParentTypes['CartBranchUpdatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Branch']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CartItemResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CartItem'] = ResolversParentTypes['CartItem'],
> = {
  amountPlanned?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  amountRequested?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  branchId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  createdAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  effectivePrice?: Resolver<
    Maybe<ResolversTypes['Money']>,
    ParentType,
    ContextType
  >
  effectiveUnit?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  price?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>
  product?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType>
  productId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  suggestion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  updatedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  updatedBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CartItemCreatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CartItemCreatePayload'] = ResolversParentTypes['CartItemCreatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['CartItem']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CartItemUpdatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CartItemUpdatePayload'] = ResolversParentTypes['CartItemUpdatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['CartItem']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CheckoutResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['Checkout'] = ResolversParentTypes['Checkout'],
> = {
  asap?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  branchId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  checkoutItems?: Resolver<
    Maybe<Array<ResolversTypes['CheckoutItem']>>,
    ParentType,
    ContextType
  >
  consumer?: Resolver<ResolversTypes['User'], ParentType, ContextType>
  cost?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  hasThresholdBreach?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  openedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  openedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  rejectReason?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  status?: Resolver<
    ResolversTypes['CheckoutStatusesEnum'],
    ParentType,
    ContextType
  >
  technician?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  totalItems?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  totalUnits?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  updatedBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CheckoutCancelPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CheckoutCancelPayload'] = ResolversParentTypes['CheckoutCancelPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Checkout']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CheckoutCompletePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CheckoutCompletePayload'] = ResolversParentTypes['CheckoutCompletePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Checkout']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CheckoutCreatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CheckoutCreatePayload'] = ResolversParentTypes['CheckoutCreatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Checkout']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CheckoutItemResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CheckoutItem'] = ResolversParentTypes['CheckoutItem'],
> = {
  amountRequested?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  checkoutId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  cost?: Resolver<ResolversTypes['Money'], ParentType, ContextType>
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  depletions?: Resolver<
    Array<ResolversTypes['CheckoutItemDepletion']>,
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  isOverThreshold?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  monthlyQuantityUsed?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  overBy?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>
  product?: Resolver<ResolversTypes['Product'], ParentType, ContextType>
  productId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  technicianThreshold?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  unit?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CheckoutItemCreatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CheckoutItemCreatePayload'] = ResolversParentTypes['CheckoutItemCreatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<ResolversTypes['CheckoutItem']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CheckoutItemDepletionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CheckoutItemDepletion'] = ResolversParentTypes['CheckoutItemDepletion'],
> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  locationCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  userName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CheckoutItemRemovePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CheckoutItemRemovePayload'] = ResolversParentTypes['CheckoutItemRemovePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CheckoutItemUpdatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CheckoutItemUpdatePayload'] = ResolversParentTypes['CheckoutItemUpdatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<ResolversTypes['CheckoutItem']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CheckoutRecallPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CheckoutRecallPayload'] = ResolversParentTypes['CheckoutRecallPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Checkout']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CheckoutRemovePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CheckoutRemovePayload'] = ResolversParentTypes['CheckoutRemovePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CheckoutReopenPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CheckoutReopenPayload'] = ResolversParentTypes['CheckoutReopenPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Checkout']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CheckoutSubmitPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CheckoutSubmitPayload'] = ResolversParentTypes['CheckoutSubmitPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Checkout']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CycleCountResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CycleCount'] = ResolversParentTypes['CycleCount'],
> = {
  account?: Resolver<ResolversTypes['Account'], ParentType, ContextType>
  completedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  completedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  countedAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  countedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  countedBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  cycleCountItems?: Resolver<
    Array<ResolversTypes['CycleCountItem']>,
    ParentType,
    ContextType,
    Partial<CycleCountCycleCountItemsArgs>
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  location?: Resolver<ResolversTypes['Location'], ParentType, ContextType>
  locationAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  rejectedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  rejectedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  totalVariancePrice?: Resolver<
    ResolversTypes['Float'],
    ParentType,
    ContextType
  >
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  variance?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CycleCountCreatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CycleCountCreatePayload'] = ResolversParentTypes['CycleCountCreatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<ResolversTypes['CycleCount']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CycleCountItemResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CycleCountItem'] = ResolversParentTypes['CycleCountItem'],
> = {
  countedAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  cycleCount?: Resolver<ResolversTypes['CycleCount'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  locationAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  locationItem?: Resolver<
    ResolversTypes['LocationItem'],
    ParentType,
    ContextType
  >
  price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>
  product?: Resolver<ResolversTypes['Product'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  totalVariancePrice?: Resolver<
    ResolversTypes['Float'],
    ParentType,
    ContextType
  >
  unit?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  variance?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CycleCountItemsUpdatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CycleCountItemsUpdatePayload'] = ResolversParentTypes['CycleCountItemsUpdatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<Array<ResolversTypes['CycleCountItem']>>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CycleCountRecountPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CycleCountRecountPayload'] = ResolversParentTypes['CycleCountRecountPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<ResolversTypes['CycleCount']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type CycleCountUpdatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['CycleCountUpdatePayload'] = ResolversParentTypes['CycleCountUpdatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<ResolversTypes['CycleCount']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export interface DecimalScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['Decimal'], any> {
  name: 'Decimal'
}

export type DestinationTransferResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['DestinationTransfer'] = ResolversParentTypes['DestinationTransfer'],
> = {
  approvedAmount?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  approvedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601Date']>,
    ParentType,
    ContextType
  >
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  currentInventory?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  destinationAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  destinationPrice?: Resolver<
    Maybe<ResolversTypes['Money']>,
    ParentType,
    ContextType
  >
  destinationUnit?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  hasProduct?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  product?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType>
  productId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  sourceAuthorName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  sourceBranchName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DivisionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['Division'] = ResolversParentTypes['Division'],
> = {
  branchId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  checkoutableProducts?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['DivisionsProduct']>>>,
    ParentType,
    ContextType
  >
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  inventoryProducts?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['InventoryProduct']>>>,
    ParentType,
    ContextType,
    RequireFields<DivisionInventoryProductsArgs, 'branchIds'>
  >
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  products?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['DivisionsProduct']>>>,
    ParentType,
    ContextType
  >
  technicians?: Resolver<
    Maybe<Array<ResolversTypes['User']>>,
    ParentType,
    ContextType
  >
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DivisionCreatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['DivisionCreatePayload'] = ResolversParentTypes['DivisionCreatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Division']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DivisionRemovePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['DivisionRemovePayload'] = ResolversParentTypes['DivisionRemovePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DivisionUpdatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['DivisionUpdatePayload'] = ResolversParentTypes['DivisionUpdatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Division']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type DivisionsProductResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['DivisionsProduct'] = ResolversParentTypes['DivisionsProduct'],
> = {
  accountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  branchesProduct?: Resolver<
    Maybe<ResolversTypes['BranchesProduct']>,
    ParentType,
    ContextType
  >
  caseQuantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  category?: Resolver<
    Maybe<ResolversTypes['ProductCategory']>,
    ParentType,
    ContextType
  >
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  custom?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  distributor?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  erpCatalogName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  group?: Resolver<
    Maybe<ResolversTypes['ProductGroup']>,
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  kind?: Resolver<
    ResolversTypes['GenericProductKindsEnum'],
    ParentType,
    ContextType
  >
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  palletQuantity?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  photo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  price?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>
  quantity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  salesUnit?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  speciesIds?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>
  stockInventory?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  stockState?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  unavailable?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type EnsureBranchPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['EnsureBranchPayload'] = ResolversParentTypes['EnsureBranchPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Branch']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ForecastResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['Forecast'] = ResolversParentTypes['Forecast'],
> = {
  amountMaxSuggested?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  amountMinSuggested?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  amountSuggested?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  month?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  productId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type GenerateAppLoginTokenPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['GenerateAppLoginTokenPayload'] = ResolversParentTypes['GenerateAppLoginTokenPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type GenericProductResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['GenericProduct'] = ResolversParentTypes['GenericProduct'],
> = {
  accountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  branchesProduct?: Resolver<
    Maybe<ResolversTypes['BranchesProduct']>,
    ParentType,
    ContextType
  >
  caseQuantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  category?: Resolver<
    Maybe<ResolversTypes['ProductCategory']>,
    ParentType,
    ContextType
  >
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  custom?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  distributor?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  erpCatalogName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  group?: Resolver<
    Maybe<ResolversTypes['ProductGroup']>,
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  palletQuantity?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  photo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  price?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>
  quantity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  salesUnit?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  speciesIds?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>
  stockInventory?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  stockState?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  unavailable?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export interface Iso8601DateScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['ISO8601Date'], any> {
  name: 'ISO8601Date'
}

export interface Iso8601DateOnlyScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['ISO8601DateOnly'], any> {
  name: 'ISO8601DateOnly'
}

export interface Iso8601DateTimeScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['ISO8601DateTime'], any> {
  name: 'ISO8601DateTime'
}

export type ImpersonateUserPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ImpersonateUserPayload'] = ResolversParentTypes['ImpersonateUserPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InboundInventoryResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['InboundInventory'] = ResolversParentTypes['InboundInventory'],
> = {
  acctounId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  approvedAmount?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  approvedItemsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  branchId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  invoiceDate?: Resolver<
    Maybe<ResolversTypes['ISO8601Date']>,
    ParentType,
    ContextType
  >
  itemsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  navId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  navOriginalOrderId?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  recordType?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  shipments?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Shipment']>>>,
    ParentType,
    ContextType
  >
  totalAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  totalPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>
  transfers?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['DestinationTransfer']>>>,
    ParentType,
    ContextType
  >
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InboundInventoryApprovePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['InboundInventoryApprovePayload'] = ResolversParentTypes['InboundInventoryApprovePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<ResolversTypes['InboundInventory']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InventoryEventResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['InventoryEvent'] = ResolversParentTypes['InventoryEvent'],
> = {
  additional?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  branchStockValue?: Resolver<
    Maybe<ResolversTypes['Float']>,
    ParentType,
    ContextType
  >
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  createdByUser?: Resolver<
    Maybe<ResolversTypes['User']>,
    ParentType,
    ContextType
  >
  eventCreatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  eventType?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  locationId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  stockValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  unit?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InventoryEventEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['InventoryEventEdge'] = ResolversParentTypes['InventoryEventEdge'],
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  node?: Resolver<
    Maybe<ResolversTypes['InventoryEvent']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InventoryEventWithPaginationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['InventoryEventWithPagination'] = ResolversParentTypes['InventoryEventWithPagination'],
> = {
  edges?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['InventoryEventEdge']>>>,
    ParentType,
    ContextType
  >
  nodes?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['InventoryEvent']>>>,
    ParentType,
    ContextType
  >
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>
  totalItems?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InventoryProductResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['InventoryProduct'] = ResolversParentTypes['InventoryProduct'],
> = {
  binLocationThreshold?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  divisions?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Division']>>>,
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  inventory?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  inventoryEvents?: Resolver<
    Maybe<ResolversTypes['InventoryEventWithPagination']>,
    ParentType,
    ContextType,
    Partial<InventoryProductInventoryEventsArgs>
  >
  locationItems?: Resolver<
    Array<ResolversTypes['LocationItem']>,
    ParentType,
    ContextType
  >
  lockToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  notifyThreshold?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >
  originalProductData?: Resolver<
    Maybe<ResolversTypes['SalableProductData']>,
    ParentType,
    ContextType
  >
  price?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>
  priceVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  product?: Resolver<ResolversTypes['Product'], ParentType, ContextType>
  productTags?: Resolver<
    Array<ResolversTypes['ProductTag']>,
    ParentType,
    ContextType
  >
  quantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  technicianThreshold?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  threshold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  truckLocationThreshold?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InventoryProductCreatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['InventoryProductCreatePayload'] = ResolversParentTypes['InventoryProductCreatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<ResolversTypes['InventoryProduct']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InventoryProductRemovePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['InventoryProductRemovePayload'] = ResolversParentTypes['InventoryProductRemovePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InventoryProductTransferPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['InventoryProductTransferPayload'] = ResolversParentTypes['InventoryProductTransferPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<ResolversTypes['InventoryProduct']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type InventoryProductUpdatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['InventoryProductUpdatePayload'] = ResolversParentTypes['InventoryProductUpdatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<ResolversTypes['InventoryProduct']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export interface JsonScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON'
}

export type LoadAccountsCsvPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['LoadAccountsCsvPayload'] = ResolversParentTypes['LoadAccountsCsvPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Account']>>>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LoadBranchesCsvPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['LoadBranchesCsvPayload'] = ResolversParentTypes['LoadBranchesCsvPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Branch']>>>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LoadDivisionProductsCsvPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['LoadDivisionProductsCsvPayload'] = ResolversParentTypes['LoadDivisionProductsCsvPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['GenericProduct']>>>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LoadLocationsCsvPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['LoadLocationsCsvPayload'] = ResolversParentTypes['LoadLocationsCsvPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Location']>>>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LoadShipmentsCsvPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['LoadShipmentsCsvPayload'] = ResolversParentTypes['LoadShipmentsCsvPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LoadUsersCsvPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['LoadUsersCsvPayload'] = ResolversParentTypes['LoadUsersCsvPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LocationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['Location'] = ResolversParentTypes['Location'],
> = {
  accountId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  branches?: Resolver<Array<ResolversTypes['Branch']>, ParentType, ContextType>
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  cycleCountDue?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  cycleCountFrequencyDays?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  cycleCountStartDate?: Resolver<
    Maybe<ResolversTypes['ISO8601Date']>,
    ParentType,
    ContextType
  >
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  hasCycleCounts?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  isDefault?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  latestCycleCount?: Resolver<
    Maybe<ResolversTypes['CycleCount']>,
    ParentType,
    ContextType
  >
  latestMove?: Resolver<Maybe<ResolversTypes['Move']>, ParentType, ContextType>
  locationItems?: Resolver<
    Array<ResolversTypes['LocationItem']>,
    ParentType,
    ContextType
  >
  locationType?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  lowStockLocationItems?: Resolver<
    Array<ResolversTypes['LocationItem']>,
    ParentType,
    ContextType
  >
  nextCycleCountDate?: Resolver<
    Maybe<ResolversTypes['ISO8601Date']>,
    ParentType,
    ContextType
  >
  openProcess?: Resolver<
    Maybe<ResolversTypes['OpenProcessEnum']>,
    ParentType,
    ContextType
  >
  products?: Resolver<Array<ResolversTypes['Product']>, ParentType, ContextType>
  totalValue?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  updatedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LocationCreatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['LocationCreatePayload'] = ResolversParentTypes['LocationCreatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Location']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LocationDeletePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['LocationDeletePayload'] = ResolversParentTypes['LocationDeletePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LocationItemResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['LocationItem'] = ResolversParentTypes['LocationItem'],
> = {
  branchProductThreshold?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType,
    Partial<LocationItemBranchProductThresholdArgs>
  >
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  discardedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  inventory?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  location?: Resolver<ResolversTypes['Location'], ParentType, ContextType>
  locationId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>
  product?: Resolver<ResolversTypes['Product'], ParentType, ContextType>
  productId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  threshold?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  unit?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  updatedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LocationItemCreatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['LocationItemCreatePayload'] = ResolversParentTypes['LocationItemCreatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<ResolversTypes['LocationItem']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LocationItemDeletePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['LocationItemDeletePayload'] = ResolversParentTypes['LocationItemDeletePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<ResolversTypes['LocationItem']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LocationItemUpdatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['LocationItemUpdatePayload'] = ResolversParentTypes['LocationItemUpdatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<ResolversTypes['LocationItem']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type LocationUpdatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['LocationUpdatePayload'] = ResolversParentTypes['LocationUpdatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Location']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ManagerUpdatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ManagerUpdatePayload'] = ResolversParentTypes['ManagerUpdatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MessageResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['Message'] = ResolversParentTypes['Message'],
> = {
  archivedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  publishedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  read?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MessageArchivePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['MessageArchivePayload'] = ResolversParentTypes['MessageArchivePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MessageMarkReadPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['MessageMarkReadPayload'] = ResolversParentTypes['MessageMarkReadPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<ResolversTypes['MessageRead']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MessagePublishPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['MessagePublishPayload'] = ResolversParentTypes['MessagePublishPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MessageReadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['MessageRead'] = ResolversParentTypes['MessageRead'],
> = {
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  message?: Resolver<ResolversTypes['Message'], ParentType, ContextType>
  readAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MessageUpdatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['MessageUpdatePayload'] = ResolversParentTypes['MessageUpdatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export interface MoneyScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['Money'], any> {
  name: 'Money'
}

export type MoveResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['Move'] = ResolversParentTypes['Move'],
> = {
  account?: Resolver<ResolversTypes['Account'], ParentType, ContextType>
  canceledAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  canceledBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  completedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  completedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  fromLocation?: Resolver<ResolversTypes['Location'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  locationAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  moveItems?: Resolver<
    Array<ResolversTypes['MoveItem']>,
    ParentType,
    ContextType
  >
  movedAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  movedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>
  movedBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>
  rejectReason?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  rejectedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  rejectedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  status?: Resolver<ResolversTypes['MoveStatusesEnum'], ParentType, ContextType>
  toBranch?: Resolver<Maybe<ResolversTypes['Branch']>, ParentType, ContextType>
  toLocation?: Resolver<
    Maybe<ResolversTypes['Location']>,
    ParentType,
    ContextType
  >
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MoveCreatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['MoveCreatePayload'] = ResolversParentTypes['MoveCreatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Move']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MoveItemResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['MoveItem'] = ResolversParentTypes['MoveItem'],
> = {
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  locationAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  locationItem?: Resolver<
    ResolversTypes['LocationItem'],
    ParentType,
    ContextType
  >
  move?: Resolver<ResolversTypes['Move'], ParentType, ContextType>
  movedAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  price?: Resolver<ResolversTypes['Money'], ParentType, ContextType>
  product?: Resolver<ResolversTypes['Product'], ParentType, ContextType>
  toLocation?: Resolver<
    Maybe<ResolversTypes['Location']>,
    ParentType,
    ContextType
  >
  unit?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MoveUpdatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['MoveUpdatePayload'] = ResolversParentTypes['MoveUpdatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Move']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type MutationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation'],
> = {
  acceptTerms?: Resolver<
    Maybe<ResolversTypes['AcceptTermsPayload']>,
    ParentType,
    ContextType
  >
  accountUpdate?: Resolver<
    Maybe<ResolversTypes['AccountUpdatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationAccountUpdateArgs, 'attributes' | 'id'>
  >
  addPlanProduct?: Resolver<
    Maybe<ResolversTypes['AddPlanProductPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationAddPlanProductArgs, 'branchId' | 'productId'>
  >
  addPlanProductsFromInventory?: Resolver<
    Maybe<ResolversTypes['AddPlanProductsFromInventoryPayload']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationAddPlanProductsFromInventoryArgs,
      'branchId' | 'productIds'
    >
  >
  assignMultipleAccounts?: Resolver<
    Maybe<ResolversTypes['AssignMultipleAccountsPayload']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationAssignMultipleAccountsArgs,
      'accountAssignments' | 'userId'
    >
  >
  branchCreate?: Resolver<
    Maybe<ResolversTypes['BranchCreatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationBranchCreateArgs, 'attributes'>
  >
  branchDelete?: Resolver<
    Maybe<ResolversTypes['BranchDeletePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationBranchDeleteArgs, 'id'>
  >
  branchUpdate?: Resolver<
    Maybe<ResolversTypes['BranchUpdatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationBranchUpdateArgs, 'attributes' | 'id'>
  >
  cartBranchUpdate?: Resolver<
    Maybe<ResolversTypes['CartBranchUpdatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCartBranchUpdateArgs, 'attributes' | 'id'>
  >
  cartItemCreate?: Resolver<
    Maybe<ResolversTypes['CartItemCreatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCartItemCreateArgs, 'attributes'>
  >
  cartItemUpdate?: Resolver<
    Maybe<ResolversTypes['CartItemUpdatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCartItemUpdateArgs, 'attributes' | 'id'>
  >
  checkoutCancel?: Resolver<
    Maybe<ResolversTypes['CheckoutCancelPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCheckoutCancelArgs, 'id'>
  >
  checkoutComplete?: Resolver<
    Maybe<ResolversTypes['CheckoutCompletePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCheckoutCompleteArgs, 'id'>
  >
  checkoutCreate?: Resolver<
    Maybe<ResolversTypes['CheckoutCreatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCheckoutCreateArgs, 'attributes'>
  >
  checkoutItemCreate?: Resolver<
    Maybe<ResolversTypes['CheckoutItemCreatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCheckoutItemCreateArgs, 'attributes'>
  >
  checkoutItemRemove?: Resolver<
    Maybe<ResolversTypes['CheckoutItemRemovePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCheckoutItemRemoveArgs, 'id'>
  >
  checkoutItemUpdate?: Resolver<
    Maybe<ResolversTypes['CheckoutItemUpdatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCheckoutItemUpdateArgs, 'attributes' | 'id'>
  >
  checkoutRecall?: Resolver<
    Maybe<ResolversTypes['CheckoutRecallPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCheckoutRecallArgs, 'id'>
  >
  checkoutRemove?: Resolver<
    Maybe<ResolversTypes['CheckoutRemovePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCheckoutRemoveArgs, 'id'>
  >
  checkoutReopen?: Resolver<
    Maybe<ResolversTypes['CheckoutReopenPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCheckoutReopenArgs, 'id'>
  >
  checkoutSubmit?: Resolver<
    Maybe<ResolversTypes['CheckoutSubmitPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCheckoutSubmitArgs, 'id'>
  >
  cycleCountCreate?: Resolver<
    Maybe<ResolversTypes['CycleCountCreatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCycleCountCreateArgs, 'attributes'>
  >
  cycleCountItemsUpdate?: Resolver<
    Maybe<ResolversTypes['CycleCountItemsUpdatePayload']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationCycleCountItemsUpdateArgs,
      'cycleCountId' | 'ids' | 'status'
    >
  >
  cycleCountRecount?: Resolver<
    Maybe<ResolversTypes['CycleCountRecountPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCycleCountRecountArgs, 'id' | 'items'>
  >
  cycleCountUpdate?: Resolver<
    Maybe<ResolversTypes['CycleCountUpdatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCycleCountUpdateArgs, 'attributes' | 'id'>
  >
  divisionCreate?: Resolver<
    Maybe<ResolversTypes['DivisionCreatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationDivisionCreateArgs, 'attributes'>
  >
  divisionRemove?: Resolver<
    Maybe<ResolversTypes['DivisionRemovePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationDivisionRemoveArgs, 'id'>
  >
  divisionUpdate?: Resolver<
    Maybe<ResolversTypes['DivisionUpdatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationDivisionUpdateArgs, 'attributes' | 'id'>
  >
  ensureBranch?: Resolver<
    Maybe<ResolversTypes['EnsureBranchPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationEnsureBranchArgs, 'id'>
  >
  generateAppLoginToken?: Resolver<
    Maybe<ResolversTypes['GenerateAppLoginTokenPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationGenerateAppLoginTokenArgs, 'userId'>
  >
  impersonateUser?: Resolver<
    Maybe<ResolversTypes['ImpersonateUserPayload']>,
    ParentType,
    ContextType,
    Partial<MutationImpersonateUserArgs>
  >
  inboundInventoryApprove?: Resolver<
    Maybe<ResolversTypes['InboundInventoryApprovePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationInboundInventoryApproveArgs, 'id' | 'inboundData'>
  >
  inventoryProductCreate?: Resolver<
    Maybe<ResolversTypes['InventoryProductCreatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationInventoryProductCreateArgs, 'attributes'>
  >
  inventoryProductRemove?: Resolver<
    Maybe<ResolversTypes['InventoryProductRemovePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationInventoryProductRemoveArgs, 'branchId' | 'productId'>
  >
  inventoryProductTransfer?: Resolver<
    Maybe<ResolversTypes['InventoryProductTransferPayload']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationInventoryProductTransferArgs,
      'attributes' | 'destinationBranchId' | 'productCode' | 'sourceBranchId'
    >
  >
  inventoryProductUpdate?: Resolver<
    Maybe<ResolversTypes['InventoryProductUpdatePayload']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationInventoryProductUpdateArgs,
      'attributes' | 'branchId' | 'productId'
    >
  >
  loadAccountsCsv?: Resolver<
    Maybe<ResolversTypes['LoadAccountsCsvPayload']>,
    ParentType,
    ContextType
  >
  loadBranchesCsv?: Resolver<
    Maybe<ResolversTypes['LoadBranchesCsvPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationLoadBranchesCsvArgs, 'accountId'>
  >
  loadDivisionProductsCsv?: Resolver<
    Maybe<ResolversTypes['LoadDivisionProductsCsvPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationLoadDivisionProductsCsvArgs, 'branchId'>
  >
  loadLocationsCsv?: Resolver<
    Maybe<ResolversTypes['LoadLocationsCsvPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationLoadLocationsCsvArgs, 'accountId' | 'branchId'>
  >
  loadShipmentsCsv?: Resolver<
    Maybe<ResolversTypes['LoadShipmentsCsvPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationLoadShipmentsCsvArgs, 'accountId'>
  >
  loadUsersCsv?: Resolver<
    Maybe<ResolversTypes['LoadUsersCsvPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationLoadUsersCsvArgs, 'accountId'>
  >
  locationCreate?: Resolver<
    Maybe<ResolversTypes['LocationCreatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationLocationCreateArgs, 'attributes'>
  >
  locationDelete?: Resolver<
    Maybe<ResolversTypes['LocationDeletePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationLocationDeleteArgs, 'id'>
  >
  locationItemCreate?: Resolver<
    Maybe<ResolversTypes['LocationItemCreatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationLocationItemCreateArgs, 'attributes'>
  >
  locationItemDelete?: Resolver<
    Maybe<ResolversTypes['LocationItemDeletePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationLocationItemDeleteArgs, 'id'>
  >
  locationItemUpdate?: Resolver<
    Maybe<ResolversTypes['LocationItemUpdatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationLocationItemUpdateArgs, 'attributes' | 'id'>
  >
  locationUpdate?: Resolver<
    Maybe<ResolversTypes['LocationUpdatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationLocationUpdateArgs, 'attributes' | 'id'>
  >
  managerUpdate?: Resolver<
    Maybe<ResolversTypes['ManagerUpdatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationManagerUpdateArgs, 'attributes' | 'id'>
  >
  messageArchive?: Resolver<
    Maybe<ResolversTypes['MessageArchivePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationMessageArchiveArgs, 'id'>
  >
  messageMarkRead?: Resolver<
    Maybe<ResolversTypes['MessageMarkReadPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationMessageMarkReadArgs, 'id'>
  >
  messagePublish?: Resolver<
    Maybe<ResolversTypes['MessagePublishPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationMessagePublishArgs, 'content'>
  >
  messageUpdate?: Resolver<
    Maybe<ResolversTypes['MessageUpdatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationMessageUpdateArgs, 'content' | 'id'>
  >
  moveCreate?: Resolver<
    Maybe<ResolversTypes['MoveCreatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationMoveCreateArgs, 'attributes'>
  >
  moveUpdate?: Resolver<
    Maybe<ResolversTypes['MoveUpdatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationMoveUpdateArgs, 'attributes'>
  >
  navInvoiceIgnore?: Resolver<
    Maybe<ResolversTypes['NavInvoiceIgnorePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationNavInvoiceIgnoreArgs, 'id'>
  >
  navInvoiceMap?: Resolver<
    Maybe<ResolversTypes['NavInvoiceMapPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationNavInvoiceMapArgs, 'branchId' | 'id' | 'process'>
  >
  orderApprove?: Resolver<
    Maybe<ResolversTypes['OrderApprovePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationOrderApproveArgs, 'id'>
  >
  orderItemCreate?: Resolver<
    Maybe<ResolversTypes['OrderItemCreatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationOrderItemCreateArgs, 'attributes'>
  >
  orderItemUpdate?: Resolver<
    Maybe<ResolversTypes['OrderItemUpdatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationOrderItemUpdateArgs, 'attributes' | 'id'>
  >
  orderReject?: Resolver<
    Maybe<ResolversTypes['OrderRejectPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationOrderRejectArgs, 'id'>
  >
  orderRequest?: Resolver<
    Maybe<ResolversTypes['OrderRequestPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationOrderRequestArgs, 'id'>
  >
  orderRequestFromCart?: Resolver<
    Maybe<ResolversTypes['OrderRequestFromCartPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationOrderRequestFromCartArgs, 'branchId'>
  >
  orderRequestTrackingInfo?: Resolver<
    Maybe<ResolversTypes['OrderRequestTrackingInfoPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationOrderRequestTrackingInfoArgs, 'id'>
  >
  orderSubmit?: Resolver<
    Maybe<ResolversTypes['OrderSubmitPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationOrderSubmitArgs, 'id'>
  >
  orderSubmitFromCart?: Resolver<
    Maybe<ResolversTypes['OrderSubmitFromCartPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationOrderSubmitFromCartArgs, 'branchId'>
  >
  orderUpdate?: Resolver<
    Maybe<ResolversTypes['OrderUpdatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationOrderUpdateArgs, 'attributes' | 'id'>
  >
  productTagCreate?: Resolver<
    Maybe<ResolversTypes['ProductTagCreatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationProductTagCreateArgs, 'branchId' | 'color' | 'name'>
  >
  productTagDelete?: Resolver<
    Maybe<ResolversTypes['ProductTagDeletePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationProductTagDeleteArgs, 'id'>
  >
  productTagUpdate?: Resolver<
    Maybe<ResolversTypes['ProductTagUpdatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationProductTagUpdateArgs, 'id'>
  >
  removeBranchesSalableProduct?: Resolver<
    Maybe<ResolversTypes['RemoveBranchesSalableProductPayload']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationRemoveBranchesSalableProductArgs,
      'branchId' | 'salableProductId'
    >
  >
  removePlanProduct?: Resolver<
    Maybe<ResolversTypes['RemovePlanProductPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationRemovePlanProductArgs, 'branchId' | 'productId'>
  >
  replenishmentPlanItemSpecify?: Resolver<
    Maybe<ResolversTypes['ReplenishmentPlanItemSpecifyPayload']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationReplenishmentPlanItemSpecifyArgs,
      'amount' | 'branchId' | 'month' | 'productId'
    >
  >
  replenishmentPlanProductReplace?: Resolver<
    Maybe<ResolversTypes['ReplenishmentPlanProductReplacePayload']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationReplenishmentPlanProductReplaceArgs,
      'branchId' | 'newProductId' | 'oldProductId'
    >
  >
  sanaPasswordRotate?: Resolver<
    Maybe<ResolversTypes['SanaPasswordRotatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationSanaPasswordRotateArgs, 'managerId'>
  >
  sanaPasswordSetManual?: Resolver<
    Maybe<ResolversTypes['SanaPasswordSetManualPayload']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationSanaPasswordSetManualArgs,
      'managerId' | 'newPassword'
    >
  >
  scheduleAccountSync?: Resolver<
    Maybe<ResolversTypes['ScheduleAccountSyncPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationScheduleAccountSyncArgs, 'accountId'>
  >
  scheduleBranchSync?: Resolver<
    Maybe<ResolversTypes['ScheduleBranchSyncPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationScheduleBranchSyncArgs, 'branchId'>
  >
  scheduleProductsUpdate?: Resolver<
    Maybe<ResolversTypes['ScheduleProductsUpdatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationScheduleProductsUpdateArgs, 'accountId'>
  >
  speciesSetGroup?: Resolver<
    Maybe<ResolversTypes['SpeciesSetGroupPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationSpeciesSetGroupArgs, 'group' | 'id'>
  >
  teamCreate?: Resolver<
    Maybe<ResolversTypes['TeamCreatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationTeamCreateArgs, 'attributes'>
  >
  teamRemove?: Resolver<
    Maybe<ResolversTypes['TeamRemovePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationTeamRemoveArgs, 'id'>
  >
  teamUpdate?: Resolver<
    Maybe<ResolversTypes['TeamUpdatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationTeamUpdateArgs, 'attributes' | 'id'>
  >
  technicianCreate?: Resolver<
    Maybe<ResolversTypes['TechnicianCreatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationTechnicianCreateArgs, 'attributes'>
  >
  technicianMove?: Resolver<
    Maybe<ResolversTypes['TechnicianMovePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationTechnicianMoveArgs, 'branchIds' | 'id'>
  >
  technicianRemove?: Resolver<
    Maybe<ResolversTypes['TechnicianRemovePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationTechnicianRemoveArgs, 'id'>
  >
  technicianUpdate?: Resolver<
    Maybe<ResolversTypes['TechnicianUpdatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationTechnicianUpdateArgs, 'attributes' | 'id'>
  >
  updateDeviceInfo?: Resolver<
    Maybe<ResolversTypes['UpdateDeviceInfoPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateDeviceInfoArgs, 'deviceInfo'>
  >
  userAttachAvatar?: Resolver<
    Maybe<ResolversTypes['UserAttachAvatarPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUserAttachAvatarArgs, 'id'>
  >
  userCreate?: Resolver<
    Maybe<ResolversTypes['UserCreatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUserCreateArgs, 'attributes'>
  >
  userMove?: Resolver<
    Maybe<ResolversTypes['UserMovePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUserMoveArgs, 'branchIds' | 'id'>
  >
  userReassignAccount?: Resolver<
    Maybe<ResolversTypes['UserReassignAccountPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUserReassignAccountArgs, 'accountId' | 'id'>
  >
  userSetBranches?: Resolver<
    Maybe<ResolversTypes['UserSetBranchesPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUserSetBranchesArgs, 'branches' | 'id'>
  >
  userUpdate?: Resolver<
    Maybe<ResolversTypes['UserUpdatePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUserUpdateArgs, 'attributes' | 'id'>
  >
}

export type NavInvoiceResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['NavInvoice'] = ResolversParentTypes['NavInvoice'],
> = {
  accountName?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  actedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  actedByName?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  invoiceDate?: Resolver<ResolversTypes['ISO8601Date'], ParentType, ContextType>
  invoiceNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  lastError?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  manualBranch?: Resolver<
    Maybe<ResolversTypes['Branch']>,
    ParentType,
    ContextType
  >
  navAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  navBranchId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  pendingReason?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  status?: Resolver<
    ResolversTypes['NavInvoiceStatusesEnum'],
    ParentType,
    ContextType
  >
  totalPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type NavInvoiceCountsResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['NavInvoiceCounts'] = ResolversParentTypes['NavInvoiceCounts'],
> = {
  branch?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  pending?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  processing?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  shippingAgent?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type NavInvoiceEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['NavInvoiceEdge'] = ResolversParentTypes['NavInvoiceEdge'],
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  node?: Resolver<Maybe<ResolversTypes['NavInvoice']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type NavInvoiceIgnorePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['NavInvoiceIgnorePayload'] = ResolversParentTypes['NavInvoiceIgnorePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<ResolversTypes['NavInvoice']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type NavInvoiceMapPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['NavInvoiceMapPayload'] = ResolversParentTypes['NavInvoiceMapPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<ResolversTypes['NavInvoice']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type NavInvoiceWithPaginationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['NavInvoiceWithPagination'] = ResolversParentTypes['NavInvoiceWithPagination'],
> = {
  edges?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['NavInvoiceEdge']>>>,
    ParentType,
    ContextType
  >
  nodes?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['NavInvoice']>>>,
    ParentType,
    ContextType
  >
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>
  totalItems?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OrderResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['Order'] = ResolversParentTypes['Order'],
> = {
  account?: Resolver<ResolversTypes['Account'], ParentType, ContextType>
  approveDueDateAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateOnly']>,
    ParentType,
    ContextType
  >
  approvedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  approvedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  autoSubmitted?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >
  blockedReason?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  branch?: Resolver<ResolversTypes['Branch'], ParentType, ContextType>
  cost?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  createdBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  dueDateAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateOnly']>,
    ParentType,
    ContextType
  >
  erpCatalogName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  kind?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  month?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  navOrderId?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  navReferenceId?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  orderItems?: Resolver<
    Maybe<Array<ResolversTypes['OrderItem']>>,
    ParentType,
    ContextType
  >
  orderTrackingStatuses?: Resolver<
    Maybe<Array<ResolversTypes['OrderTrackingStatus']>>,
    ParentType,
    ContextType
  >
  processingStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  purchaseOrderNumber?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  rejectReason?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  rejectedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateOnly']>,
    ParentType,
    ContextType
  >
  rejectedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  requestedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateOnly']>,
    ParentType,
    ContextType
  >
  requestedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  shipmentDateAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateOnly']>,
    ParentType,
    ContextType
  >
  skipReminder?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  submittedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  submittedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  updatedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OrderApprovePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['OrderApprovePayload'] = ResolversParentTypes['OrderApprovePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Order']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OrderDetailedResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['OrderDetailed'] = ResolversParentTypes['OrderDetailed'],
> = {
  account?: Resolver<ResolversTypes['Account'], ParentType, ContextType>
  approveDueDateAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateOnly']>,
    ParentType,
    ContextType
  >
  approvedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  approvedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  autoSubmitted?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >
  blockedReason?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  branch?: Resolver<ResolversTypes['Branch'], ParentType, ContextType>
  cost?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  createdBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  dueDateAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateOnly']>,
    ParentType,
    ContextType
  >
  erpCatalogName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  kind?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  month?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  navCsv?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType,
    RequireFields<OrderDetailedNavCsvArgs, 'colSep' | 'forceQuotes' | 'rowSep'>
  >
  navOrderId?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  navReferenceId?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  orderItems?: Resolver<
    Maybe<Array<ResolversTypes['OrderItem']>>,
    ParentType,
    ContextType
  >
  orderTrackingStatuses?: Resolver<
    Maybe<Array<ResolversTypes['OrderTrackingStatus']>>,
    ParentType,
    ContextType
  >
  processingStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  purchaseOrderNumber?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  rejectReason?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  rejectedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateOnly']>,
    ParentType,
    ContextType
  >
  rejectedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  requestedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateOnly']>,
    ParentType,
    ContextType
  >
  requestedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  shipmentDateAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateOnly']>,
    ParentType,
    ContextType
  >
  skipReminder?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  submittedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  submittedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  updatedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OrderEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['OrderEdge'] = ResolversParentTypes['OrderEdge'],
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  node?: Resolver<Maybe<ResolversTypes['Order']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OrderItemResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['OrderItem'] = ResolversParentTypes['OrderItem'],
> = {
  amountOverridden?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >
  amountRequested?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  effectivePrice?: Resolver<
    Maybe<ResolversTypes['Money']>,
    ParentType,
    ContextType
  >
  effectiveUnit?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  forecast?: Resolver<
    Maybe<ResolversTypes['Forecast']>,
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  orderId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  price?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>
  product?: Resolver<ResolversTypes['Product'], ParentType, ContextType>
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  updatedBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OrderItemCreatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['OrderItemCreatePayload'] = ResolversParentTypes['OrderItemCreatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['OrderItem']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OrderItemUpdatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['OrderItemUpdatePayload'] = ResolversParentTypes['OrderItemUpdatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['OrderItem']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OrderRejectPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['OrderRejectPayload'] = ResolversParentTypes['OrderRejectPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Order']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OrderRequestFromCartPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['OrderRequestFromCartPayload'] = ResolversParentTypes['OrderRequestFromCartPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Order']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OrderRequestPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['OrderRequestPayload'] = ResolversParentTypes['OrderRequestPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Order']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OrderRequestTrackingInfoPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['OrderRequestTrackingInfoPayload'] = ResolversParentTypes['OrderRequestTrackingInfoPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OrderSubmitFromCartPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['OrderSubmitFromCartPayload'] = ResolversParentTypes['OrderSubmitFromCartPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Order']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OrderSubmitPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['OrderSubmitPayload'] = ResolversParentTypes['OrderSubmitPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Order']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OrderTrackingStatusResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['OrderTrackingStatus'] = ResolversParentTypes['OrderTrackingStatus'],
> = {
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  navId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  shippedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601Date']>,
    ParentType,
    ContextType
  >
  shippingAgent?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  soNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  trackingNumber?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  trackingUrl?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OrderUpdatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['OrderUpdatePayload'] = ResolversParentTypes['OrderUpdatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Order']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OrderWithPaginationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['OrderWithPagination'] = ResolversParentTypes['OrderWithPagination'],
> = {
  edges?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['OrderEdge']>>>,
    ParentType,
    ContextType
  >
  nodes?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Order']>>>,
    ParentType,
    ContextType
  >
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>
  totalItems?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type OrdersStatsResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['OrdersStats'] = ResolversParentTypes['OrdersStats'],
> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PageInfoResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo'],
> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  startCursor?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type PlanItemResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['PlanItem'] = ResolversParentTypes['PlanItem'],
> = {
  amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  month?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  productId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ProductResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['Product'] = ResolversParentTypes['Product'],
> = {
  caseQuantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  category?: Resolver<
    Maybe<ResolversTypes['ProductCategory']>,
    ParentType,
    ContextType
  >
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  custom?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  distributor?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  erpCatalogName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  group?: Resolver<
    Maybe<ResolversTypes['ProductGroup']>,
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  palletQuantity?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  photo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  price?: Resolver<Maybe<ResolversTypes['Decimal']>, ParentType, ContextType>
  priceVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  salesUnit?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  speciesIds?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>
  stockInventory?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  stockState?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  unavailable?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ProductCategoryResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ProductCategory'] = ResolversParentTypes['ProductCategory'],
> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ProductGroupResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ProductGroup'] = ResolversParentTypes['ProductGroup'],
> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ProductTagResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ProductTag'] = ResolversParentTypes['ProductTag'],
> = {
  color?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  productsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ProductTagCreatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ProductTagCreatePayload'] = ResolversParentTypes['ProductTagCreatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<ResolversTypes['ProductTag']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ProductTagDeletePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ProductTagDeletePayload'] = ResolversParentTypes['ProductTagDeletePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<ResolversTypes['ProductTag']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ProductTagUpdatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ProductTagUpdatePayload'] = ResolversParentTypes['ProductTagUpdatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<ResolversTypes['ProductTag']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ProductsUnionResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ProductsUnion'] = ResolversParentTypes['ProductsUnion'],
> = {
  __resolveType: TypeResolveFn<'AccountsProduct', ParentType, ContextType>
}

export type QueryResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['Query'] = ResolversParentTypes['Query'],
> = {
  accounts?: Resolver<
    Maybe<ResolversTypes['AccountWithPagination']>,
    ParentType,
    ContextType,
    Partial<QueryAccountsArgs>
  >
  branchBinLocationItems?: Resolver<
    Array<ResolversTypes['BranchBinLocationItem']>,
    ParentType,
    ContextType,
    RequireFields<QueryBranchBinLocationItemsArgs, 'branchId' | 'productId'>
  >
  cycleCount?: Resolver<
    Maybe<ResolversTypes['CycleCount']>,
    ParentType,
    ContextType,
    RequireFields<QueryCycleCountArgs, 'id'>
  >
  cycleCounts?: Resolver<
    Maybe<Array<ResolversTypes['CycleCount']>>,
    ParentType,
    ContextType,
    RequireFields<QueryCycleCountsArgs, 'accountId'>
  >
  forecasts?: Resolver<
    Array<ResolversTypes['Forecast']>,
    ParentType,
    ContextType,
    RequireFields<QueryForecastsArgs, 'branchId'>
  >
  internal?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  location?: Resolver<
    Maybe<ResolversTypes['Location']>,
    ParentType,
    ContextType,
    RequireFields<QueryLocationArgs, 'id'>
  >
  locations?: Resolver<
    Maybe<Array<ResolversTypes['Location']>>,
    ParentType,
    ContextType,
    RequireFields<QueryLocationsArgs, 'accountId'>
  >
  locationsCsv?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType,
    RequireFields<QueryLocationsCsvArgs, 'accountId'>
  >
  manager?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  me?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  mobileUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  move?: Resolver<
    Maybe<ResolversTypes['Move']>,
    ParentType,
    ContextType,
    RequireFields<QueryMoveArgs, 'id'>
  >
  moves?: Resolver<
    Maybe<Array<ResolversTypes['Move']>>,
    ParentType,
    ContextType,
    RequireFields<QueryMovesArgs, 'accountId'>
  >
  planItems?: Resolver<
    Array<ResolversTypes['PlanItem']>,
    ParentType,
    ContextType,
    RequireFields<QueryPlanItemsArgs, 'branchId'>
  >
  planSpecies?: Resolver<
    Array<ResolversTypes['Species']>,
    ParentType,
    ContextType
  >
  planner?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  productsOrderable?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['AccountsProduct']>>>,
    ParentType,
    ContextType,
    Partial<QueryProductsOrderableArgs>
  >
  publishedMessage?: Resolver<
    Maybe<ResolversTypes['Message']>,
    ParentType,
    ContextType
  >
  replenishmentPlan?: Resolver<
    Maybe<Array<ResolversTypes['BranchesSalableProduct']>>,
    ParentType,
    ContextType,
    Partial<QueryReplenishmentPlanArgs>
  >
  replenishmentPlanExports?: Resolver<
    Maybe<Array<ResolversTypes['ReplenishmentPlanExport']>>,
    ParentType,
    ContextType,
    Partial<QueryReplenishmentPlanExportsArgs>
  >
  shipments?: Resolver<
    Array<ResolversTypes['Shipment']>,
    ParentType,
    ContextType,
    RequireFields<QueryShipmentsArgs, 'branchId'>
  >
  species?: Resolver<Array<ResolversTypes['Species']>, ParentType, ContextType>
  submittedItems?: Resolver<
    Array<ResolversTypes['SubmittedItem']>,
    ParentType,
    ContextType,
    RequireFields<QuerySubmittedItemsArgs, 'branchId'>
  >
  technician?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
}

export type RemoveBranchesSalableProductPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['RemoveBranchesSalableProductPayload'] = ResolversParentTypes['RemoveBranchesSalableProductPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RemovePlanProductPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['RemovePlanProductPayload'] = ResolversParentTypes['RemovePlanProductPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['RemovedOrderItem']>>>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type RemovedOrderItemResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['RemovedOrderItem'] = ResolversParentTypes['RemovedOrderItem'],
> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  orderId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  productId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ReplenishmentPlanExportResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ReplenishmentPlanExport'] = ResolversParentTypes['ReplenishmentPlanExport'],
> = {
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  file?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  navId?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ReplenishmentPlanItemSpecifyPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ReplenishmentPlanItemSpecifyPayload'] = ResolversParentTypes['ReplenishmentPlanItemSpecifyPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['PlanItem']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ReplenishmentPlanProductReplacePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ReplenishmentPlanProductReplacePayload'] = ResolversParentTypes['ReplenishmentPlanProductReplacePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<ResolversTypes['BranchesSalableProduct']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SalableProductDataResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['SalableProductData'] = ResolversParentTypes['SalableProductData'],
> = {
  price?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SanaPasswordRotatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['SanaPasswordRotatePayload'] = ResolversParentTypes['SanaPasswordRotatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SanaPasswordSetManualPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['SanaPasswordSetManualPayload'] = ResolversParentTypes['SanaPasswordSetManualPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ScheduleAccountSyncPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ScheduleAccountSyncPayload'] = ResolversParentTypes['ScheduleAccountSyncPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<ResolversTypes['AccountSyncJob']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ScheduleBranchSyncPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ScheduleBranchSyncPayload'] = ResolversParentTypes['ScheduleBranchSyncPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<
    Maybe<ResolversTypes['AccountSyncJob']>,
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ScheduleProductsUpdatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ScheduleProductsUpdatePayload'] = ResolversParentTypes['ScheduleProductsUpdatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ShipmentResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['Shipment'] = ResolversParentTypes['Shipment'],
> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  approvedAmount?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  approvedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601Date']>,
    ParentType,
    ContextType
  >
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  currentInventory?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  date?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>
  hasProduct?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  product?: Resolver<
    Maybe<ResolversTypes['ShippedProduct']>,
    ParentType,
    ContextType
  >
  productId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type ShippedProductResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['ShippedProduct'] = ResolversParentTypes['ShippedProduct'],
> = {
  caseQuantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  category?: Resolver<
    Maybe<ResolversTypes['ProductCategory']>,
    ParentType,
    ContextType
  >
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  custom?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  distributor?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  erpCatalogName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  group?: Resolver<
    Maybe<ResolversTypes['ProductGroup']>,
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  palletQuantity?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  photo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  price?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>
  salesUnit?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  speciesIds?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>
  stockInventory?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >
  stockState?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  unavailable?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpeciesResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['Species'] = ResolversParentTypes['Species'],
> = {
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  group?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  productsForshaw?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  productsFrs?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  sanaId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SpeciesSetGroupPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['SpeciesSetGroupPayload'] = ResolversParentTypes['SpeciesSetGroupPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Species']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type SubmittedItemResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['SubmittedItem'] = ResolversParentTypes['SubmittedItem'],
> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  month?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  productId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TeamResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['Team'] = ResolversParentTypes['Team'],
> = {
  branchId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  technicians?: Resolver<
    Maybe<Array<ResolversTypes['User']>>,
    ParentType,
    ContextType
  >
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TeamCreatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['TeamCreatePayload'] = ResolversParentTypes['TeamCreatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TeamRemovePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['TeamRemovePayload'] = ResolversParentTypes['TeamRemovePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TeamUpdatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['TeamUpdatePayload'] = ResolversParentTypes['TeamUpdatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Team']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TechnicianCreatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['TechnicianCreatePayload'] = ResolversParentTypes['TechnicianCreatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TechnicianMovePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['TechnicianMovePayload'] = ResolversParentTypes['TechnicianMovePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TechnicianRemovePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['TechnicianRemovePayload'] = ResolversParentTypes['TechnicianRemovePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type TechnicianUpdatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['TechnicianUpdatePayload'] = ResolversParentTypes['TechnicianUpdatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UpdateDeviceInfoPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['UpdateDeviceInfoPayload'] = ResolversParentTypes['UpdateDeviceInfoPayload'],
> = {
  errors?: Resolver<
    Maybe<Array<ResolversTypes['String']>>,
    ParentType,
    ContextType
  >
  result?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['User'] = ResolversParentTypes['User'],
> = {
  account?: Resolver<Maybe<ResolversTypes['Account']>, ParentType, ContextType>
  accountUsers?: Resolver<
    Maybe<ResolversTypes['UserWithPagination']>,
    ParentType,
    ContextType,
    RequireFields<UserAccountUsersArgs, 'accountId'>
  >
  accounts?: Resolver<
    Maybe<ResolversTypes['AccountWithPagination']>,
    ParentType,
    ContextType,
    Partial<UserAccountsArgs>
  >
  availableAccounts?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Account']>>>,
    ParentType,
    ContextType
  >
  avatar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  binCount?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  bins?: Resolver<
    Maybe<Array<ResolversTypes['Location']>>,
    ParentType,
    ContextType
  >
  branches?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Branch']>>>,
    ParentType,
    ContextType,
    Partial<UserBranchesArgs>
  >
  checkoutManager?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  checkoutUsers?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['User']>>>,
    ParentType,
    ContextType,
    RequireFields<UserCheckoutUsersArgs, 'branchId'>
  >
  checkouts?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Checkout']>>>,
    ParentType,
    ContextType,
    Partial<UserCheckoutsArgs>
  >
  clonedUsers?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['User']>>>,
    ParentType,
    ContextType
  >
  createdAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  currentSignInAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  defaultBin?: Resolver<
    Maybe<ResolversTypes['Location']>,
    ParentType,
    ContextType
  >
  divisions?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Division']>>>,
    ParentType,
    ContextType
  >
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  emailInboundInventoryApproval?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >
  emailLocationInventory?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >
  emailLowStockWarning?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >
  emailOrderApprovalRequest?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >
  emailReplenishmentPlanReminder?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >
  enableReports?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  generalManager?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  impersonating?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  inboundInventoryFind?: Resolver<
    Maybe<ResolversTypes['InboundInventory']>,
    ParentType,
    ContextType,
    RequireFields<UserInboundInventoryFindArgs, 'id'>
  >
  internals?: Resolver<
    Maybe<ResolversTypes['UserWithPagination']>,
    ParentType,
    ContextType,
    Partial<UserInternalsArgs>
  >
  inventoryProducts?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['InventoryProduct']>>>,
    ParentType,
    ContextType,
    RequireFields<UserInventoryProductsArgs, 'branchId'>
  >
  isAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  isMovable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  isRemovable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  lastSignInAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  location?: Resolver<
    Maybe<ResolversTypes['Location']>,
    ParentType,
    ContextType
  >
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  navInvoiceBranches?: Resolver<
    Maybe<Array<ResolversTypes['Branch']>>,
    ParentType,
    ContextType,
    RequireFields<UserNavInvoiceBranchesArgs, 'navInvoiceId'>
  >
  navInvoiceCounts?: Resolver<
    Maybe<ResolversTypes['NavInvoiceCounts']>,
    ParentType,
    ContextType
  >
  navInvoices?: Resolver<
    Maybe<ResolversTypes['NavInvoiceWithPagination']>,
    ParentType,
    ContextType,
    Partial<UserNavInvoicesArgs>
  >
  orderFilter?: Resolver<
    Maybe<ResolversTypes['OrderWithPagination']>,
    ParentType,
    ContextType,
    Partial<UserOrderFilterArgs>
  >
  orderFind?: Resolver<
    Maybe<ResolversTypes['OrderDetailed']>,
    ParentType,
    ContextType,
    RequireFields<UserOrderFindArgs, 'id'>
  >
  orders?: Resolver<
    Maybe<Array<ResolversTypes['Order']>>,
    ParentType,
    ContextType,
    RequireFields<UserOrdersArgs, 'branchId'>
  >
  pendingOrdersStats?: Resolver<
    Maybe<ResolversTypes['OrdersStats']>,
    ParentType,
    ContextType,
    RequireFields<UserPendingOrdersStatsArgs, 'branchId'>
  >
  photo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  resetPasswordSentAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  retrieveAnnualPlan?: Resolver<
    Array<ResolversTypes['Order']>,
    ParentType,
    ContextType,
    RequireFields<UserRetrieveAnnualPlanArgs, 'branchId' | 'year'>
  >
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  sanaPasswordSyncError?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >
  sanaPasswordSyncedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  teams?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Team']>>>,
    ParentType,
    ContextType
  >
  termsAcceptedAt?: Resolver<
    Maybe<ResolversTypes['ISO8601DateTime']>,
    ParentType,
    ContextType
  >
  updatedAt?: Resolver<
    ResolversTypes['ISO8601DateTime'],
    ParentType,
    ContextType
  >
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserAttachAvatarPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['UserAttachAvatarPayload'] = ResolversParentTypes['UserAttachAvatarPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserCreatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['UserCreatePayload'] = ResolversParentTypes['UserCreatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserEdgeResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['UserEdge'] = ResolversParentTypes['UserEdge'],
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>
  node?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserMovePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['UserMovePayload'] = ResolversParentTypes['UserMovePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserReassignAccountPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['UserReassignAccountPayload'] = ResolversParentTypes['UserReassignAccountPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserSetBranchesPayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['UserSetBranchesPayload'] = ResolversParentTypes['UserSetBranchesPayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserUpdatePayloadResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['UserUpdatePayload'] = ResolversParentTypes['UserUpdatePayload'],
> = {
  errors?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>
  result?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type UserWithPaginationResolvers<
  ContextType = any,
  ParentType extends
    ResolversParentTypes['UserWithPagination'] = ResolversParentTypes['UserWithPagination'],
> = {
  edges?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['UserEdge']>>>,
    ParentType,
    ContextType
  >
  nodes?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['User']>>>,
    ParentType,
    ContextType
  >
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>
  totalItems?: Resolver<ResolversTypes['Int'], ParentType, ContextType>
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>
}

export type Resolvers<ContextType = any> = {
  AcceptTermsPayload?: AcceptTermsPayloadResolvers<ContextType>
  Account?: AccountResolvers<ContextType>
  AccountBase?: AccountBaseResolvers<ContextType>
  AccountEdge?: AccountEdgeResolvers<ContextType>
  AccountSyncJob?: AccountSyncJobResolvers<ContextType>
  AccountUpdatePayload?: AccountUpdatePayloadResolvers<ContextType>
  AccountWithPagination?: AccountWithPaginationResolvers<ContextType>
  AccountsProduct?: AccountsProductResolvers<ContextType>
  AddPlanProductPayload?: AddPlanProductPayloadResolvers<ContextType>
  AddPlanProductResult?: AddPlanProductResultResolvers<ContextType>
  AddPlanProductsFromInventoryPayload?: AddPlanProductsFromInventoryPayloadResolvers<ContextType>
  AssignMultipleAccountsPayload?: AssignMultipleAccountsPayloadResolvers<ContextType>
  Branch?: BranchResolvers<ContextType>
  BranchBinLocationItem?: BranchBinLocationItemResolvers<ContextType>
  BranchCreatePayload?: BranchCreatePayloadResolvers<ContextType>
  BranchDeletePayload?: BranchDeletePayloadResolvers<ContextType>
  BranchUpdatePayload?: BranchUpdatePayloadResolvers<ContextType>
  BranchesProduct?: BranchesProductResolvers<ContextType>
  BranchesSalableProduct?: BranchesSalableProductResolvers<ContextType>
  CartBranchUpdatePayload?: CartBranchUpdatePayloadResolvers<ContextType>
  CartItem?: CartItemResolvers<ContextType>
  CartItemCreatePayload?: CartItemCreatePayloadResolvers<ContextType>
  CartItemUpdatePayload?: CartItemUpdatePayloadResolvers<ContextType>
  Checkout?: CheckoutResolvers<ContextType>
  CheckoutCancelPayload?: CheckoutCancelPayloadResolvers<ContextType>
  CheckoutCompletePayload?: CheckoutCompletePayloadResolvers<ContextType>
  CheckoutCreatePayload?: CheckoutCreatePayloadResolvers<ContextType>
  CheckoutItem?: CheckoutItemResolvers<ContextType>
  CheckoutItemCreatePayload?: CheckoutItemCreatePayloadResolvers<ContextType>
  CheckoutItemDepletion?: CheckoutItemDepletionResolvers<ContextType>
  CheckoutItemRemovePayload?: CheckoutItemRemovePayloadResolvers<ContextType>
  CheckoutItemUpdatePayload?: CheckoutItemUpdatePayloadResolvers<ContextType>
  CheckoutRecallPayload?: CheckoutRecallPayloadResolvers<ContextType>
  CheckoutRemovePayload?: CheckoutRemovePayloadResolvers<ContextType>
  CheckoutReopenPayload?: CheckoutReopenPayloadResolvers<ContextType>
  CheckoutSubmitPayload?: CheckoutSubmitPayloadResolvers<ContextType>
  CycleCount?: CycleCountResolvers<ContextType>
  CycleCountCreatePayload?: CycleCountCreatePayloadResolvers<ContextType>
  CycleCountItem?: CycleCountItemResolvers<ContextType>
  CycleCountItemsUpdatePayload?: CycleCountItemsUpdatePayloadResolvers<ContextType>
  CycleCountRecountPayload?: CycleCountRecountPayloadResolvers<ContextType>
  CycleCountUpdatePayload?: CycleCountUpdatePayloadResolvers<ContextType>
  Decimal?: GraphQLScalarType
  DestinationTransfer?: DestinationTransferResolvers<ContextType>
  Division?: DivisionResolvers<ContextType>
  DivisionCreatePayload?: DivisionCreatePayloadResolvers<ContextType>
  DivisionRemovePayload?: DivisionRemovePayloadResolvers<ContextType>
  DivisionUpdatePayload?: DivisionUpdatePayloadResolvers<ContextType>
  DivisionsProduct?: DivisionsProductResolvers<ContextType>
  EnsureBranchPayload?: EnsureBranchPayloadResolvers<ContextType>
  Forecast?: ForecastResolvers<ContextType>
  GenerateAppLoginTokenPayload?: GenerateAppLoginTokenPayloadResolvers<ContextType>
  GenericProduct?: GenericProductResolvers<ContextType>
  ISO8601Date?: GraphQLScalarType
  ISO8601DateOnly?: GraphQLScalarType
  ISO8601DateTime?: GraphQLScalarType
  ImpersonateUserPayload?: ImpersonateUserPayloadResolvers<ContextType>
  InboundInventory?: InboundInventoryResolvers<ContextType>
  InboundInventoryApprovePayload?: InboundInventoryApprovePayloadResolvers<ContextType>
  InventoryEvent?: InventoryEventResolvers<ContextType>
  InventoryEventEdge?: InventoryEventEdgeResolvers<ContextType>
  InventoryEventWithPagination?: InventoryEventWithPaginationResolvers<ContextType>
  InventoryProduct?: InventoryProductResolvers<ContextType>
  InventoryProductCreatePayload?: InventoryProductCreatePayloadResolvers<ContextType>
  InventoryProductRemovePayload?: InventoryProductRemovePayloadResolvers<ContextType>
  InventoryProductTransferPayload?: InventoryProductTransferPayloadResolvers<ContextType>
  InventoryProductUpdatePayload?: InventoryProductUpdatePayloadResolvers<ContextType>
  JSON?: GraphQLScalarType
  LoadAccountsCsvPayload?: LoadAccountsCsvPayloadResolvers<ContextType>
  LoadBranchesCsvPayload?: LoadBranchesCsvPayloadResolvers<ContextType>
  LoadDivisionProductsCsvPayload?: LoadDivisionProductsCsvPayloadResolvers<ContextType>
  LoadLocationsCsvPayload?: LoadLocationsCsvPayloadResolvers<ContextType>
  LoadShipmentsCsvPayload?: LoadShipmentsCsvPayloadResolvers<ContextType>
  LoadUsersCsvPayload?: LoadUsersCsvPayloadResolvers<ContextType>
  Location?: LocationResolvers<ContextType>
  LocationCreatePayload?: LocationCreatePayloadResolvers<ContextType>
  LocationDeletePayload?: LocationDeletePayloadResolvers<ContextType>
  LocationItem?: LocationItemResolvers<ContextType>
  LocationItemCreatePayload?: LocationItemCreatePayloadResolvers<ContextType>
  LocationItemDeletePayload?: LocationItemDeletePayloadResolvers<ContextType>
  LocationItemUpdatePayload?: LocationItemUpdatePayloadResolvers<ContextType>
  LocationUpdatePayload?: LocationUpdatePayloadResolvers<ContextType>
  ManagerUpdatePayload?: ManagerUpdatePayloadResolvers<ContextType>
  Message?: MessageResolvers<ContextType>
  MessageArchivePayload?: MessageArchivePayloadResolvers<ContextType>
  MessageMarkReadPayload?: MessageMarkReadPayloadResolvers<ContextType>
  MessagePublishPayload?: MessagePublishPayloadResolvers<ContextType>
  MessageRead?: MessageReadResolvers<ContextType>
  MessageUpdatePayload?: MessageUpdatePayloadResolvers<ContextType>
  Money?: GraphQLScalarType
  Move?: MoveResolvers<ContextType>
  MoveCreatePayload?: MoveCreatePayloadResolvers<ContextType>
  MoveItem?: MoveItemResolvers<ContextType>
  MoveUpdatePayload?: MoveUpdatePayloadResolvers<ContextType>
  Mutation?: MutationResolvers<ContextType>
  NavInvoice?: NavInvoiceResolvers<ContextType>
  NavInvoiceCounts?: NavInvoiceCountsResolvers<ContextType>
  NavInvoiceEdge?: NavInvoiceEdgeResolvers<ContextType>
  NavInvoiceIgnorePayload?: NavInvoiceIgnorePayloadResolvers<ContextType>
  NavInvoiceMapPayload?: NavInvoiceMapPayloadResolvers<ContextType>
  NavInvoiceWithPagination?: NavInvoiceWithPaginationResolvers<ContextType>
  Order?: OrderResolvers<ContextType>
  OrderApprovePayload?: OrderApprovePayloadResolvers<ContextType>
  OrderDetailed?: OrderDetailedResolvers<ContextType>
  OrderEdge?: OrderEdgeResolvers<ContextType>
  OrderItem?: OrderItemResolvers<ContextType>
  OrderItemCreatePayload?: OrderItemCreatePayloadResolvers<ContextType>
  OrderItemUpdatePayload?: OrderItemUpdatePayloadResolvers<ContextType>
  OrderRejectPayload?: OrderRejectPayloadResolvers<ContextType>
  OrderRequestFromCartPayload?: OrderRequestFromCartPayloadResolvers<ContextType>
  OrderRequestPayload?: OrderRequestPayloadResolvers<ContextType>
  OrderRequestTrackingInfoPayload?: OrderRequestTrackingInfoPayloadResolvers<ContextType>
  OrderSubmitFromCartPayload?: OrderSubmitFromCartPayloadResolvers<ContextType>
  OrderSubmitPayload?: OrderSubmitPayloadResolvers<ContextType>
  OrderTrackingStatus?: OrderTrackingStatusResolvers<ContextType>
  OrderUpdatePayload?: OrderUpdatePayloadResolvers<ContextType>
  OrderWithPagination?: OrderWithPaginationResolvers<ContextType>
  OrdersStats?: OrdersStatsResolvers<ContextType>
  PageInfo?: PageInfoResolvers<ContextType>
  PlanItem?: PlanItemResolvers<ContextType>
  Product?: ProductResolvers<ContextType>
  ProductCategory?: ProductCategoryResolvers<ContextType>
  ProductGroup?: ProductGroupResolvers<ContextType>
  ProductTag?: ProductTagResolvers<ContextType>
  ProductTagCreatePayload?: ProductTagCreatePayloadResolvers<ContextType>
  ProductTagDeletePayload?: ProductTagDeletePayloadResolvers<ContextType>
  ProductTagUpdatePayload?: ProductTagUpdatePayloadResolvers<ContextType>
  ProductsUnion?: ProductsUnionResolvers<ContextType>
  Query?: QueryResolvers<ContextType>
  RemoveBranchesSalableProductPayload?: RemoveBranchesSalableProductPayloadResolvers<ContextType>
  RemovePlanProductPayload?: RemovePlanProductPayloadResolvers<ContextType>
  RemovedOrderItem?: RemovedOrderItemResolvers<ContextType>
  ReplenishmentPlanExport?: ReplenishmentPlanExportResolvers<ContextType>
  ReplenishmentPlanItemSpecifyPayload?: ReplenishmentPlanItemSpecifyPayloadResolvers<ContextType>
  ReplenishmentPlanProductReplacePayload?: ReplenishmentPlanProductReplacePayloadResolvers<ContextType>
  SalableProductData?: SalableProductDataResolvers<ContextType>
  SanaPasswordRotatePayload?: SanaPasswordRotatePayloadResolvers<ContextType>
  SanaPasswordSetManualPayload?: SanaPasswordSetManualPayloadResolvers<ContextType>
  ScheduleAccountSyncPayload?: ScheduleAccountSyncPayloadResolvers<ContextType>
  ScheduleBranchSyncPayload?: ScheduleBranchSyncPayloadResolvers<ContextType>
  ScheduleProductsUpdatePayload?: ScheduleProductsUpdatePayloadResolvers<ContextType>
  Shipment?: ShipmentResolvers<ContextType>
  ShippedProduct?: ShippedProductResolvers<ContextType>
  Species?: SpeciesResolvers<ContextType>
  SpeciesSetGroupPayload?: SpeciesSetGroupPayloadResolvers<ContextType>
  SubmittedItem?: SubmittedItemResolvers<ContextType>
  Team?: TeamResolvers<ContextType>
  TeamCreatePayload?: TeamCreatePayloadResolvers<ContextType>
  TeamRemovePayload?: TeamRemovePayloadResolvers<ContextType>
  TeamUpdatePayload?: TeamUpdatePayloadResolvers<ContextType>
  TechnicianCreatePayload?: TechnicianCreatePayloadResolvers<ContextType>
  TechnicianMovePayload?: TechnicianMovePayloadResolvers<ContextType>
  TechnicianRemovePayload?: TechnicianRemovePayloadResolvers<ContextType>
  TechnicianUpdatePayload?: TechnicianUpdatePayloadResolvers<ContextType>
  UpdateDeviceInfoPayload?: UpdateDeviceInfoPayloadResolvers<ContextType>
  User?: UserResolvers<ContextType>
  UserAttachAvatarPayload?: UserAttachAvatarPayloadResolvers<ContextType>
  UserCreatePayload?: UserCreatePayloadResolvers<ContextType>
  UserEdge?: UserEdgeResolvers<ContextType>
  UserMovePayload?: UserMovePayloadResolvers<ContextType>
  UserReassignAccountPayload?: UserReassignAccountPayloadResolvers<ContextType>
  UserSetBranchesPayload?: UserSetBranchesPayloadResolvers<ContextType>
  UserUpdatePayload?: UserUpdatePayloadResolvers<ContextType>
  UserWithPagination?: UserWithPaginationResolvers<ContextType>
}

export type PlanForecastFragment = {
  productId: number
  amountMaxSuggested: number
  amountMinSuggested: number
  amountSuggested: number
  month: number
  year: number
}

export type PlanItemFragment = {
  productId: number
  amount?: number | null
  month: number
  year: number
}

export type PlanProductFragment = {
  id: number
  name: string
  price?: any | null
  code: string
  photo?: string | null
  unit?: string | null
  caseQuantity?: number | null
  palletQuantity?: number | null
  erpCatalogName: string
  unavailable?: boolean | null
  speciesIds: Array<number>
  category?: ProductCategoryFragment | null
  group?: ProductGroupFragment | null
}

export type ProductCategoryFragment = { id: number; name: string; code: string }

export type ProductGroupFragment = { id: number; name: string; code: string }

export type PlanShipmentFragment = {
  productId: number
  amount: number
  date?: any | null
  product?: { price?: any | null } | null
}

export type ReplenishmentPlanItemFragment = {
  salableProductId: number
  product: PlanProductFragment
}

export type AddProductToPlanMutationVariables = Exact<{
  branchId: Scalars['Int']['input']
  productId: Scalars['Int']['input']
}>

export type AddProductToPlanMutation = {
  addPlanProduct?: {
    errors?: any | null
    result?: { salableProductId: number } | null
  } | null
}

export type AddProductsFromInventoryMutationVariables = Exact<{
  branchId: Scalars['Int']['input']
  productIds: Array<Scalars['Int']['input']> | Scalars['Int']['input']
}>

export type AddProductsFromInventoryMutation = {
  addPlanProductsFromInventory?: {
    errors?: any | null
    result?: Array<{ id: number } | null> | null
  } | null
}

export type RemoveBranchesSalableProductMutationVariables = Exact<{
  branchId: Scalars['Int']['input']
  salableProductId: Scalars['Int']['input']
  productId: Scalars['Int']['input']
}>

export type RemoveBranchesSalableProductMutation = {
  removeBranchesSalableProduct?: {
    errors?: any | null
    result?: { id: number } | null
  } | null
}

export type RemoveProductFromPlanMutationVariables = Exact<{
  branchId: Scalars['Int']['input']
  productId: Scalars['Int']['input']
}>

export type RemoveProductFromPlanMutation = {
  removePlanProduct?: {
    errors?: any | null
    result?: Array<{ id: number } | null> | null
  } | null
}

export type ReplaceProductInPlanMutationVariables = Exact<{
  branchId: Scalars['Int']['input']
  oldProductId: Scalars['Int']['input']
  newProductId: Scalars['Int']['input']
}>

export type ReplaceProductInPlanMutation = {
  replenishmentPlanProductReplace?: {
    errors?: any | null
    result?: ReplenishmentPlanItemFragment | null
  } | null
}

export type SpecifyProductPlanMutationVariables = Exact<{
  amount: Scalars['Int']['input']
  branchId: Scalars['Int']['input']
  month: Scalars['String']['input']
  productId: Scalars['Int']['input']
}>

export type SpecifyProductPlanMutation = {
  replenishmentPlanItemSpecify?: {
    errors?: any | null
    result?: PlanItemFragment | null
  } | null
}

export type GetForecastsQueryVariables = Exact<{
  branchId: Scalars['Int']['input']
  fromMonth: Scalars['String']['input']
  toMonth: Scalars['String']['input']
  productIds?: InputMaybe<
    Array<Scalars['Int']['input']> | Scalars['Int']['input']
  >
}>

export type GetForecastsQuery = { forecasts: Array<PlanForecastFragment> }

export type GetInternalAccountAndBranchQueryVariables = Exact<{
  accountId: Scalars['Int']['input']
  branchId: Scalars['Int']['input']
}>

export type GetInternalAccountAndBranchQuery = {
  internal?: {
    accounts?: {
      nodes?: Array<{
        name: string
        erpCatalogs: Array<string>
        branches?: Array<{ name: string }> | null
      } | null> | null
    } | null
  } | null
}

export type GetInventoryProductsForImportQueryVariables = Exact<{
  branchId: Scalars['Int']['input']
  accountId: Scalars['Int']['input']
  divisionId?: InputMaybe<Scalars['Int']['input']>
  term?: InputMaybe<Scalars['String']['input']>
  excludePlanned?: InputMaybe<Scalars['Boolean']['input']>
  excludeCustom?: InputMaybe<Scalars['Boolean']['input']>
}>

export type GetInventoryProductsForImportQuery = {
  internal?: {
    accounts?: {
      nodes?: Array<{
        divisions?: Array<{ id: number; name: string }> | null
        branches?: Array<{
          inventoryProducts?: Array<{
            id: number
            price?: any | null
            unit?: string | null
            product: {
              code: string
              name: string
              photo?: string | null
              erpCatalogName: string
            }
          } | null> | null
        }> | null
      } | null> | null
    } | null
  } | null
  manager?: {
    account?: { divisions?: Array<{ id: number; name: string }> | null } | null
    branches?: Array<{
      inventoryProducts?: Array<{
        id: number
        price?: any | null
        unit?: string | null
        product: {
          code: string
          name: string
          photo?: string | null
          erpCatalogName: string
        }
      } | null> | null
    } | null> | null
  } | null
}

export type GetMeQueryVariables = Exact<{ [key: string]: never }>

export type GetMeQuery = {
  me?: {
    id: number
    name: string
    email: string
    avatar?: string | null
    role: string
    account?: { erpCatalogs: Array<string> } | null
  } | null
}

export type GetPlanItemsQueryVariables = Exact<{
  branchId: Scalars['Int']['input']
  fromMonth: Scalars['String']['input']
  toMonth: Scalars['String']['input']
  productIds?: InputMaybe<
    Array<Scalars['Int']['input']> | Scalars['Int']['input']
  >
}>

export type GetPlanItemsQuery = { planItems: Array<PlanItemFragment> }

export type GetPlanQueryVariables = Exact<{
  branchId: Scalars['Int']['input']
}>

export type GetPlanQuery = {
  replenishmentPlan?: Array<ReplenishmentPlanItemFragment> | null
  planSpecies: Array<{ sanaId: number; name: string; group?: string | null }>
}

export type GetPlannerAccountAndBranchesQueryVariables = Exact<{
  [key: string]: never
}>

export type GetPlannerAccountAndBranchesQuery = {
  planner?: {
    account?: { id: number; name: string } | null
    branches?: Array<{ id: number; name: string } | null> | null
  } | null
}

export type GetShipmentsQueryVariables = Exact<{
  branchId: Scalars['Int']['input']
  fromMonth: Scalars['String']['input']
  toMonth: Scalars['String']['input']
  productIds?: InputMaybe<
    Array<Scalars['Int']['input']> | Scalars['Int']['input']
  >
}>

export type GetShipmentsQuery = { shipments: Array<PlanShipmentFragment> }

export type GetSubmittedItemsQueryVariables = Exact<{
  branchId: Scalars['Int']['input']
  fromMonth: Scalars['String']['input']
  toMonth: Scalars['String']['input']
  productIds?: InputMaybe<
    Array<Scalars['Int']['input']> | Scalars['Int']['input']
  >
}>

export type GetSubmittedItemsQuery = {
  submittedItems: Array<PlanSubmittedItemFragment>
}

export type PlanSubmittedItemFragment = {
  productId: number
  month: string
  amount: number
}

export type ReplenishmentPlanExportsQueryVariables = Exact<{
  from: Scalars['ISO8601DateTime']['input']
  to: Scalars['ISO8601DateTime']['input']
}>

export type ReplenishmentPlanExportsQuery = {
  replenishmentPlanExports?: Array<{
    id: number
    file: string
    createdAt: any
  }> | null
}

export type SearchProductsQueryVariables = Exact<{
  branchId: Scalars['Int']['input']
  term: Scalars['String']['input']
  categoryCode?: InputMaybe<Scalars['String']['input']>
  includePlanUnavailable?: InputMaybe<Scalars['Boolean']['input']>
}>

export type SearchProductsQuery = {
  productsOrderable?: Array<ProductOrderableFragment | null> | null
}

export type ProductOrderableFragment = {
  id: number
  name: string
  price?: any | null
  code: string
  photo?: string | null
  unit?: string | null
  caseQuantity?: number | null
  palletQuantity?: number | null
  erpCatalogName: string
  speciesIds: Array<number>
  unavailable?: boolean | null
  category?: ProductCategoryFragment | null
  group?: ProductGroupFragment | null
}

export const PlanForecastFragmentDoc = `
    fragment PlanForecastFragment on Forecast {
  productId
  amountMaxSuggested
  amountMinSuggested
  amountSuggested
  month
  year
}
    `
export const PlanItemFragmentDoc = `
    fragment PlanItemFragment on PlanItem {
  productId
  amount
  month
  year
}
    `
export const PlanShipmentFragmentDoc = `
    fragment PlanShipmentFragment on Shipment {
  productId
  amount
  date
  product {
    price
  }
}
    `
export const ProductCategoryFragmentDoc = `
    fragment ProductCategoryFragment on ProductCategory {
  id
  name
  code
}
    `
export const ProductGroupFragmentDoc = `
    fragment ProductGroupFragment on ProductGroup {
  id
  name
  code
}
    `
export const PlanProductFragmentDoc = `
    fragment PlanProductFragment on Product {
  id
  category {
    ...ProductCategoryFragment
  }
  group {
    ...ProductGroupFragment
  }
  name
  price
  code
  photo
  unit
  caseQuantity
  palletQuantity
  erpCatalogName
  unavailable
  speciesIds
}
    ${ProductCategoryFragmentDoc}
${ProductGroupFragmentDoc}`
export const ReplenishmentPlanItemFragmentDoc = `
    fragment ReplenishmentPlanItemFragment on BranchesSalableProduct {
  salableProductId
  product {
    ...PlanProductFragment
  }
}
    ${PlanProductFragmentDoc}`
export const PlanSubmittedItemFragmentDoc = `
    fragment PlanSubmittedItemFragment on SubmittedItem {
  productId
  month
  amount
}
    `
export const ProductOrderableFragmentDoc = `
    fragment ProductOrderableFragment on AccountsProduct {
  id
  category {
    ...ProductCategoryFragment
  }
  group {
    ...ProductGroupFragment
  }
  name
  price
  code
  photo
  unit
  caseQuantity
  palletQuantity
  erpCatalogName
  speciesIds
  unavailable
}
    ${ProductCategoryFragmentDoc}
${ProductGroupFragmentDoc}`
export const AddProductToPlanDocument = `
    mutation AddProductToPlan($branchId: Int!, $productId: Int!) {
  addPlanProduct(branchId: $branchId, productId: $productId) {
    errors
    result {
      salableProductId
    }
  }
}
    `
export const AddProductsFromInventoryDocument = `
    mutation AddProductsFromInventory($branchId: Int!, $productIds: [Int!]!) {
  addPlanProductsFromInventory(branchId: $branchId, productIds: $productIds) {
    errors
    result {
      id
    }
  }
}
    `
export const RemoveBranchesSalableProductDocument = `
    mutation RemoveBranchesSalableProduct($branchId: Int!, $salableProductId: Int!, $productId: Int!) {
  removeBranchesSalableProduct(
    branchId: $branchId
    salableProductId: $salableProductId
    productId: $productId
  ) {
    errors
    result {
      id
    }
  }
}
    `
export const RemoveProductFromPlanDocument = `
    mutation RemoveProductFromPlan($branchId: Int!, $productId: Int!) {
  removePlanProduct(branchId: $branchId, productId: $productId) {
    errors
    result {
      id
    }
  }
}
    `
export const ReplaceProductInPlanDocument = `
    mutation ReplaceProductInPlan($branchId: Int!, $oldProductId: Int!, $newProductId: Int!) {
  replenishmentPlanProductReplace(
    branchId: $branchId
    oldProductId: $oldProductId
    newProductId: $newProductId
  ) {
    errors
    result {
      ...ReplenishmentPlanItemFragment
    }
  }
}
    ${ReplenishmentPlanItemFragmentDoc}`
export const SpecifyProductPlanDocument = `
    mutation SpecifyProductPlan($amount: Int!, $branchId: Int!, $month: String!, $productId: Int!) {
  replenishmentPlanItemSpecify(
    amount: $amount
    branchId: $branchId
    month: $month
    productId: $productId
  ) {
    errors
    result {
      ...PlanItemFragment
    }
  }
}
    ${PlanItemFragmentDoc}`
export const GetForecastsDocument = `
    query GetForecasts($branchId: Int!, $fromMonth: String!, $toMonth: String!, $productIds: [Int!]) {
  forecasts(
    branchId: $branchId
    fromMonth: $fromMonth
    toMonth: $toMonth
    productIds: $productIds
  ) {
    ...PlanForecastFragment
  }
}
    ${PlanForecastFragmentDoc}`
export const GetInternalAccountAndBranchDocument = `
    query GetInternalAccountAndBranch($accountId: Int!, $branchId: Int!) {
  internal {
    accounts(id: $accountId) {
      nodes {
        name
        erpCatalogs
        branches(id: $branchId) {
          name
        }
      }
    }
  }
}
    `
export const GetInventoryProductsForImportDocument = `
    query GetInventoryProductsForImport($branchId: Int!, $accountId: Int!, $divisionId: Int, $term: String, $excludePlanned: Boolean, $excludeCustom: Boolean) {
  internal {
    accounts(id: $accountId) {
      nodes {
        divisions {
          id
          name
        }
        branches(id: $branchId) {
          inventoryProducts(
            divisionId: $divisionId
            term: $term
            excludePlanned: $excludePlanned
            excludeCustom: $excludeCustom
          ) {
            id
            price
            unit
            product {
              code
              name
              photo
              erpCatalogName
            }
          }
        }
      }
    }
  }
  manager {
    account {
      divisions {
        id
        name
      }
    }
    branches(id: $branchId) {
      inventoryProducts(
        divisionId: $divisionId
        term: $term
        excludePlanned: $excludePlanned
        excludeCustom: $excludeCustom
      ) {
        id
        price
        unit
        product {
          code
          name
          photo
          erpCatalogName
        }
      }
    }
  }
}
    `
export const GetMeDocument = `
    query GetMe {
  me {
    id
    name
    email
    avatar
    role
    account {
      erpCatalogs
    }
  }
}
    `
export const GetPlanItemsDocument = `
    query GetPlanItems($branchId: Int!, $fromMonth: String!, $toMonth: String!, $productIds: [Int!]) {
  planItems(
    branchId: $branchId
    fromMonth: $fromMonth
    toMonth: $toMonth
    productIds: $productIds
  ) {
    ...PlanItemFragment
  }
}
    ${PlanItemFragmentDoc}`
export const GetPlanDocument = `
    query GetPlan($branchId: Int!) {
  replenishmentPlan(branchId: $branchId) {
    ...ReplenishmentPlanItemFragment
  }
  planSpecies {
    sanaId
    name
    group
  }
}
    ${ReplenishmentPlanItemFragmentDoc}`
export const GetPlannerAccountAndBranchesDocument = `
    query GetPlannerAccountAndBranches {
  planner {
    account {
      id
      name
    }
    branches {
      id
      name
    }
  }
}
    `
export const GetShipmentsDocument = `
    query GetShipments($branchId: Int!, $fromMonth: String!, $toMonth: String!, $productIds: [Int!]) {
  shipments(
    branchId: $branchId
    fromMonth: $fromMonth
    toMonth: $toMonth
    productIds: $productIds
  ) {
    ...PlanShipmentFragment
  }
}
    ${PlanShipmentFragmentDoc}`
export const GetSubmittedItemsDocument = `
    query GetSubmittedItems($branchId: Int!, $fromMonth: String!, $toMonth: String!, $productIds: [Int!]) {
  submittedItems(
    branchId: $branchId
    fromMonth: $fromMonth
    toMonth: $toMonth
    productIds: $productIds
  ) {
    ...PlanSubmittedItemFragment
  }
}
    ${PlanSubmittedItemFragmentDoc}`
export const ReplenishmentPlanExportsDocument = `
    query ReplenishmentPlanExports($from: ISO8601DateTime!, $to: ISO8601DateTime!) {
  replenishmentPlanExports(from: $from, to: $to) {
    id
    file
    createdAt
  }
}
    `
export const SearchProductsDocument = `
    query SearchProducts($branchId: Int!, $term: String!, $categoryCode: String, $includePlanUnavailable: Boolean) {
  productsOrderable(
    branchId: $branchId
    term: $term
    categoryCode: $categoryCode
    includePlanUnavailable: $includePlanUnavailable
  ) {
    ...ProductOrderableFragment
  }
}
    ${ProductOrderableFragmentDoc}`

const injectedRtkApi = baseGraphqlApi.injectEndpoints({
  endpoints: (build) => ({
    AddProductToPlan: build.mutation<
      AddProductToPlanMutation,
      AddProductToPlanMutationVariables
    >({
      query: (variables) => ({ document: AddProductToPlanDocument, variables }),
    }),
    AddProductsFromInventory: build.mutation<
      AddProductsFromInventoryMutation,
      AddProductsFromInventoryMutationVariables
    >({
      query: (variables) => ({
        document: AddProductsFromInventoryDocument,
        variables,
      }),
    }),
    RemoveBranchesSalableProduct: build.mutation<
      RemoveBranchesSalableProductMutation,
      RemoveBranchesSalableProductMutationVariables
    >({
      query: (variables) => ({
        document: RemoveBranchesSalableProductDocument,
        variables,
      }),
    }),
    RemoveProductFromPlan: build.mutation<
      RemoveProductFromPlanMutation,
      RemoveProductFromPlanMutationVariables
    >({
      query: (variables) => ({
        document: RemoveProductFromPlanDocument,
        variables,
      }),
    }),
    ReplaceProductInPlan: build.mutation<
      ReplaceProductInPlanMutation,
      ReplaceProductInPlanMutationVariables
    >({
      query: (variables) => ({
        document: ReplaceProductInPlanDocument,
        variables,
      }),
    }),
    SpecifyProductPlan: build.mutation<
      SpecifyProductPlanMutation,
      SpecifyProductPlanMutationVariables
    >({
      query: (variables) => ({
        document: SpecifyProductPlanDocument,
        variables,
      }),
    }),
    GetForecasts: build.query<GetForecastsQuery, GetForecastsQueryVariables>({
      query: (variables) => ({ document: GetForecastsDocument, variables }),
    }),
    GetInternalAccountAndBranch: build.query<
      GetInternalAccountAndBranchQuery,
      GetInternalAccountAndBranchQueryVariables
    >({
      query: (variables) => ({
        document: GetInternalAccountAndBranchDocument,
        variables,
      }),
    }),
    GetInventoryProductsForImport: build.query<
      GetInventoryProductsForImportQuery,
      GetInventoryProductsForImportQueryVariables
    >({
      query: (variables) => ({
        document: GetInventoryProductsForImportDocument,
        variables,
      }),
    }),
    GetMe: build.query<GetMeQuery, GetMeQueryVariables | void>({
      query: (variables) => ({ document: GetMeDocument, variables }),
    }),
    GetPlanItems: build.query<GetPlanItemsQuery, GetPlanItemsQueryVariables>({
      query: (variables) => ({ document: GetPlanItemsDocument, variables }),
    }),
    GetPlan: build.query<GetPlanQuery, GetPlanQueryVariables>({
      query: (variables) => ({ document: GetPlanDocument, variables }),
    }),
    GetPlannerAccountAndBranches: build.query<
      GetPlannerAccountAndBranchesQuery,
      GetPlannerAccountAndBranchesQueryVariables | void
    >({
      query: (variables) => ({
        document: GetPlannerAccountAndBranchesDocument,
        variables,
      }),
    }),
    GetShipments: build.query<GetShipmentsQuery, GetShipmentsQueryVariables>({
      query: (variables) => ({ document: GetShipmentsDocument, variables }),
    }),
    GetSubmittedItems: build.query<
      GetSubmittedItemsQuery,
      GetSubmittedItemsQueryVariables
    >({
      query: (variables) => ({
        document: GetSubmittedItemsDocument,
        variables,
      }),
    }),
    ReplenishmentPlanExports: build.query<
      ReplenishmentPlanExportsQuery,
      ReplenishmentPlanExportsQueryVariables
    >({
      query: (variables) => ({
        document: ReplenishmentPlanExportsDocument,
        variables,
      }),
    }),
    SearchProducts: build.query<
      SearchProductsQuery,
      SearchProductsQueryVariables
    >({
      query: (variables) => ({ document: SearchProductsDocument, variables }),
    }),
  }),
})

export { injectedRtkApi as api }
export const {
  useAddProductToPlanMutation,
  useAddProductsFromInventoryMutation,
  useRemoveBranchesSalableProductMutation,
  useRemoveProductFromPlanMutation,
  useReplaceProductInPlanMutation,
  useSpecifyProductPlanMutation,
  useGetForecastsQuery,
  useLazyGetForecastsQuery,
  useGetInternalAccountAndBranchQuery,
  useLazyGetInternalAccountAndBranchQuery,
  useGetInventoryProductsForImportQuery,
  useLazyGetInventoryProductsForImportQuery,
  useGetMeQuery,
  useLazyGetMeQuery,
  useGetPlanItemsQuery,
  useLazyGetPlanItemsQuery,
  useGetPlanQuery,
  useLazyGetPlanQuery,
  useGetPlannerAccountAndBranchesQuery,
  useLazyGetPlannerAccountAndBranchesQuery,
  useGetShipmentsQuery,
  useLazyGetShipmentsQuery,
  useGetSubmittedItemsQuery,
  useLazyGetSubmittedItemsQuery,
  useReplenishmentPlanExportsQuery,
  useLazyReplenishmentPlanExportsQuery,
  useSearchProductsQuery,
  useLazySearchProductsQuery,
} = injectedRtkApi
